// import {
//   DeleteOutlined,
//   LeftOutlined,
//   LoadingOutlined,
//   MinusCircleOutlined,
//   RightOutlined,
//   SearchOutlined,
// } from "@ant-design/icons";
// import { Button, DatePicker, Input, Select, Spin } from "antd";
// import React, {
//   createRef,
//   useEffect,
//   useRef,
//   useState,
//   useCallback,
// } from "react";
// import { debounce } from "lodash";
// import { useNavigate } from "react-router-dom";
// import products from "../../../../Data/products.json";
// import inventory from "../../../../Data/inventory.json";
// import customers from "../../../../Data/customers.json";
// import BarcodeButton from "../../../../Componets/Buttons/barcode";
// import { select_id, select_search } from "../../../../Controllers/Global";
// import moment from "moment";
// import URL from "../../../../Main/url";
// import {
//   get_all_inventories,
//   get_inventory,
//   get_inventory_barcode,
// } from "../../../../Controllers/Inventory/Batch";
// import toast from "react-hot-toast";
// import dayjs from "dayjs";
// import Modalcomponent from "../../../../Componets/Modal";
// import { create_customer } from "../../../../Controllers/Customers";
// import Loadercomponent from "../../../../Componets/Loader";

// const BillingPos = React.forwardRef((props, submitType) => {
//   const {
//     loader,
//     setLoader,
//     options,
//     setOptions,
//     customer,
//     setCustomer,
//     details,
//     setDetails,
//     totals,
//     setTotals,
//     formdata,
//     buttonLoader,
//   } = props;

//   const [isFocusedProduct, setIsFocusedProduct] = useState(false);
//   const [isFocusedInventory, setIsFocusedInventory] = useState(false);

//   const [posloader, setPosLoader] = useState(false);

//   const [search, setSearch] = useState("");

//   const [inventoryoption, setInventoryOption] = useState();

//   const [open, setOpen] = useState(false);
//   const [modalData, setModalData] = useState();
//   const [selectedModalData, setSelectedModalData] = useState();

//   const [customerName, setCustomerName] = useState();
//   const [customerPhone, setCustomerPhone] = useState();
//   const [customerOptions, setCustomerOptions] = useState([]);

//   const [customerPay, setCustomerPay] = useState();

//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalCount: 0,
//     totalPages: 0,
//   });

//   const handleCustomerPay = (e) => {
//     setCustomerPay(e?.target?.value);
//   };

//   const handleCustomerSearch = async (e) => {
//     const select = {
//       api: "get-all-customers",
//       search: e,
//       status: 1,
//     };

//     const search = await select_search(select);

//     if (search?.status) {
//       let options = [];
//       search?.data?.data?.map((value, index) => {
//         options?.push({
//           value: value?._id,
//           label: (
//             <div>
//               {value?.name}
//               &nbsp;{value?.phone ? "(" + value?.phone + ")" : ""}
//             </div>
//           ),
//         });
//       });

//       setCustomerOptions(options);
//     } else {
//       toast?.error(search?.message);
//     }
//   };

//   const handleCustomer = (e) => {
//     if (e?.target?.name == "name") {
//       setCustomerName(e?.target?.value);
//     } else if (e?.target?.name == "phone") {
//       setCustomerPhone(e?.target?.value);
//     }
//   };

//   const addCustomer = async (e) => {
//   if (!customerPhone) {
//     toast?.error("Phone Required");
//     return;
//   }

//   let params = {
//     name: customerName,
//     phone: customerPhone,
//     status: 1,
//   };

//   const addcustomer = await create_customer(params);

//   if (addcustomer?.status) {
//     toast?.success(addcustomer?.message);

//     // Get the newly created customer object
//     const newCustomer = addcustomer?.data;

//     // Update the dropdown options
//     setCustomerOptions((prevOptions) => [
//       ...prevOptions,
//       {
//         value: newCustomer._id,
//         label: `${newCustomer.name} (${newCustomer.phone || ""})`,
//       },
//     ]);

//     // Select the newly added customer automatically
//     setCustomer(newCustomer._id);

//     // Clear input fields
//     setCustomerName("");
//     setCustomerPhone("");
//   } else {
//     toast?.error(addcustomer?.message);
//   }
// };


//   const handleNext = () => {
//     let currentPage = parseInt(pagination?.currentPage) + 1;

//     if (currentPage <= parseInt(pagination?.totalPages)) {
//       let data = {
//         ...pagination,
//         currentPage: currentPage,
//       };

//       handleSearch(search, data);
//     }
//   };

//   const handlePrevious = () => {
//     let currentPage = parseInt(pagination?.currentPage) - 1;

//     if (currentPage > 0) {
//       let data = {
//         ...pagination,
//         currentPage: currentPage,
//       };

//       handleSearch(search, data);
//     }
//   };

//   const handleSelectSearch = async (e, ind) => {
//     const select = {
//       api: "get-all-inventories",
//       search: e,
//       status: 1,
//     };
//     const search = await select_search(select);

//     if (search?.status) {
//       let options = [];
//       search?.data?.data?.map((value, index) => {
//         options?.push({ value: value?._id, label: value?.product?.name });
//       });

//       setInventoryOption(options);
//     } else {
//       toast?.error(search?.message);
//     }
//   };

//   const latestQueryRef = useRef("");

//   const handleSearch = async (query, page) => {
//     latestQueryRef.current = query;

//     setPosLoader(true);

//     setSearch(query);

//     const select = {
//       api: "get-all-inventories",
//       search: query,
//       status: 1,
//       sort: 2,
//       page: page?.currentPage,
//     };

//     // setPosLoader(true);

//     // setSearch(e);

//     const search = await select_search(select);
//     if (latestQueryRef.current !== query) return; 

//     if (search?.status) {
//       let options = [];
//       options = search?.data?.data;
//       // search?.data?.data?.map((value, index) => {
//       //   options?.push({
//       //     value: value?._id,
//       //     image: value?.product?.image,
//       //     name: value?.product?.name,
//       //     stock: value?.stock,
//       //     number: `#BATCH-${value?.number}`,
//       //     expiry_date: value?.expiry_date
//       //       ? moment?.(value?.expiry_date)?.format("DD-MM-YYYY")
//       //       : "N/A",
//       //     sale_price: value?.sale_price,
//       //     tax: value?.tax,
//       //   });
//       // });

//       setPagination({
//         currentPage: search?.data?.currentPage,
//         totalCount: search?.data?.totalCount,
//         totalPages: search?.data?.totalPages,
//       });

//       setOptions(options);
//       setPosLoader(false);
//     } else {
//       setPosLoader(false);
//       toast?.error(search?.message);
//     }
//   };

//   const handleDescriptionProductBarcode = async (e, page) => {
//     let data = [...details];

//     if (isFocusedProduct) {
//       if (e) {
//         const select = {
//           api: "get-all-inventories",
//           search: e,
//           status: 1,
//           sort: 2,
//           page: page?.currentPage,
//         };

//         setPosLoader(true);

//         setSearch(e);

//         const search = await select_search(select);

//         if (search?.status) {
//           let options = [];
//           options = search?.data?.data;
//           // search?.data?.data?.map((value, index) => {
//           //   options?.push({
//           //     value: value?._id,
//           //     image: value?.product?.image,
//           //     name: value?.product?.name,
//           //     stock: value?.stock,
//           //     number: `#BATCH-${value?.number}`,
//           //     expiry_date: value?.expiry_date
//           //       ? moment?.(value?.expiry_date)?.format("DD-MM-YYYY")
//           //       : "N/A",
//           //     sale_price: value?.sale_price,
//           //     tax: value?.tax,
//           //   });
//           // });

//           setPagination({
//             currentPage: search?.data?.currentPage,
//             totalCount: search?.data?.totalCount,
//             totalPages: search?.data?.totalPages,
//           });

//           // console.log();
//           // handleDescription(options?.[0]?.value, details?.length);
//           handleDescription(options?.[0], details?.length);

//           setOptions(options);
//           setPosLoader(false);
//         } else {
//           setPosLoader(false);
//           toast?.error("Product not found");
//         }
//       }
//     }
//   };

//   const handleDescriptionInventoryBarcode = async (e) => {
//     let data = [...details];

//     if (isFocusedInventory) {
//       let params = {
//         barcode: e,
//       };

//       const inventory = await get_inventory_barcode(params);

//       if (inventory?.status) {
//         if (
//           inventory?.data?.expiry_date &&
//           new Date(new Date(inventory?.data?.expiry_date).getTime()) <
//             new Date()
//         ) {
//           toast?.error(
//             `Inventory expired on ${moment?.(
//               inventory?.data?.expiry_date
//             )?.format("DD-MM-YYYY")}`
//           );
//         } else {
//           if (inventory?.data?.inventory_unit_details?.length > 0) {
//             setOpen(true);

//             let modaldata = [
//               {
//                 ...inventory?.data,
//                 name: inventory?.data?.product?.unit?.name,
//               },
//             ];

//             inventory?.data?.inventory_unit_details?.map((v, i) => {
//               modaldata?.push(v);
//             });

//             setModalData(modaldata);

//             setSelectedModalData({ ...inventory, index: details?.length });
//           } else {
//             if (inventory?.data?.stock > 1) {
//               let description_ids = [];

//               data?.map((v, i) => {
//                 description_ids?.push(v?.description);
//               });

//               if (!description_ids?.includes(inventory?.data?._id)) {
//                 let inventory_description = inventory?.data?._id;
//                 let inventory_name = inventory?.data?.product?.name;
//                 let inventory_batch = inventory?.data?.number;
//                 let inventory_expiry_date = inventory?.data?.expiry_date;
//                 let inventory_unit = inventory?.data?._id;
//                 let inventory_unit_name = inventory?.data?.product?.unit?.name;
//                 let inventory_sale_price = inventory?.data?.sale_price;
//                 let inventory_stock = inventory?.data?.stock;
//                 let inventory_tax = inventory?.data?.tax;

//                 let inventory_unit_details = [];
//                 if (inventory?.data?.inventory_unit_details?.length > 0) {
//                   inventory?.data?.inventory_unit_details?.map(
//                     (value, index) => {
//                       inventory_unit_details?.push({
//                         ...value,
//                         name: value?.name?.name,
//                         price_per_unit: 0,
//                         sale_price: "",
//                         unit_quantity: 0,
//                         unit_delivered: 0,
//                       });
//                     }
//                   );
//                 }

//                 let price_sale = parseFloat(inventory_sale_price || 0);
//                 let price_tax =
//                   parseFloat(price_sale || 0) *
//                   (parseFloat(inventory_tax || 0) / 100);
//                 let price_total =
//                   parseFloat(price_sale || 0) + parseFloat(price_tax || 0);

//                 data?.push({
//                   description: inventory_description,
//                   name: inventory_name,
//                   batch: inventory_batch,
//                   expiry_date: inventory_expiry_date,
//                   unit: inventory_unit,
//                   unit_name: inventory_unit_name,
//                   sale_price: price_sale,
//                   stock: inventory_stock,
//                   tax: inventory_tax,
//                   quantity: 1,
//                   delivered: 1,
//                   tax_amount: price_tax,
//                   total: price_total,
//                 });

//                 let subtotal =
//                   data?.reduce(
//                     (acc, currentValue) =>
//                       parseFloat(acc) + parseFloat(currentValue?.total),
//                     0
//                   ) -
//                   data?.reduce(
//                     (acc, currentValue) =>
//                       parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                     0
//                   );
//                 let taxamount = data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                   0
//                 );
//                 let grandtotal = data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.total),
//                   0
//                 );

//                 totals.subtotal = subtotal;
//                 totals.taxamount = taxamount;
//                 totals.delivery_status = 2;
//                 totals.delivery_date = new Date();
//                 totals.payment_status = 2;
//                 totals.payment_types = ["Cash"];
//                 totals.payments = {
//                   Cash: "",
//                   Cheque: "",
//                   "Debit card": "",
//                   "Credit card": "",
//                   "Bank transfer": "",
//                   "Online payment": "",
//                 };
//                 totals.total = grandtotal;

//                 setDetails(data);
//                 setTotals({ ...totals });
//               } else {
//                 let selected_index = description_ids?.indexOf(
//                   inventory?.data?._id
//                 );

//                 if (
//                   parseFloat(data[selected_index].quantity || 0) <
//                   parseFloat(data[selected_index].stock || 0)
//                 ) {
//                   let quantity = data[selected_index].quantity
//                     ? data[selected_index].quantity
//                     : 0;
//                   let delivered = data[selected_index].delivered
//                     ? data[selected_index].delivered
//                     : 0;

//                   let total_quantity = parseFloat(quantity) + parseFloat(1);

//                   data[selected_index].quantity = total_quantity;
//                   data[selected_index].delivered = total_quantity;

//                   data[selected_index].tax_amount = data[selected_index].tax
//                     ? parseFloat(data[selected_index].sale_price || 0) *
//                       parseFloat(total_quantity || 0) *
//                       (parseFloat(data[selected_index].tax || 0) / 100)
//                     : 0;
//                   data[selected_index].total =
//                     parseFloat(data[selected_index].sale_price || 0) *
//                       parseFloat(total_quantity) +
//                     (data[selected_index].tax
//                       ? parseFloat(data[selected_index].sale_price || 0) *
//                         parseFloat(total_quantity || 0) *
//                         (parseFloat(data[selected_index].tax || 0) / 100)
//                       : 0);

//                   let subtotal =
//                     data?.reduce(
//                       (acc, currentValue) =>
//                         parseFloat(acc) + parseFloat(currentValue?.total),
//                       0
//                     ) -
//                     data?.reduce(
//                       (acc, currentValue) =>
//                         parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                       0
//                     );
//                   let taxamount = data?.reduce(
//                     (acc, currentValue) =>
//                       parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                     0
//                   );
//                   let grandtotal = data?.reduce(
//                     (acc, currentValue) =>
//                       parseFloat(acc) + parseFloat(currentValue?.total),
//                     0
//                   );

//                   totals.subtotal = subtotal;
//                   totals.taxamount = taxamount;
//                   totals.delivery_status = 2;
//                   totals.delivery_date = new Date();
//                   totals.payment_status = 2;
//                   totals.payment_types = ["Cash"];
//                   totals.payments = {
//                     Cash: "",
//                     Cheque: "",
//                     "Debit card": "",
//                     "Credit card": "",
//                     "Bank transfer": "",
//                     "Online payment": "",
//                   };
//                   totals.total = grandtotal;

//                   setDetails(data);
//                   setTotals({ ...totals });
//                 } else {
//                   toast?.error(`Stock only ${data[selected_index].stock}`);
//                 }
//               }
//             } else {
//               toast?.error(`Stock only ${inventory?.data?.stock}`);
//             }
//           }
//         }
//       } else {
//         toast?.error("Inventory not found");
//       }
//     }
//   };

//   const handleModal = (modaldata) => {
//     let data = [...details];

//     let inventory = selectedModalData;
//     let index = selectedModalData?.index;

//     let inventory_description = null;
//     let inventory_name = "";
//     let inventory_batch = "";
//     let inventory_expiry_date = "";
//     let inventory_price_per_unit = "";
//     let inventory_unit = "";
//     let inventory_unit_name = "";
//     let inventory_sale_price = 0;
//     let inventory_stock = 0;
//     let inventory_tax = 0;
//     let inventory_conversion = 0;
//     let inventories_units_details = [];

//     let description_ids = [];

//     data?.map((v, i) => {
//       description_ids?.push(v?.unit);
//     });

//     console.log(inventory, "inventory");

//     if (!description_ids?.includes(modaldata)) {
//       if (inventory?._id == modaldata) {
//         inventory_description = inventory?._id;
//         inventory_name = inventory?.product?.name;
//         inventory_batch = inventory?.number;
//         inventory_expiry_date = inventory?.expiry_date;
//         inventory_price_per_unit = inventory?.price_per_unit;
//         inventory_unit = modaldata;
//         inventory_unit_name = inventory?.product?.unit?.name;
//         inventory_sale_price = inventory?.sale_price;
//         inventory_stock = inventory?.stock;
//         inventory_tax = inventory?.tax;

//         if (inventory?.inventories_units_details?.length > 0) {
//           inventory?.inventories_units_details?.map((value, index) => {
//             inventories_units_details?.push({
//               ...value,
//               name: value?.name,
//               purchase_price: value?.purchase_price,
//               price_per_unit: value?.price_per_unit,
//               sale_price: value?.sale_price,
//               stock: value?.stock,
//               unit_quantity: 0,
//               unit_delivered: 0,
//             });
//           });
//         }
//       } else {
//         let selected_unit = "";
//         let unit_ids = [];

//         if (inventory?.inventories_units_details?.length > 0) {
//           inventory?.inventories_units_details?.map((value, index) => {
//             unit_ids?.push(value?._id);
//           });
//         }

//         if (unit_ids?.includes(modaldata)) {
//           selected_unit =
//             inventory?.inventories_units_details?.[
//               unit_ids?.indexOf(modaldata)
//             ];
//         }

//         inventory_description = inventory?._id;
//         inventory_name = inventory?.product?.name;
//         inventory_batch = inventory?.number;
//         inventory_expiry_date = inventory?.expiry_date;
//         inventory_unit = modaldata;
//         inventory_unit_name = selected_unit?.name;
//         inventory_sale_price = selected_unit?.sale_price;
//         inventory_stock = selected_unit?.stock;
//         inventory_tax = inventory?.tax;
//         inventory_conversion = selected_unit?.conversion;
//       }

//       if (inventory_stock >= 1) {
//         let price_sale = parseFloat(inventory_sale_price || 0);
//         let price_tax =
//           parseFloat(price_sale || 0) * (parseFloat(inventory_tax || 0) / 100);
//         let price_total =
//           parseFloat(price_sale || 0) + parseFloat(price_tax || 0);

//         data?.push({
//           description: inventory_description,
//           name: inventory_name,
//           batch: inventory_batch,
//           expiry_date: inventory_expiry_date,
//           unit: inventory_unit,
//           unit_name: inventory_unit_name,
//           sale_price: price_sale,
//           stock: inventory_stock,
//           tax: inventory_tax,
//           conversion: inventory_conversion,
//           quantity: 1,
//           delivered: 1,
//           tax_amount: price_tax,
//           total: price_total,
//           unit_details_options: inventories_units_details,
//         });

//         let subtotal =
//           data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.total),
//             0
//           ) -
//           data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//             0
//           );
//         let taxamount = data?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//           0
//         );
//         let grandtotal = data?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.total),
//           0
//         );

//         totals.subtotal = subtotal;
//         totals.taxamount = taxamount;
//         totals.delivery_status = 2;
//         totals.delivery_date = new Date();
//         totals.payment_status = 2;
//         totals.payment_types = ["Cash"];
//         totals.payments = {
//           Cash: "",
//           Cheque: "",
//           "Debit card": "",
//           "Credit card": "",
//           "Bank transfer": "",
//           "Online payment": "",
//         };
//         totals.total = grandtotal;

//         setDetails(data);
//         setTotals({ ...totals });
//         setModalData();
//         setSelectedModalData();
//       } else {
//         toast?.error(`Stock only ${inventory_stock}`);
//         setModalData();
//         setSelectedModalData();
//       }
//     } else {
//       let selected_index = description_ids?.indexOf(modaldata);

//       if (
//         parseFloat(data[selected_index].quantity || 0) <
//         parseFloat(Math.floor(data[selected_index].stock) || 0)
//       ) {
//         if (
//           data?.[selected_index]?.conversion > 0 &&
//           data?.[selected_index]?.quantity + parseFloat(1) >=
//             data?.[selected_index]?.conversion
//         ) {
//           toast?.error(
//             `Quantity exceeding ${data?.[selected_index]?.conversion}`
//           );
//         } else {
//           let quantity = data[selected_index].quantity
//             ? data[selected_index].quantity
//             : 0;
//           let delivered = data[selected_index].delivered
//             ? data[selected_index].delivered
//             : 0;

//           let total_quantity = parseFloat(quantity) + parseFloat(1);

//           data[selected_index].quantity = total_quantity;
//           data[selected_index].delivered = total_quantity;

//           data[selected_index].tax_amount = data[selected_index].tax
//             ? parseFloat(data[selected_index].sale_price || 0) *
//               parseFloat(total_quantity || 0) *
//               (parseFloat(data[selected_index].tax || 0) / 100)
//             : 0;
//           data[selected_index].total =
//             parseFloat(data[selected_index].sale_price || 0) *
//               parseFloat(total_quantity) +
//             (data[selected_index].tax
//               ? parseFloat(data[selected_index].sale_price || 0) *
//                 parseFloat(total_quantity || 0) *
//                 (parseFloat(data[selected_index].tax || 0) / 100)
//               : 0);

//           let subtotal =
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.total),
//               0
//             ) -
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//               0
//             );
//           let taxamount = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//             0
//           );
//           let grandtotal = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.total),
//             0
//           );

//           totals.subtotal = subtotal;
//           totals.taxamount = taxamount;
//           totals.delivery_status = 2;
//           totals.delivery_date = new Date();
//           totals.payment_status = 2;
//           totals.payment_types = ["Cash"];
//           totals.payments = {
//             Cash: "",
//             Cheque: "",
//             "Debit card": "",
//             "Credit card": "",
//             "Bank transfer": "",
//             "Online payment": "",
//           };
//           totals.total = grandtotal;

//           setDetails(data);
//           setTotals({ ...totals });
//         }
//       } else {
//         toast?.error(`Stock only ${data[selected_index].stock}`);
//       }
//     }
//   };

//   const handleDescription = async (e, index) => {
//     let data = [...details];

//     console.log(e, "inventory");

//     if (e?._id) {
//       // let params = {
//       //   id: e,
//       // };

//       // const inventory = await get_inventory(params);

//       // if (inventory?.status) {
//       if (
//         e?.expiry_date &&
//         new Date(new Date(e?.expiry_date).getTime()) < new Date()
//       ) {
//         toast?.error(
//           `Inventory expired on ${moment?.(e?.expiry_date)?.format(
//             "DD-MM-YYYY"
//           )}`
//         );
//       } else {
//         if (e?.inventories_units_details?.length > 0) {
//           setOpen(true);

//           let modaldata = [
//             {
//               ...e,
//               name: e?.product?.unit?.name,
//             },
//           ];

//           e?.inventories_units_details?.map((v, i) => {
//             modaldata?.push(v);
//           });

//           setModalData(modaldata);
//           // setSelectedModalData({ ...inventory, index: index });
//           setSelectedModalData({ ...e, index: index });
//         } else {
//           if (e?.stock >= 1) {
//             let description_ids = [];

//             data?.map((v, i) => {
//               description_ids?.push(v?.description);
//             });

//             if (!description_ids?.includes(e?._id)) {
//               let inventory_description = e?._id;
//               let inventory_name = e?.product?.name;
//               let inventory_batch = e?.number;
//               let inventory_expiry_date = e?.expiry_date;
//               let inventory_unit = e?._id;
//               let inventory_unit_name = e?.product?.unit?.name;
//               let inventory_sale_price = e?.sale_price;
//               let inventory_stock = e?.stock;
//               let inventory_tax = e?.tax;
//               let inventories_units_details = [];

//               if (e?.inventories_units_details?.length > 0) {
//                 e?.inventories_units_details?.map((value, index) => {
//                   inventories_units_details?.push({
//                     ...value,
//                     name: value?.name?.name,
//                     price_per_unit: 0,
//                     sale_price: "",
//                     unit_quantity: 0,
//                     unit_delivered: 0,
//                   });
//                 });
//               }

//               let price_sale = parseFloat(inventory_sale_price || 0);
//               let price_tax =
//                 parseFloat(price_sale || 0) *
//                 (parseFloat(inventory_tax || 0) / 100);
//               let price_total =
//                 parseFloat(price_sale || 0) + parseFloat(price_tax || 0);
//               data?.push({
//                 description: inventory_description,
//                 name: inventory_name,
//                 batch: inventory_batch,
//                 expiry_date: inventory_expiry_date,
//                 unit: inventory_unit,
//                 unit_name: inventory_unit_name,
//                 sale_price: price_sale,
//                 stock: inventory_stock,
//                 tax: inventory_tax,
//                 quantity: 1,
//                 delivered: 1,
//                 tax_amount: price_tax,
//                 total: price_total,
//                 unit_details_options: inventories_units_details,
//               });
//               let subtotal =
//                 data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.total),
//                   0
//                 ) -
//                 data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                   0
//                 );
//               let taxamount = data?.reduce(
//                 (acc, currentValue) =>
//                   parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                 0
//               );
//               let grandtotal = data?.reduce(
//                 (acc, currentValue) =>
//                   parseFloat(acc) + parseFloat(currentValue?.total),
//                 0
//               );
//               totals.subtotal = subtotal;
//               totals.taxamount = taxamount;
//               totals.delivery_status = 2;
//               totals.delivery_date = new Date();
//               totals.payment_status = 2;
//               totals.payment_types = ["Cash"];
//               totals.payments = {
//                 Cash: "",
//                 Cheque: "",
//                 "Debit card": "",
//                 "Credit card": "",
//                 "Bank transfer": "",
//                 "Online payment": "",
//               };
//               totals.total = grandtotal;
//               setDetails(data);
//               setTotals({ ...totals });
//             } else {
//               let selected_index = description_ids?.indexOf(e?._id);

//               if (
//                 parseFloat(data[selected_index].quantity || 0) <
//                 parseFloat(data[selected_index].stock || 0)
//               ) {
//                 let quantity = data[selected_index].quantity
//                   ? data[selected_index].quantity
//                   : 0;
//                 let delivered = data[selected_index].delivered
//                   ? data[selected_index].delivered
//                   : 0;
//                 let total_quantity = parseFloat(quantity) + parseFloat(1);

//                 data[selected_index].quantity = total_quantity;
//                 data[selected_index].delivered = total_quantity;
//                 data[selected_index].tax_amount = data[selected_index].tax
//                   ? parseFloat(data[selected_index].sale_price || 0) *
//                     parseFloat(total_quantity || 0) *
//                     (parseFloat(data[selected_index].tax || 0) / 100)
//                   : 0;
//                 data[selected_index].total =
//                   parseFloat(data[selected_index].sale_price || 0) *
//                     parseFloat(total_quantity) +
//                   (data[selected_index].tax
//                     ? parseFloat(data[selected_index].sale_price || 0) *
//                       parseFloat(total_quantity || 0) *
//                       (parseFloat(data[selected_index].tax || 0) / 100)
//                     : 0);
//                 let subtotal =
//                   data?.reduce(
//                     (acc, currentValue) =>
//                       parseFloat(acc) + parseFloat(currentValue?.total),
//                     0
//                   ) -
//                   data?.reduce(
//                     (acc, currentValue) =>
//                       parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                     0
//                   );
//                 let taxamount = data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                   0
//                 );
//                 let grandtotal = data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.total),
//                   0
//                 );
//                 totals.subtotal = subtotal;
//                 totals.taxamount = taxamount;
//                 totals.delivery_status = 2;
//                 totals.delivery_date = new Date();
//                 totals.payment_status = 2;
//                 totals.payment_types = ["Cash"];
//                 totals.payments = {
//                   Cash: "",
//                   Cheque: "",
//                   "Debit card": "",
//                   "Credit card": "",
//                   "Bank transfer": "",
//                   "Online payment": "",
//                 };
//                 totals.total = grandtotal;
//                 setDetails(data);
//                 setTotals({ ...totals });
//               } else {
//                 toast?.error(`Stock only ${data[selected_index].stock}`);
//               }
//             }
//           } else {
//             toast?.error(`Stock only ${e?.stock}`);
//           }
//         }
//       }
//       // } else {
//       //   toast?.error(`Stock only ${e?.stock}`);
//       // }
//     } else {
//       data[index].id = "";
//       data[index].description = null;
//       data[index].name = "";
//       data[index].batch = "";
//       data[index].expiry_date = "";
//       data[index].unit = "";
//       data[index].unit_name = "";
//       data[index].unit_details_options = null;
//       data[index].quantity = "";
//       data[index].conversion = 0;
//       data[index].purchase = "";
//       data[index].sale_price = "";
//       data[index].purchase_options = null;
//       data[index].delivered = "";
//       data[index].tax = 0;
//       data[index].free = "";
//       data[index].barcode = "";
//       data[index].price_per_unit = "";
//       data[index].sale_price = "";
//       data[index].expiry_date = "";
//       data[index].tax_amount = "0.000";
//       data[index].total = 0;
//       setDetails(data);
//     }
//   };

//   const handlePurchase = (e, index, key) => {
//     if (e) {
//       let event = {
//         target: {
//           name: "sale_price",
//           value: JSON?.parse(e)?.sale_price,
//         },
//       };

//       handleTotal(event, index, key);
//       handleTotal(JSON?.parse(e)?.tax, index, "tax");
//     }
//   };

//   const handleDelivered = (e, index) => {
//     console.log(e);
//     if (e?.target?.value >= 0) {
//       let data = [...details];

//       let data_quantity = data[index]?.quantity
//         ? parseFloat(data[index]?.quantity)
//         : 0;
//       let data_delivered = e?.target?.value ? parseFloat(e?.target?.value) : 0;

//       if (data_delivered <= data_quantity) {
//         data[index][e?.target?.name] = e?.target?.value;
//         setDetails(data);
//       } else {
//         toast?.error(`Quantity only ${data_quantity}`);
//       }
//     }
//   };

//   const handleTotal = (e, index, key) => {
//     let name = key ? key : e?.target?.name;
//     let value = key && e ? e : !key && e?.target?.value ? e?.target?.value : "";

//     if (value >= 0) {
//       let data = [...details];

//       if (value <= data[index]?.stock) {
//         let data_sale_price = data[index]?.sale_price
//           ? data[index]?.sale_price
//           : 0;
//         let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
//         let data_deliverd = data[index]?.delivered ? data[index]?.delivered : 0;
//         let data_free = data[index]?.free ? data[index]?.free : 0;
//         let data_tax = data[index]?.tax ? data[index]?.tax : 0;
//         let data_conversion = data[index].conversion
//           ? data[index].conversion
//           : 0;

//         let sale_price = name === "sale_price" ? value : data_sale_price;
//         let quantity = name === "quantity" ? value : data_quantity;
//         let delivered = name === "quantity" ? value : data_deliverd;
//         let free = name === "free" ? value : data_free;
//         let tax = name === "tax" ? value : data_tax;

//         let tax_amount = tax
//           ? parseFloat(sale_price) *
//             parseFloat(quantity ? quantity : 0) *
//             (parseFloat(tax) / 100)
//           : 0;

//         let total =
//           parseFloat(sale_price) * parseFloat(quantity ? quantity : 0) +
//           parseFloat(tax_amount);

//         let price_per_unit =
//           parseFloat(total ? total : 0) /
//           (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

//         let unit_details_options = [];
//         if (data?.[index]?.unit_details_options?.length > 0) {
//           data?.[index]?.unit_details_options?.map((v, i) => {
//             let total_quantity =
//               parseFloat(quantity || 0) + parseFloat(free || 0);

//             unit_details_options?.push({
//               ...v,
//               //price_per_unit
//               price_per_unit: price_per_unit
//                 ? parseFloat(price_per_unit || 0) /
//                   parseFloat(v?.conversion || 0)
//                 : 0,
//               //unit_quantity
//               unit_quantity: quantity
//                 ? parseFloat(v?.conversion || 0) *
//                   parseFloat(total_quantity || 0)
//                 : 0,
//               //unit_deliverd
//               unit_delivered: delivered
//                 ? parseFloat(v?.conversion || 0) *
//                   parseFloat(total_quantity || 0)
//                 : 0,
//             });
//           });
//         }

//         if (
//           data_conversion > 0 &&
//           parseFloat(quantity) + parseFloat(free) >= data_conversion
//         ) {
//           toast?.error(`Quantiy exceeding ${data[index].conversion}`);
//         } else {
//           data[index][name] = value;
//           data[index].unit_details_options = unit_details_options;
//           data[index].delivered = delivered ? delivered : "";
//           data[index].tax = tax ? tax : 0;
//           data[index].total = total ? total : 0;
//           data[index].tax_amount = tax_amount ? tax_amount : "0.000";
//           data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

//           let subtotal =
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.total),
//               0
//             ) -
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//               0
//             );

//           let taxamount = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//             0
//           );

//           let grandtotal = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.total),
//             0
//           );

//           totals.discount = "";
//           totals.delivery = "";
//           totals.subtotal = subtotal;
//           totals.taxamount = taxamount;
//           totals.delivery_status = 2;
//           totals.delivery_date = new Date();
//           totals.payment_status = 2;
//           totals.payment_types = ["Cash"];
//           totals.payments = {
//             Cash: "",
//             Cheque: "",
//             "Debit card": "",
//             "Credit card": "",
//             "Bank transfer": "",
//             "Online payment": "",
//           };
//           totals.total = grandtotal;

//           setDetails(data);
//           setTotals({ ...totals });
//         }
//       } else {
//         toast?.error(`Stock only ${data[index]?.stock}`);
//       }
//     }
//   };

//   const handleRemove = (index) => {
//     let data = [...details];

//     let name = "quantity";
//     let value = 0;

//     if (value <= data[index]?.stock) {
//       let data_sale_price = data[index]?.sale_price
//         ? data[index]?.sale_price
//         : 0;
//       let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
//       let data_deliverd = data[index]?.delivered ? data[index]?.delivered : 0;
//       let data_free = data[index]?.free ? data[index]?.free : 0;
//       let data_tax = data[index]?.tax ? data[index]?.tax : 0;
//       let data_conversion = data[index].conversion ? data[index].conversion : 0;

//       let sale_price = name === "sale_price" ? value : data_sale_price;
//       let quantity = name === "quantity" ? value : data_quantity;
//       let delivered = name === "quantity" ? value : data_deliverd;
//       let free = name === "free" ? value : data_free;
//       let tax = name === "tax" ? value : data_tax;

//       let tax_amount = tax
//         ? parseFloat(sale_price) *
//           parseFloat(quantity ? quantity : 0) *
//           (parseFloat(tax) / 100)
//         : 0;

//       let total =
//         parseFloat(sale_price) * parseFloat(quantity ? quantity : 0) +
//         parseFloat(tax_amount);

//       let price_per_unit =
//         parseFloat(total ? total : 0) /
//         (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

//       let unit_details_options = [];
//       if (data?.[index]?.unit_details_options?.length > 0) {
//         data?.[index]?.unit_details_options?.map((v, i) => {
//           let total_quantity =
//             parseFloat(quantity || 0) + parseFloat(free || 0);

//           unit_details_options?.push({
//             ...v,
//             //price_per_unit
//             price_per_unit: price_per_unit
//               ? parseFloat(price_per_unit || 0) / parseFloat(v?.conversion || 0)
//               : 0,
//             //unit_quantity
//             unit_quantity: quantity
//               ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
//               : 0,
//             //unit_deliverd
//             unit_delivered: delivered
//               ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
//               : 0,
//           });
//         });
//       }

//       if (
//         data_conversion > 0 &&
//         parseFloat(quantity) + parseFloat(free) >= data_conversion
//       ) {
//         toast?.error(`Quantiy exceeding ${data[index].conversion}`);
//       } else {
//         data[index][name] = value;
//         data[index].unit_details_options = unit_details_options;
//         data[index].delivered = delivered ? delivered : "";
//         data[index].tax = tax ? tax : 0;
//         data[index].total = total ? total : 0;
//         data[index].tax_amount = tax_amount ? tax_amount : "0.000";
//         data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

//         let subtotal =
//           data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.total),
//             0
//           ) -
//           data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//             0
//           );

//         let taxamount = data?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//           0
//         );

//         let grandtotal = data?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.total),
//           0
//         );

//         totals.discount = "";
//         totals.delivery = "";
//         totals.subtotal = subtotal;
//         totals.taxamount = taxamount;
//         totals.delivery_status = 2;
//         totals.delivery_date = new Date();
//         totals.payment_status = 2;
//         totals.payment_types = ["Cash"];
//         totals.payments = {
//           Cash: "",
//           Cheque: "",
//           "Debit card": "",
//           "Credit card": "",
//           "Bank transfer": "",
//           "Online payment": "",
//         };
//         totals.total = grandtotal;

//         data?.splice(index, 1);
//         setDetails(data);
//         setTotals({ ...totals });
//       }
//     } else {
//       toast?.error(`Stock only ${data[index]?.stock}`);
//     }
//   };

//   const handleAdd = (e) => {
//     if (e) {
//       setDetails((prevDetails) => [
//         ...prevDetails,
//         {
//           id: "",
//           description: null,
//           unit: "",
//           sale_price: "",
//           quantity: "",
//           delivered: "",
//           free: "",
//           tax: 0,
//           total: 0,
//         },
//       ]);

//       handleDescription(e, details?.length + 1);
//     }
//   };

//   const handleDelivery = (e) => {
//     if (e?.target?.value >= 0) {
//       let total_amount = parseFloat(
//         details?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.total),
//           0
//         )
//       );

//       let total =
//         parseFloat(total_amount ? total_amount : 0) +
//         parseFloat(e?.target?.value ? e?.target?.value : 0) -
//         parseFloat(totals?.discount ? totals?.discount : 0);

//       totals.delivery = e?.target?.value;
//       totals.total = total;

//       setTotals({ ...totals });
//     }
//   };

//   const handleDiscount = (e) => {
//     if (e?.target?.value >= 0) {
//       let total_amount = parseFloat(
//         details?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.total),
//           0
//         )
//       );

//       let total =
//         parseFloat(total_amount ? total_amount : 0) +
//         parseFloat(totals?.delivery ? totals?.delivery : 0) -
//         parseFloat(e?.target?.value ? e?.target?.value : 0);

//       if (e?.target?.value <= total_amount) {
//         totals.discount = e?.target?.value;
//         totals.total = total;
//       } else {
//         toast?.error(`Discount exceeding`);
//       }

//       setTotals({ ...totals });
//     }
//   };

//   const handleDeliveryStatus = (e) => {
//     totals.delivery_status = e;

//     if (!e) {
//       totals.delivery_date = "";
//     } else if (e == 1) {
//       totals.delivery_date = "";
//     }

//     setTotals({ ...totals });
//   };

//   const handleDeliveryDate = (e) => {
//     totals.delivery_date = e?.$d;
//     setTotals({ ...totals });
//   };

//   const handlePaymentStatus = (e) => {
//     totals.payment_status = e;

//     if (!e) {
//       totals.payment_types = null;
//     }
//     setTotals({ ...totals });
//   };

//   const handlePaymentTypes = (e) => {
//     totals?.payment_types?.map((v, i) => {
//       if (!e?.includes(v)) {
//         totals.payments[v] = "";
//       }
//     });

//     totals.payment_types = e;

//     setTotals({ ...totals });
//   };

//   const handlePayments = (e) => {
//     let name = e?.target?.name;
//     let value = e?.target?.value ? e?.target?.value : "";

//     if (e?.target?.value >= 0) {
//       let data_Cash = totals?.payments?.Cash?.amount
//         ? totals?.payments?.Cash?.amount
//         : 0;
//       let data_Cheque = totals?.payments?.Cheque?.amount
//         ? totals?.payments?.Cheque?.amount
//         : 0;
//       let data_Debitcard = totals?.payments?.["Debit card"]?.amount
//         ? totals?.payments?.["Debit card"]?.amount
//         : 0;
//       let data_Creditcard = totals?.payments?.["Credit card"]?.amount
//         ? totals?.payments?.["Credit card"]?.amount
//         : 0;
//       let data_Banktransfer = totals?.payments?.["Bank transfer"]?.amount
//         ? totals?.payments?.["Bank transfer"]?.amount
//         : 0;
//       let data_Onlinepayment = totals?.payments?.["Online payment"]?.amount
//         ? totals?.payments?.["Online payment"]?.amount
//         : 0;

//       let Cash = name === "Cash" ? value : data_Cash;
//       let Cheque = name === "Cheque" ? value : data_Cheque;
//       let Debitcard = name === "Debit card" ? value : data_Debitcard;
//       let Creditcard = name === "Credit card" ? value : data_Creditcard;
//       let Banktransfer = name === "Bank transfer" ? value : data_Banktransfer;
//       let Onlinepayment =
//         name === "Online payment" ? value : data_Onlinepayment;

//       let total =
//         parseFloat(Cash) +
//         parseFloat(Cheque) +
//         parseFloat(Debitcard) +
//         parseFloat(Creditcard) +
//         parseFloat(Banktransfer) +
//         parseFloat(Onlinepayment);

//       let payment_total = total ? parseFloat?.(total || 0)?.toFixed(3) : 0;
//       let grand_total = totals?.total
//         ? parseFloat?.(totals?.total || 0)?.toFixed(3)
//         : 0;

//       if (
//         parseFloat?.(parseFloat(payment_total || 0)?.toFixed(3)) <=
//         parseFloat?.(parseFloat(grand_total || 0)?.toFixed(3))
//       ) {
//         totals.payments[name] = { ...totals.payments[name], amount: value };
//         setTotals({ ...totals });
//       } else {
//         let previous_total =
//           parseFloat(data_Cash) +
//           parseFloat(data_Cheque) +
//           parseFloat(data_Debitcard) +
//           parseFloat(data_Creditcard) +
//           parseFloat(data_Banktransfer) +
//           parseFloat(data_Onlinepayment);

//         let previous_remaining_amount =
//           parseFloat(grand_total) - parseFloat(previous_total);

//         toast?.error(`Total only ${grand_total}`);
//       }
//     }
//   };

//   const handleSubmit = (e) => {
//     e?.preventDefault();

//     const data = {
//       status: true,
//     };

//     formdata(data);
//   };

//   const fetchData = () => {
//     handleSearch("");
//   };

//   const barcodeInputRefProduct = useRef("");
//   const handleKeyDownProduct = (event) => {
//     const ignoredKeys = [
//       "Shift",
//       "Control",
//       "Alt",
//       "Meta",
//       "ArrowUp",
//       "ArrowDown",
//       "ArrowLeft",
//       "ArrowRight",
//       "CapsLock",
//     ];
//     const validKey = /^[a-zA-Z0-9]$/;

//     if (event.key === "Enter") {
//       const barcode = barcodeInputRefProduct.current.trim();

//       if (barcode) {
//         handleDescriptionProductBarcode(barcode);
//       } else {
//         // toast?.error("Empty barcode received");
//       }

//       barcodeInputRefProduct.current = "";
//     } else if (!ignoredKeys.includes(event.key) && validKey.test(event.key)) {
//       barcodeInputRefProduct.current += event.key;
//     } else {
//       // toast?.error(`Ignored key: ${event.key}`);
//     }
//   };

//   const barcodeInputRefIvnentory = useRef("");
//   const handleKeyDownIvnentory = (event) => {
//     const ignoredKeys = [
//       "Shift",
//       "Control",
//       "Alt",
//       "Meta",
//       "ArrowUp",
//       "ArrowDown",
//       "ArrowLeft",
//       "ArrowRight",
//       "CapsLock",
//     ];
//     const validKey = /^[a-zA-Z0-9]$/;

//     if (event.key === "Enter") {
//       const barcode = barcodeInputRefIvnentory.current.trim();

//       if (barcode) {
//         handleDescriptionInventoryBarcode(barcode);
//       } else {
//         // toast?.error("Empty barcode received");
//       }

//       barcodeInputRefIvnentory.current = "";
//     } else if (!ignoredKeys.includes(event.key) && validKey.test(event.key)) {
//       barcodeInputRefIvnentory.current += event.key;
//     } else {
//       // toast?.error(`Ignored key: ${event.key}`);
//     }
//   };

//   const debouncedSearch = useCallback(
//     debounce((query) => handleSearch(query, { currentPage: 1 }), 500),
//     []
//   );

//   const handleInputChange = (e) => {
//     debouncedSearch(e.target.value);
//   };

//   const handleOnKeyDown = (event) => {
//     if (event.key === "Enter") {
//       event.preventDefault();
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const formRef = useRef(null);

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "F4") {
//         e.preventDefault();
//         submitType.current = "print";
//         if (formRef.current) {
//           formRef.current.requestSubmit();
//         }
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, []);

//   return (
//     <div>
//       <Modalcomponent
//         open={open}
//         setOpen={setOpen}
//         modalData={modalData}
//         setModalData={setModalData}
//         selectedModalData={selectedModalData}
//         setSelectedModalData={setSelectedModalData}
//         handleModal={handleModal}
//       />
//       <form ref={formRef} onSubmit={handleSubmit}>
//         <div className="p-4">
//           <div className="flex justify-between">
//             {/* products */}
//             <div className="w-[49%] rounded-md">
//               <div className="p-4 flex justify-between bg-white rounded-tl-md rounded-tr-md">
//                 <div className="w-2/3 pr-8">
//                   {/* <Select
//                     className="w-full text-regular"
//                     name="description"
//                     placeholder="Description"
//                     allowClear={true}
//                     showSearch={true}
//                     filterOption={false}
//                     options={inventoryoption}
//                     onSearch={(e) => handleSelectSearch(e)}
//                     onFocus={(e) => handleSelectSearch("")}
//                     onClick={(e) => handleSelectSearch("")}
//                     onChange={(e) => handleDescription(e)}
//                     autoComplete="off"
//                   /> */}
//                   <div>
//                     <div className="flex">
//                       <div className="pr-3">
//                         <BarcodeButton
//                           name="product"
//                           tabIndex={0}
//                           onKeyDown={handleKeyDownProduct}
//                           isFocusedProduct={isFocusedProduct}
//                           setIsFocusedProduct={setIsFocusedProduct}
//                         />
//                       </div>
//                       <div className="w-full">
//                         <Input
//                           allowClear
//                           // size="large"
//                           className="search"
//                           placeholder="Search"
//                           onChange={handleInputChange}
//                           onKeyDown={handleOnKeyDown}
//                           prefix={
//                             <span className="text-gray-500 text-medium">
//                               <SearchOutlined />
//                             </span>
//                           }
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div>
//                   <BarcodeButton
//                     name="inventory"
//                     onKeyDown={handleKeyDownIvnentory}
//                     isFocusedInventory={isFocusedInventory}
//                     setIsFocusedInventory={setIsFocusedInventory}
//                   />
//                 </div>
//               </div>
//               <div className="bg-white h-[60vh]" style={{ overflowX: "auto" }}>
//                 <Loadercomponent loader={posloader}>
//                   <div className="mx-2">
//                     <div className="grid sm:grid-cols-1 md:grid-cols-2  lg:grid-cols-3  xl:grid-cols-3 2xl:grid-cols-4 grid-cols-5 gap-3">
//                       {options?.map((value, index) => {
//                         return (
//                           <button
//                             type="button"
//                             key={index}
//                             className="border cursor-pointer p-3 hover:bg-gray-100 rounded-lg flex flex-col min-h-[8vw]"
//                             // onClick={() => handleDescription(value?.value)}
//                             onClick={() => handleDescription(value)}
//                           >
//                             <div className="text-center">
//                               {/* <img
//                                 className="rounded-md w-full h-[5vw] object-cover"
//                                 src={
//                                   value?.product?.image
//                                     ? `${URL}/uploads${value?.product?.image}`
//                                     : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6xiTpb6Tyc-CTn4FJmXyNBuPze14R-qIJNIDHj2uQbidXRFY1Otr27ZQd69L5_drFaDY&usqp=CAU"
//                                 }
//                               /> */}
//                             </div>
//                             <div className="text-center pt-2 flex-grow">
//                               <div className="text-[0.70rem] text-medium break-words leading-tight">
//                                 {value?.product?.name}
//                               </div>
//                               <div className="text-[0.50rem] text-gray-500">
//                                 #BATCH-{value?.number}
//                                 <div className="text-xs text-green-500 font-medium">
//                                   Stock&nbsp;(
//                                   {value?.stock
//                                     ? Number.isInteger(value?.stock)
//                                       ? parseFloat?.(value?.stock || 0)
//                                       : parseFloat?.(
//                                           value?.stock || 0
//                                         )?.toFixed?.(3)
//                                     : "0"}
//                                   )
//                                 </div>
//                               </div>
//                               <div className="text-[0.50rem] text-gray-500">
//                                 EXP :&nbsp;
//                                 {value?.expiry_date
//                                   ? moment?.(value?.expiry_date)?.format(
//                                       "DD-MM-YYYY"
//                                     )
//                                   : "N/A"}
//                               </div>
//                             </div>
//                             <div className="text-center text-[0.50rem] text-gray-500">
//                               <div>
//                                 {value?.tax ? "VAT " + value?.tax + "%" : ""}
//                               </div>
//                             </div>
//                             <div className="border text-medium text-xs rounded-md  text-center text-green-500  font-medium mt-auto">
//                               OMR {parseFloat?.(value?.sale_price)?.toFixed(3)}{" "}
//                             </div>
//                           </button>
//                         );
//                       })}
//                     </div>
//                   </div>

//                   {/* <div className="flex flex-wrap">
//                     {options?.map((value, index) => {
//                       return (
//                         <button
//                           type="button"
//                           key={index}
//                           className="cursor-pointer p-3 w-[20%] hover:bg-gray-100 rounded-lg"
//                           onClick={() => handleDescription(value?.value)}
//                         >
//                           <div>
//                             <div className="">
//                               <img
//                                 className="rounded-md w-full h-[100px]"
//                                 src={
//                                   value?.image
//                                     ? `${URL}/uploads${value?.image}`
//                                     : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6xiTpb6Tyc-CTn4FJmXyNBuPze14R-qIJNIDHj2uQbidXRFY1Otr27ZQd69L5_drFaDY&usqp=CAU"
//                                 }
//                               />
//                             </div>
//                             <div className="text-center pt-2">
//                               <div className="text-[0.65vw] text-medium">
//                                 {value?.name}
//                               </div>
//                               <div className="text-[0.65vw] text-gray-500">
//                                 {value?.number}
//                                 <div className="text-[0.65vw] text-medium text-green-500">
//                                   Stock&nbsp;(
//                                   {value?.stock
//                                     ? Number.isInteger(value?.stock)
//                                       ? parseFloat?.(value?.stock || 0)
//                                       : parseFloat?.(
//                                           value?.stock || 0
//                                         )?.toFixed(3)
//                                     : "0"}
//                                   )
//                                 </div>
//                               </div>
//                               <div className="text-xs  text-gray-500">
//                                 {"EXP : " + value?.expiry_date}
//                               </div>
//                             </div>
//                             <div className="text-center text-green-500 text-xs text-medium">
//                               OMR {parseFloat?.(value?.sale_price)?.toFixed(3)}
//                             </div>
//                           </div>
//                         </button>
//                       );
//                     })}
//                   </div> */}
//                 </Loadercomponent>
//               </div>
//               {/* pagination */}
//               <div className="p-4 flex justify-between text-gray-600 text-sm text-medium">
//                 <div>
//                   <span className="pr-3">TOTAL</span>
//                   <span className="pl-5">
//                     {pagination?.currentPage > 1
//                       ? parseInt(pagination?.currentPage || 0) - 1
//                       : 1}
//                     {pagination?.currentPage > 1 ? 1 : ""} -{" "}
//                     {pagination?.currentPage}0 OF {pagination?.totalCount}
//                   </span>
//                 </div>
//                 <div className="flex">
//                   <span>
//                     {/* <button */}
//                     <div
//                       type="button"
//                       className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553]"
//                       onClick={handlePrevious}
//                     >
//                       <div className="text-center text-xs text-gray-900">
//                         <LeftOutlined />
//                       </div>
//                     </div>
//                     {/* </button> */}
//                   </span>
//                   <span className="px-3 pt-1">
//                     {pagination?.currentPage} OUT OF {pagination?.totalPages}
//                   </span>
//                   <span>
//                     {/* <button */}
//                     <div
//                       type="button"
//                       className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553]"
//                       onClick={handleNext}
//                     >
//                       <div className="text-center text-xs text-gray-600">
//                         <RightOutlined />
//                       </div>
//                     </div>
//                     {/* </button> */}
//                   </span>
//                 </div>
//               </div>
//               {/* pagination end */}
//               <div className="p-10 flex justify-between bg-white rounded-bl-md rounded-br-md" />
//             </div>

//             {/* checkout */}
//             <div className="bg-white w-[49%] rounded-md">
//               <div className="p-4 flex justify-center">
//                 <div className="p-1 text-semi-bold">CHECKOUT</div>
//               </div>
//               <div className="h-[35vh]" style={{ overflowY: "auto" }}>
//                 <table className="w-full">
//                   <thead className="bg-gray-100 text-gray-500 text-xs text-medium">
//                     <tr>
//                       <td className=" p-1 border-r ">SNO</td>
//                       <td className=" p-1 border-r">NAME</td>
//                       <td className=" p-1 border-r">UNIT</td>
//                       <td className=" p-1 border-r">QUANTITY</td>
//                       {/* <td className=" p-1 border-r">DELIVERED</td> */}
//                       <td className=" p-1 border-r">PRICE</td>
//                       <td className=" p-1 border-r">TAX</td>
//                       <td className=" p-1 border-r">TOTAL</td>
//                       <td className=" p-1 text-center">DELETE</td>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details?.map((value, index) => {
//                       return (
//                         <tr className="border-b text-xs">
//                           <td className="p-1 border-r">{index + 1}</td>
//                           <td className="p-1 border-r">
//                             <div className="text-[0.70rem] text-medium">
//                               {value?.name}
//                             </div>
//                             <div className="text-[0.50rem] text-gray-500">
//                               <div>{`#BATCH-${value?.batch}`}</div>
//                               <div className="text-[0.50rem]">
//                                 {value?.expiry_date
//                                   ? `EXPIRY : ${moment(
//                                       value?.expiry_date
//                                     )?.format("DD-MM-YYYY")}`
//                                   : ""}
//                               </div>
//                             </div>
//                           </td>
//                           <td className="p-1 border-r text-[0.65rem] text-medium">
//                             {value?.unit_name}
//                           </td>
//                           <td className="p-1 border-r">
//                             <div className="text-green-500 text-[0.60rem] text-medium">
//                               Stock&nbsp;(
//                               {value?.stock
//                                 ? Number.isInteger(value?.stock)
//                                   ? parseFloat?.(value?.stock || 0)
//                                   : parseFloat?.(value?.stock || 0)?.toFixed(3)
//                                 : "0"}
//                               )
//                             </div>
//                             <Input
//                               type="number"
//                               className="text-xs"
//                               name="quantity"
//                               placeholder="Quantity"
//                               value={value?.quantity}
//                               onChange={(e) => handleTotal(e, index)}
//                               onKeyDown={handleOnKeyDown}
//                               autoComplete="off"
//                               required="required"
//                             />
//                           </td>
//                           <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                             {value?.sale_price
//                               ? value?.sale_price?.toFixed?.(3)
//                               : "0.000"}
//                           </td>
//                           <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                             <div>{value?.tax}%</div>
//                             <div>
//                               {value?.tax_amount
//                                 ? value?.tax_amount?.toFixed?.(3)
//                                 : ""}
//                             </div>
//                           </td>
//                           <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                             {value?.total
//                               ? value?.total?.toFixed?.(3)
//                               : "0.000"}
//                           </td>
//                           <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                             <button
//                               type="button"
//                               className="cursor-pointer text-xl text-red-500 hover:text-red-900"
//                               onClick={() => handleRemove(index)}
//                             >
//                               <DeleteOutlined />
//                             </button>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//               <div className="bg-gray-100 text-medium text-gray-500">
//                 <div className="px-4 py-1 flex justify-between text-xs">
//                   <div>Subtotal</div>
//                   <div>
//                     {totals?.subtotal > 0
//                       ? totals?.subtotal?.toFixed(3)
//                       : "0.000"}
//                   </div>
//                 </div>
//                 <div className="px-4 py-1 flex justify-between text-xs">
//                   <div>Tax amount</div>
//                   <div>
//                     {totals?.taxamount > 0
//                       ? totals?.taxamount?.toFixed(3)
//                       : "0.000"}
//                   </div>
//                 </div>
//                 <div className="px-4 pb-2 flex justify-between text-xs">
//                   <div className="my-auto">Discount</div>
//                   <div>
//                     <Input
//                       size="small"
//                       type="number"
//                       className="w-full text-regular"
//                       placeholder="Discount amount"
//                       name="discount"
//                       value={totals?.discount}
//                       autoComplete="off"
//                       onChange={handleDiscount}
//                     />
//                   </div>
//                 </div>
//                 {/* <div className="px-4 pb-2 flex justify-between text-xs">
//                   <div className="my-auto">Delivery</div>
//                   <div>
//                     <Input
//                       size="small"
//                       type="number"
//                       className="w-full text-regular"
//                       placeholder="Delivery charges"
//                       name="delivery"
//                       value={totals?.delivery}
//                       autoComplete="off"
//                       onChange={handleDelivery}
//                     />
//                   </div>
//                 </div> */}
//               </div>
//               <div className="bg-white text-semi-bold">
//                 <div className="px-4 py-1 flex justify-between text-xs">
//                   <div>Total</div>
//                   <div>
//                     {totals?.total > 0 ? totals?.total?.toFixed(3) : "0.000"}
//                   </div>
//                 </div>
//               </div>

//               {/* info */}
//               <div className="p-4 bg-gray-200">
//                 <div>
//                   <div>
//                     <Select
//                       size="small"
//                       className="w-full text-regular"
//                       name="customer"
//                       showSearch
//                       allowClear
//                       placeholder="Select customer"
//                       filterOption={false}
//                       onSearch={(e) => handleCustomerSearch(e)}
//                       onClick={(e) => handleCustomerSearch("")}
//                       onFocus={(e) => handleCustomerSearch("")}
//                       onChange={(e) => setCustomer(e)}
//                       value={customer} 
//                       options={customerOptions}
//                     />
//                   </div>
//                   <div className="flex w-full pt-2">
//                     <div className="w-full">
//                       <Input
//                         size="small"
//                         className="w-full text-regular"
//                         name="name"
//                         value={customerName}
//                         placeholder="New customer name"
//                         onChange={handleCustomer}
//                         autoComplete="off"
//                       />
//                     </div>
//                     <div className="w-full pl-2">
//                       <Input
//                         size="small"
//                         className="w-full text-regular"
//                         name="phone"
//                         value={customerPhone}
//                         placeholder="New customer phone"
//                         onChange={handleCustomer}
//                         autoComplete="off"
//                       />
//                     </div>
//                     <div>
//                       <Button
//                         size="small"
//                         type="button"
//                         className="w-full text-medium text-white bg-[#07B553] hover:bg-[#14532d] mx-1"
//                         onClick={addCustomer}
//                       >
//                         ADD
//                       </Button>
//                     </div>
//                   </div>
//                 </div>

//                 {/* <div className="pt-4">
//                   <div>
//                     <Select
//                       className="w-full"
//                       name="tax"
//                       placeholder="Delivery status"
//                       value={totals?.delivery_status}
//                       options={[
//                         {
//                           value: 0,
//                           label: "Pending",
//                         },
//                         {
//                           value: 1,
//                           label: "Partial",
//                         },
//                         {
//                           value: 2,
//                           label: "Delivered",
//                         },
//                       ]}
//                       onChange={handleDeliveryStatus}
//                     />
//                   </div>
//                   {totals?.delivery_status == 2 && (
//                     <div className="pt-4">
//                       <DatePicker
//                         type="number"
//                         className="w-full"
//                         placeholder="Delivered date"
//                         name="delivery"
//                         value={
//                           totals?.delivery_date && dayjs(totals?.delivery_date)
//                         }
//                         onChange={handleDeliveryDate}
//                         autoComplete="off"
//                       />
//                     </div>
//                   )}
//                 </div> */}

//                 <div className="pt-2">
//                   {/* <div>
//                     <Select
//                       className="w-full"
//                       name="tax"
//                       placeholder="Payment status"
//                       value={totals?.payment_status}
//                       options={[
//                         {
//                           value: 0,
//                           label: "Unpaid",
//                         },
//                         {
//                           value: 1,
//                           label: "Partial",
//                         },
//                         {
//                           value: 2,
//                           label: "Paid",
//                         },
//                       ]}
//                       onChange={handlePaymentStatus}
//                     />
//                   </div> */}

//                   {totals?.payment_status == 1 ||
//                   totals?.payment_status == 2 ? (
//                     <div className="">
//                       <Select
//                         mode="multiple"
//                         className="w-full"
//                         name="tax"
//                         placeholder="Payment mode"
//                         value={totals?.payment_types}
//                         options={[
//                           {
//                             value: "Cash",
//                             label: "Cash",
//                           },

//                           {
//                             value: "Debit card",
//                             label: "Debit card",
//                           },
//                           {
//                             value: "Bank transfer",
//                             label: "Bank transfer",
//                           },
//                           {
//                             value: "Online payment",
//                             label: "Online payment",
//                           },
//                           {
//                             value: "Credit card",
//                             label: "Credit card",
//                           },
//                           {
//                             value: "Cheque",
//                             label: "Cheque",
//                           },
//                         ]}
//                         onChange={handlePaymentTypes}
//                       />
//                     </div>
//                   ) : (
//                     ""
//                   )}
//                   {totals?.payment_types?.map((value, index) => {
//                     return totals?.payment_types?.length > 1 ? (
//                       <div className="pt-4">
//                         <Input
//                           type="number"
//                           className="w-full"
//                           placeholder={value}
//                           name={value}
//                           value={totals?.payments?.[value]?.amount}
//                           onChange={handlePayments}
//                           autoComplete="off"
//                           required="required"
//                         />
//                       </div>
//                     ) : (
//                       ""
//                     );
//                   })}
//                 </div>
//               </div>
//               {/* info */}
//               <div className="p-4 flex">
//                 {/* <div className="pr-2 w-full">
//                   <Button
//                     htmlType="submit"
//                     type="primary"
//                     size="large"
//                     className="w-full text-medium bg-[#07B553] hover:bg-[#14532d]"
//                     disabled={buttonLoader}
//                   >
//                     {buttonLoader ? (
//                       <Spin
//                         indicator={<LoadingOutlined spin />}
//                         size="small"
//                         className="w-full text-medium bg-[#07B553]"
//                       />
//                     ) : (
//                       <>
//                         Save & Print {" (OMR "}
//                         {totals?.total > 0
//                           ? totals?.total?.toFixed(3)
//                           : "0.000"}
//                         {") "}
//                       </>
//                     )}
//                   </Button>
//                 </div> */}
//                 <div className="pl-2 w-full">
//                   <Button
//                     htmlType="submit"
//                     type="primary"
//                     size="large"
//                     className="w-full text-medium bg-[#07B553] hover:bg-[#14532d]"
//                     disabled={buttonLoader}
//                   >
//                     {buttonLoader ? (
//                       <Spin
//                         indicator={<LoadingOutlined spin />}
//                         size="small"
//                         className="w-full text-medium bg-[#07B553]"
//                       />
//                     ) : (
//                       <>
//                         Save {" (OMR "}
//                         {totals?.total > 0
//                           ? totals?.total?.toFixed(3)
//                           : "0.000"}
//                         {") "}
//                       </>
//                     )}
//                   </Button>
//                 </div>
//               </div>
//               {/* customer cash pay */}
//               <div className="pt-4 mt-2 border-t-2 border-gray border-dashed">
//                 <div className="flex w-full bg-gray-200 p-4">
//                   <div className="w-full">
//                     <Input
//                       size=""
//                       className="w-full text-regular"
//                       name="number"
//                       value={customerPay}
//                       placeholder="Customer cash pay"
//                       onChange={handleCustomerPay}
//                       autoComplete="off"
//                     />
//                   </div>
//                 </div>
//                 <div className="flex justify-between w-full  p-4">
//                   <div className="text-medium text-gray-500">
//                     RETURN BALANCE&nbsp;&nbsp;
//                   </div>
//                   <div className="text-medium text-gray-500">
//                     OMR&nbsp;{}
//                     {(
//                       parseFloat(customerPay || 0) -
//                       parseFloat(totals?.total || 0)
//                     )?.toFixed(3)}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// });

// export default BillingPos;



/**
 * Test new pos for pharmasolo by faiyaz comment of the above 
 * 
 */



// import {
//   DeleteOutlined,
//   LeftOutlined,
//   LoadingOutlined,
//   RightOutlined,
//   SearchOutlined,
// } from "@ant-design/icons";
// import { Button, DatePicker, Input, Select, Spin } from "antd";
// import React, { useEffect, useRef, useState, useCallback } from "react";
// import { debounce } from "lodash";
// import Fuse from "fuse.js";
// import { useNavigate } from "react-router-dom";
// import BarcodeButton from "../../../../Componets/Buttons/barcode";
// import { select_search } from "../../../../Controllers/Global";
// import moment from "moment";
// import URL from "../../../../Main/url";
// import {
//   get_all_inventories,
//   get_inventory_barcode,
// } from "../../../../Controllers/Inventory/Batch";
// import toast from "react-hot-toast";
// import dayjs from "dayjs";
// import Modalcomponent from "../../../../Componets/Modal";
// import { create_customer } from "../../../../Controllers/Customers";
// import Loadercomponent from "../../../../Componets/Loader";

// const BillingPos = React.forwardRef((props, submitType) => {
//   const {
//     loader,
//     setLoader,
//     customer,
//     setCustomer,
//     details,
//     setDetails,
//     totals,
//     setTotals,
//     formdata,
//     buttonLoader,
//   } = props;

//   const [isFocusedProduct, setIsFocusedProduct] = useState(false);
//   const [isFocusedInventory, setIsFocusedInventory] = useState(false);
//   const [posloader, setPosLoader] = useState(false);
//   const [search, setSearch] = useState("");
//   const [options, setOptions] = useState([]);
//   const [inventoryOptions, setInventoryOptions] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [modalData, setModalData] = useState();
//   const [selectedModalData, setSelectedModalData] = useState();
//   const [customerName, setCustomerName] = useState();
//   const [customerPhone, setCustomerPhone] = useState();
//   const [customerOptions, setCustomerOptions] = useState([]);
//   const [customerPay, setCustomerPay] = useState();
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalCount: 0,
//     totalPages: 0,
//   });

//   const latestQueryRef = useRef("");

//   const normalizeQuery = (query) => {
//     if (!query) return "";
//     return query
//       .toLowerCase()
//       .normalize("NFD")
//       .replace(/[\u0300-\u036f]/g, "")
//       .replace(/[^a-z0-9\s-]/g, "")
//       .replace(/\s+/g, " ")
//       .trim();
//   };

//   const handleCustomerPay = (e) => {
//     setCustomerPay(e?.target?.value);
//   };

//   const handleCustomerSearch = async (e) => {
//     const select = {
//       api: "get-all-customers",
//       search: normalizeQuery(e),
//       status: 1,
//     };

//     const search = await select_search(select);

//     if (search?.status) {
//       const options = search?.data?.data?.map((value) => ({
//         value: value?._id,
//         label: (
//           <div>
//             {value?.name}
//             &nbsp;{value?.phone ? `(${value?.phone})` : ""}
//           </div>
//         ),
//       }));
//       setCustomerOptions(options);
//     } else {
//       toast?.error(search?.message);
//     }
//   };

//   const handleCustomer = (e) => {
//     if (e?.target?.name === "name") {
//       setCustomerName(e?.target?.value);
//     } else if (e?.target?.name === "phone") {
//       setCustomerPhone(e?.target?.value);
//     }
//   };

//   const addCustomer = async () => {
//     if (!customerPhone) {
//       toast?.error("Phone Required");
//       return;
//     }

//     let params = {
//       name: customerName,
//       phone: customerPhone,
//       status: 1,
//     };

//     const addcustomer = await create_customer(params);

//     if (addcustomer?.status) {
//       toast?.success(addcustomer?.message);
//       const newCustomer = addcustomer?.data;
//       setCustomerOptions((prevOptions) => [
//         ...prevOptions,
//         {
//           value: newCustomer._id,
//           label: `${newCustomer.name} (${newCustomer.phone || ""})`,
//         },
//       ]);
//       setCustomer(newCustomer._id);
//       setCustomerName("");
//       setCustomerPhone("");
//     } else {
//       toast?.error(addcustomer?.message);
//     }
//   };

//   const handleSearch = async (query, page) => {
//     latestQueryRef.current = query;
//     setPosLoader(true);
//     setSearch(query);
//     const normalizedQuery = normalizeQuery(query);
//     const select = {
//       api: "get-all-inventories",
//       search: normalizedQuery,
//       status: 1,
//       sort: 6,
//       page: page?.currentPage || 1,
//     };

//     const search = await select_search(select);
//     if (latestQueryRef.current !== query) return;

//     if (search?.status) {
//       let fetchedOptions = search?.data?.data || [];
//       if (query && fetchedOptions.length > 0) {
//         const fuse = new Fuse(fetchedOptions, {
//           keys: ["product.searchKey", "product.name"],
//           threshold: 0.3,
//           includeScore: true,
//           minMatchCharLength: 2,
//         });
//         fetchedOptions = fuse.search(normalizedQuery).map((result) => result.item);
//       }
//       setPagination({
//         currentPage: search?.data?.currentPage || 1,
//         totalCount: search?.data?.totalCount || 0,
//         totalPages: search?.data?.totalPages || 0,
//       });
//       setOptions(fetchedOptions);
//       setInventoryOptions(
//         fetchedOptions.map((item) => ({
//           value: item._id,
//           label: item.product.name,
//         }))
//       );
//       setPosLoader(false);
//     } else {
//       setPosLoader(false);
//       setOptions([]);
//       setInventoryOptions([]);
//       toast?.error(
//         normalizedQuery.includes("tr")
//           ? "Product not found. Did you mean 'transparent'?"
//           : "Product not found"
//       );
//     }
//   };

//   const handleSelectSearch = (query) => {
//     if (!query) {
//       if (Array.isArray(options)) {
//         setInventoryOptions(
//           options.map((item) => ({
//             value: item._id,
//             label: item.product.name,
//           }))
//         );
//       }
//       return;
//     }
//     const normalizedQuery = normalizeQuery(query);
//     if (Array.isArray(options) && options.length > 0) {
//       const fuse = new Fuse(options, {
//         keys: ["product.searchKey", "product.name"],
//         threshold: 0.3,
//         includeScore: true,
//         minMatchCharLength: 2,
//       });
//       const results = fuse.search(normalizedQuery).map((result) => ({
//         value: result.item._id,
//         label: result.item.product.name,
//       }));
//       setInventoryOptions(results);
//     } else {
//       setInventoryOptions([]);
//     }
//   };

//   const handleDescriptionProductBarcode = async (e, page) => {
//     if (isFocusedProduct && e) {
//       const normalizedQuery = normalizeQuery(e);
//       setPosLoader(true);
//       setSearch(normalizedQuery);
//       const select = {
//         api: "get-all-inventories",
//         search: normalizedQuery,
//         status: 1,
//         sort: 6,
//         page: page?.currentPage || 1,
//       };
//       const search = await select_search(select);
//       if (search?.status) {
//         let fetchedOptions = search?.data?.data || [];
//         if (fetchedOptions.length > 0) {
//           handleDescription(fetchedOptions[0], details.length);
//         }
//         setPagination({
//           currentPage: search?.data?.currentPage || 1,
//           totalCount: search?.data?.totalCount || 0,
//           totalPages: search?.data?.totalPages || 0,
//         });
//         setOptions(fetchedOptions);
//         setInventoryOptions(
//           fetchedOptions.map((item) => ({
//             value: item._id,
//             label: item.product.name,
//           }))
//         );
//         setPosLoader(false);
//       } else {
//         setPosLoader(false);
//         toast?.error(
//           normalizedQuery.includes("tr")
//             ? "Product not found. Did you mean 'transparent'?"
//             : "Product not found"
//         );
//       }
//     }
//   };

//   const handleDescriptionInventoryBarcode = async (e) => {
//     if (isFocusedInventory && e) {
//       const normalizedQuery = normalizeQuery(e);
//       let params = { barcode: normalizedQuery };
//       const inventory = await get_inventory_barcode(params);
//       if (inventory?.status) {
//         if (
//           inventory?.data?.expiry_date &&
//           new Date(new Date(inventory?.data?.expiry_date).getTime()) < new Date()
//         ) {
//           toast?.error(
//             `Inventory expired on ${moment?.(inventory?.data?.expiry_date)?.format(
//               "DD-MM-YYYY"
//             )}`
//           );
//         } else {
//           if (inventory?.data?.inventories_units_details?.length > 0) {
//             setOpen(true);
//             let modaldata = [
//               { ...inventory?.data, name: inventory?.data?.product?.unit?.name },
//             ];
//             inventory?.data?.inventories_units_details?.map((v) =>
//               modaldata?.push(v)
//             );
//             setModalData(modaldata);
//             setSelectedModalData({ ...inventory.data, index: details?.length });
//           } else {
//             handleDescription(inventory.data, details?.length);
//           }
//         }
//       } else {
//         toast?.error("Inventory not found");
//       }
//     }
//   };

//   const handleNext = () => {
//     let currentPage = parseInt(pagination?.currentPage) + 1;
//     if (currentPage <= parseInt(pagination?.totalPages)) {
//       let data = { ...pagination, currentPage: currentPage };
//       handleSearch(search, data);
//     }
//   };

//   const handlePrevious = () => {
//     let currentPage = parseInt(pagination?.currentPage) - 1;
//     if (currentPage > 0) {
//       let data = { ...pagination, currentPage: currentPage };
//       handleSearch(search, data);
//     }
//   };

//   const handleModal = (modaldata) => {
//     let data = [...details];
//     let inventory = selectedModalData;
//     let index = selectedModalData?.index;

//     let inventory_description = null;
//     let inventory_name = "";
//     let inventory_batch = "";
//     let inventory_expiry_date = "";
//     let inventory_price_per_unit = "";
//     let inventory_unit = "";
//     let inventory_unit_name = "";
//     let inventory_sale_price = 0;
//     let inventory_stock = 0;
//     let inventory_tax = 0;
//     let inventory_conversion = 0;
//     let inventories_units_details = [];

//     let description_ids = data?.map((v) => v?.unit);

//     if (!description_ids?.includes(modaldata)) {
//       if (inventory?._id === modaldata) {
//         inventory_description = inventory?._id;
//         inventory_name = inventory?.product?.name;
//         inventory_batch = inventory?.number;
//         inventory_expiry_date = inventory?.expiry_date;
//         inventory_price_per_unit = inventory?.price_per_unit;
//         inventory_unit = modaldata;
//         inventory_unit_name = inventory?.product?.unit?.name;
//         inventory_sale_price = inventory?.sale_price;
//         inventory_stock = inventory?.stock;
//         inventory_tax = inventory?.tax;
//         if (inventory?.inventories_units_details?.length > 0) {
//           inventory?.inventories_units_details?.map((value) => {
//             inventories_units_details?.push({
//               ...value,
//               name: value?.name,
//               purchase_price: value?.purchase_price,
//               price_per_unit: value?.price_per_unit,
//               sale_price: value?.sale_price,
//               stock: value?.stock,
//               unit_quantity: 0,
//               unit_delivered: 0,
//             });
//           });
//         }
//       } else {
//         let selected_unit = "";
//         let unit_ids = inventory?.inventories_units_details?.map((v) => v?._id);

//         if (unit_ids?.includes(modaldata)) {
//           selected_unit =
//             inventory?.inventories_units_details?.[unit_ids?.indexOf(modaldata)];
//         }

//         inventory_description = inventory?._id;
//         inventory_name = inventory?.product?.name;
//         inventory_batch = inventory?.number;
//         inventory_expiry_date = inventory?.expiry_date;
//         inventory_unit = modaldata;
//         inventory_unit_name = selected_unit?.name;
//         inventory_sale_price = selected_unit?.sale_price;
//         inventory_stock = selected_unit?.stock;
//         inventory_tax = inventory?.tax;
//         inventory_conversion = selected_unit?.conversion;
//       }

//       if (inventory_stock >= 1) {
//         let price_sale = parseFloat(inventory_sale_price || 0);
//         let price_tax =
//           parseFloat(price_sale || 0) * (parseFloat(inventory_tax || 0) / 100);
//         let price_total =
//           parseFloat(price_sale || 0) + parseFloat(price_tax || 0);

//         data?.push({
//           description: inventory_description,
//           name: inventory_name,
//           batch: inventory_batch,
//           expiry_date: inventory_expiry_date,
//           unit: inventory_unit,
//           unit_name: inventory_unit_name,
//           sale_price: price_sale,
//           stock: inventory_stock,
//           tax: inventory_tax,
//           conversion: inventory_conversion,
//           quantity: 1,
//           delivered: 1,
//           tax_amount: price_tax,
//           total: price_total,
//           unit_details_options: inventories_units_details,
//         });

//         let subtotal =
//           data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.total),
//             0
//           ) -
//           data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//             0
//           );
//         let taxamount = data?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//           0
//         );
//         let grandtotal = data?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.total),
//           0
//         );

//         totals.subtotal = subtotal;
//         totals.taxamount = taxamount;
//         totals.delivery_status = 2;
//         totals.delivery_date = new Date();
//         totals.payment_status = 2;
//         totals.payment_types = ["Cash"];
//         totals.payments = {
//           Cash: "",
//           Cheque: "",
//           "Debit card": "",
//           "Credit card": "",
//           "Bank transfer": "",
//           "Online payment": "",
//         };
//         totals.total = grandtotal;

//         setDetails(data);
//         setTotals({ ...totals });
//         setModalData(null);
//         setSelectedModalData(null);
//       } else {
//         toast?.error(`Stock only ${inventory_stock}`);
//         setModalData(null);
//         setSelectedModalData(null);
//       }
//     } else {
//       let selected_index = description_ids?.indexOf(modaldata);

//       if (
//         parseFloat(data[selected_index].quantity || 0) <
//         parseFloat(Math.floor(data[selected_index].stock) || 0)
//       ) {
//         if (
//           data?.[selected_index]?.conversion > 0 &&
//           data?.[selected_index]?.quantity + parseFloat(1) >=
//             data?.[selected_index]?.conversion
//         ) {
//           toast?.error(
//             `Quantity exceeding ${data?.[selected_index]?.conversion}`
//           );
//         } else {
//           let quantity = data[selected_index].quantity
//             ? data[selected_index].quantity
//             : 0;
//           let delivered = data[selected_index].delivered
//             ? data[selected_index].delivered
//             : 0;

//           let total_quantity = parseFloat(quantity) + parseFloat(1);

//           data[selected_index].quantity = total_quantity;
//           data[selected_index].delivered = total_quantity;

//           data[selected_index].tax_amount = data[selected_index].tax
//             ? parseFloat(data[selected_index].sale_price || 0) *
//               parseFloat(total_quantity || 0) *
//               (parseFloat(data[selected_index].tax || 0) / 100)
//             : 0;
//           data[selected_index].total =
//             parseFloat(data[selected_index].sale_price || 0) *
//               parseFloat(total_quantity) +
//             (data[selected_index].tax
//               ? parseFloat(data[selected_index].sale_price || 0) *
//                 parseFloat(total_quantity || 0) *
//                 (parseFloat(data[selected_index].tax || 0) / 100)
//               : 0);

//           let subtotal =
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.total),
//               0
//             ) -
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//               0
//             );
//           let taxamount = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//             0
//           );
//           let grandtotal = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.total),
//             0
//           );

//           totals.subtotal = subtotal;
//           totals.taxamount = taxamount;
//           totals.delivery_status = 2;
//           totals.delivery_date = new Date();
//           totals.payment_status = 2;
//           totals.payment_types = ["Cash"];
//           totals.payments = {
//             Cash: "",
//             Cheque: "",
//             "Debit card": "",
//             "Credit card": "",
//             "Bank transfer": "",
//             "Online payment": "",
//           };
//           totals.total = grandtotal;

//           setDetails(data);
//           setTotals({ ...totals });
//         }
//       } else {
//         toast?.error(`Stock only ${data[selected_index].stock}`);
//       }
//     }
//   };

//   const handleDescription = async (e, index) => {
//     let data = [...details];

//     if (e?._id) {
//       if (
//         e?.expiry_date &&
//         new Date(new Date(e?.expiry_date).getTime()) < new Date()
//       ) {
//         toast?.error(
//           `Inventory expired on ${moment?.(e?.expiry_date)?.format(
//             "DD-MM-YYYY"
//           )}`
//         );
//       } else {
//         if (e?.inventories_units_details?.length > 0) {
//           setOpen(true);
//           let modaldata = [
//             { ...e, name: e?.product?.unit?.name },
//           ];
//           e?.inventories_units_details?.map((v) => modaldata?.push(v));
//           setModalData(modaldata);
//           setSelectedModalData({ ...e, index: index });
//         } else {
//           if (e?.stock >= 1) {
//             let description_ids = data?.map((v) => v?.description);

//             if (!description_ids?.includes(e?._id)) {
//               let inventory_description = e?._id;
//               let inventory_name = e?.product?.name;
//               let inventory_batch = e?.number;
//               let inventory_expiry_date = e?.expiry_date;
//               let inventory_unit = e?._id;
//               let inventory_unit_name = e?.product?.unit?.name;
//               let inventory_sale_price = e?.sale_price;
//               let inventory_stock = e?.stock;
//               let inventory_tax = e?.tax;
//               let inventories_units_details = [];

//               if (e?.inventories_units_details?.length > 0) {
//                 e?.inventories_units_details?.map((value) => {
//                   inventories_units_details?.push({
//                     ...value,
//                     name: value?.name?.name,
//                     price_per_unit: 0,
//                     sale_price: "",
//                     unit_quantity: 0,
//                     unit_delivered: 0,
//                   });
//                 });
//               }

//               let price_sale = parseFloat(inventory_sale_price || 0);
//               let price_tax =
//                 parseFloat(price_sale || 0) *
//                 (parseFloat(inventory_tax || 0) / 100);
//               let price_total =
//                 parseFloat(price_sale || 0) + parseFloat(price_tax || 0);

//               data?.push({
//                 description: inventory_description,
//                 name: inventory_name,
//                 batch: inventory_batch,
//                 expiry_date: inventory_expiry_date,
//                 unit: inventory_unit,
//                 unit_name: inventory_unit_name,
//                 sale_price: price_sale,
//                 stock: inventory_stock,
//                 tax: inventory_tax,
//                 quantity: 1,
//                 delivered: 1,
//                 tax_amount: price_tax,
//                 total: price_total,
//                 unit_details_options: inventories_units_details,
//               });

//               let subtotal =
//                 data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.total),
//                   0
//                 ) -
//                 data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                   0
//                 );
//               let taxamount = data?.reduce(
//                 (acc, currentValue) =>
//                   parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                 0
//               );
//               let grandtotal = data?.reduce(
//                 (acc, currentValue) =>
//                   parseFloat(acc) + parseFloat(currentValue?.total),
//                 0
//               );

//               totals.subtotal = subtotal;
//               totals.taxamount = taxamount;
//               totals.delivery_status = 2;
//               totals.delivery_date = new Date();
//               totals.payment_status = 2;
//               totals.payment_types = ["Cash"];
//               totals.payments = {
//                 Cash: "",
//                 Cheque: "",
//                 "Debit card": "",
//                 "Credit card": "",
//                 "Bank transfer": "",
//                 "Online payment": "",
//               };
//               totals.total = grandtotal;

//               setDetails(data);
//               setTotals({ ...totals });
//             } else {
//               let selected_index = description_ids?.indexOf(e?._id);

//               if (
//                 parseFloat(data[selected_index].quantity || 0) <
//                 parseFloat(data[selected_index].stock || 0)
//               ) {
//                 let quantity = data[selected_index].quantity
//                   ? data[selected_index].quantity
//                   : 0;
//                 let delivered = data[selected_index].delivered
//                   ? data[selected_index].delivered
//                   : 0;
//                 let total_quantity = parseFloat(quantity) + parseFloat(1);

//                 data[selected_index].quantity = total_quantity;
//                 data[selected_index].delivered = total_quantity;
//                 data[selected_index].tax_amount = data[selected_index].tax
//                   ? parseFloat(data[selected_index].sale_price || 0) *
//                     parseFloat(total_quantity || 0) *
//                     (parseFloat(data[selected_index].tax || 0) / 100)
//                   : 0;
//                 data[selected_index].total =
//                   parseFloat(data[selected_index].sale_price || 0) *
//                     parseFloat(total_quantity) +
//                   (data[selected_index].tax
//                     ? parseFloat(data[selected_index].sale_price || 0) *
//                       parseFloat(total_quantity || 0) *
//                       (parseFloat(data[selected_index].tax || 0) / 100)
//                     : 0);

//                 let subtotal =
//                   data?.reduce(
//                     (acc, currentValue) =>
//                       parseFloat(acc) + parseFloat(currentValue?.total),
//                     0
//                   ) -
//                   data?.reduce(
//                     (acc, currentValue) =>
//                       parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                     0
//                   );
//                 let taxamount = data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                   0
//                 );
//                 let grandtotal = data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.total),
//                     0
//                   );

//                 totals.subtotal = subtotal;
//                 totals.taxamount = taxamount;
//                 totals.delivery_status = 2;
//                 totals.delivery_date = new Date();
//                 totals.payment_status = 2;
//                 totals.payment_types = ["Cash"];
//                 totals.payments = {
//                   Cash: "",
//                   Cheque: "",
//                   "Debit card": "",
//                   "Credit card": "",
//                   "Bank transfer": "",
//                   "Online payment": "",
//                 };
//                 totals.total = grandtotal;

//                 setDetails(data);
//                 setTotals({ ...totals });
//               } else {
//                 toast?.error(`Stock only ${data[selected_index].stock}`);
//               }
//             }
//           } else {
//             toast?.error(`Stock only ${e?.stock}`);
//           }
//         }
//       }
//     } else {
//       data[index].id = "";
//       data[index].description = null;
//       data[index].name = "";
//       data[index].batch = "";
//       data[index].expiry_date = "";
//       data[index].unit = "";
//       data[index].unit_name = "";
//       data[index].unit_details_options = null;
//       data[index].quantity = "";
//       data[index].conversion = 0;
//       data[index].purchase = "";
//       data[index].sale_price = "";
//       data[index].purchase_options = null;
//       data[index].delivered = "";
//       data[index].tax = 0;
//       data[index].free = "";
//       data[index].barcode = "";
//       data[index].price_per_unit = "";
//       data[index].sale_price = "";
//       data[index].expiry_date = "";
//       data[index].tax_amount = "0.000";
//       data[index].total = 0;
//       setDetails(data);
//     }
//   };

//   const handlePurchase = (e, index, key) => {
//     if (e) {
//       let event = {
//         target: {
//           name: "sale_price",
//           value: JSON?.parse(e)?.sale_price,
//         },
//       };
//       handleTotal(event, index, "sale_price");
//       handleTotal(JSON?.parse(e)?.tax, index, "tax");
//     }
//   };

//   const handleDelivered = (e, index) => {
//     if (e?.target?.value >= 0) {
//       let data = [...details];
//       let data_quantity = data[index]?.quantity
//         ? parseFloat(data[index]?.quantity)
//         : 0;
//       let data_delivered = e?.target?.value ? parseFloat(e?.target?.value) : 0;

//       if (data_delivered <= data_quantity) {
//         data[index][e?.target?.name] = e?.target?.value;
//         setDetails(data);
//       } else {
//         toast?.error(`Quantity only ${data_quantity}`);
//       }
//     }
//   };

//   const handleTotal = (e, index, key) => {
//     let name = key ? key : e?.target?.name;
//     let value = key && e ? e : e?.target?.value ? e?.target?.value : "";

//     if (value >= 0) {
//       let data = [...details];

//       if (value <= data[index]?.stock) {
//         let data_sale_price = data[index]?.sale_price
//           ? data[index]?.sale_price
//           : 0;
//         let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
//         let data_delivered = data[index]?.delivered ? data[index]?.delivered : 0;
//         let data_free = data[index]?.free ? data[index]?.free : 0;
//         let data_tax = data[index]?.tax ? data[index]?.tax : 0;
//         let data_conversion = data[index].conversion
//           ? data[index].conversion
//           : 0;

//         let sale_price = name === "sale_price" ? value : data_sale_price;
//         let quantity = name === "quantity" ? value : data_quantity;
//         let delivered = name === "quantity" ? value : data_delivered;
//         let free = name === "free" ? value : data_free;
//         let tax = name === "tax" ? value : data_tax;

//         let tax_amount = tax
//           ? parseFloat(sale_price) *
//             parseFloat(quantity ? quantity : 0) *
//             (parseFloat(tax) / 100)
//           : 0;

//         let total =
//           parseFloat(sale_price) * parseFloat(quantity ? quantity : 0) +
//           parseFloat(tax_amount);

//         let price_per_unit =
//           parseFloat(total ? total : 0) /
//           (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

//         let unit_details_options = [];
//         if (data?.[index]?.unit_details_options?.length > 0) {
//           data?.[index]?.unit_details_options?.map((v) => {
//             let total_quantity =
//               parseFloat(quantity || 0) + parseFloat(free || 0);

//             unit_details_options?.push({
//               ...v,
//               price_per_unit: price_per_unit
//                 ? parseFloat(price_per_unit || 0) / parseFloat(v?.conversion || 0)
//                 : 0,
//               unit_quantity: quantity
//                 ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
//                 : 0,
//               unit_delivered: delivered
//                 ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
//                 : 0,
//             });
//           });
//         }

//         if (
//           data_conversion > 0 &&
//           parseFloat(quantity) + parseFloat(free) >= data_conversion
//         ) {
//           toast?.error(`Quantity exceeding ${data[index].conversion}`);
//         } else {
//           data[index][name] = value;
//           data[index].unit_details_options = unit_details_options;
//           data[index].delivered = delivered ? delivered : "";
//           data[index].tax = tax ? tax : 0;
//           data[index].total = total ? total : 0;
//           data[index].tax_amount = tax_amount ? tax_amount : "0.000";
//           data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

//           let subtotal =
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.total),
//               0
//             ) -
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//               0
//             );

//           let taxamount = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//             0
//           );

//           let grandtotal = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.total),
//             0
//           );

//           totals.discount = "";
//           totals.delivery = "";
//           totals.subtotal = subtotal;
//           totals.taxamount = taxamount;
//           totals.delivery_status = 2;
//           totals.delivery_date = new Date();
//           totals.payment_status = 2;
//           totals.payment_types = ["Cash"];
//           totals.payments = {
//             Cash: "",
//             Cheque: "",
//             "Debit card": "",
//             "Credit card": "",
//             "Bank transfer": "",
//             "Online payment": "",
//           };
//           totals.total = grandtotal;

//           setDetails(data);
//           setTotals({ ...totals });
//         }
//       } else {
//         toast?.error(`Stock only ${data[index]?.stock}`);
//       }
//     }
//   };

//   const handleRemove = (index) => {
//     let data = [...details];
//     data?.splice(index, 1);

//     let subtotal =
//       data?.reduce(
//         (acc, currentValue) =>
//           parseFloat(acc) + parseFloat(currentValue?.total),
//         0
//       ) -
//       data?.reduce(
//         (acc, currentValue) =>
//           parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//         0
//       );

//     let taxamount = data?.reduce(
//       (acc, currentValue) =>
//         parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//       0
//     );

//     let grandtotal = data?.reduce(
//       (acc, currentValue) =>
//         parseFloat(acc) + parseFloat(currentValue?.total),
//       0
//     );

//     totals.discount = "";
//     totals.delivery = "";
//     totals.subtotal = subtotal;
//     totals.taxamount = taxamount;
//     totals.delivery_status = 2;
//     totals.delivery_date = new Date();
//     totals.payment_status = 2;
//     totals.payment_types = ["Cash"];
//     totals.payments = {
//       Cash: "",
//       Cheque: "",
//       "Debit card": "",
//       "Credit card": "",
//       "Bank transfer": "",
//       "Online payment": "",
//     };
//     totals.total = grandtotal;

//     setDetails(data);
//     setTotals({ ...totals });
//   };

//   const handleAdd = (e) => {
//     if (e) {
//       setDetails((prevDetails) => [
//         ...prevDetails,
//         {
//           id: "",
//           description: null,
//           unit: "",
//           sale_price: "",
//           quantity: "",
//           delivered: "",
//           free: "",
//           tax: 0,
//           total: 0,
//         },
//       ]);
//       handleDescription(e, details?.length + 1);
//     }
//   };

//   const handleDelivery = (e) => {
//     if (e?.target?.value >= 0) {
//       let total_amount = parseFloat(
//         details?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.total),
//           0
//         )
//       );

//       let total =
//         parseFloat(total_amount ? total_amount : 0) +
//         parseFloat(e?.target?.value ? e?.target?.value : 0) -
//         parseFloat(totals?.discount ? totals?.discount : 0);

//       totals.delivery = e?.target?.value;
//       totals.total = total;

//       setTotals({ ...totals });
//     }
//   };

//   const handleDiscount = (e) => {
//     if (e?.target?.value >= 0) {
//       let total_amount = parseFloat(
//         details?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.total),
//           0
//         )
//       );

//       let total =
//         parseFloat(total_amount ? total_amount : 0) +
//         parseFloat(totals?.delivery ? totals?.delivery : 0) -
//         parseFloat(e?.target?.value ? e?.target?.value : 0);

//       if (e?.target?.value <= total_amount) {
//         totals.discount = e?.target?.value;
//         totals.total = total;
//       } else {
//         toast?.error(`Discount exceeding`);
//       }

//       setTotals({ ...totals });
//     }
//   };

//   const handleDeliveryStatus = (e) => {
//     totals.delivery_status = e;
//     if (!e || e === 1) {
//       totals.delivery_date = "";
//     }
//     setTotals({ ...totals });
//   };

//   const handleDeliveryDate = (e) => {
//     totals.delivery_date = e?.$d;
//     setTotals({ ...totals });
//   };

//   const handlePaymentStatus = (e) => {
//     totals.payment_status = e;
//     if (!e) {
//       totals.payment_types = null;
//     }
//     setTotals({ ...totals });
//   };

//   const handlePaymentTypes = (e) => {
//     totals?.payment_types?.map((v) => {
//       if (!e?.includes(v)) {
//         totals.payments[v] = "";
//       }
//     });
//     totals.payment_types = e;
//     setTotals({ ...totals });
//   };

//   const handlePayments = (e) => {
//     let name = e?.target?.name;
//     let value = e?.target?.value ? e?.target?.value : "";

//     if (e?.target?.value >= 0) {
//       let data_Cash = totals?.payments?.Cash?.amount || 0;
//       let data_Cheque = totals?.payments?.Cheque?.amount || 0;
//       let data_Debitcard = totals?.payments?.["Debit card"]?.amount || 0;
//       let data_Creditcard = totals?.payments?.["Credit card"]?.amount || 0;
//       let data_Banktransfer = totals?.payments?.["Bank transfer"]?.amount || 0;
//       let data_Onlinepayment = totals?.payments?.["Online payment"]?.amount || 0;

//       let Cash = name === "Cash" ? value : data_Cash;
//       let Cheque = name === "Cheque" ? value : data_Cheque;
//       let Debitcard = name === "Debit card" ? value : data_Debitcard;
//       let Creditcard = name === "Credit card" ? value : data_Creditcard;
//       let Banktransfer = name === "Bank transfer" ? value : data_Banktransfer;
//       let Onlinepayment = name === "Online payment" ? value : data_Onlinepayment;

//       let total =
//         parseFloat(Cash) +
//         parseFloat(Cheque) +
//         parseFloat(Debitcard) +
//         parseFloat(Creditcard) +
//         parseFloat(Banktransfer) +
//         parseFloat(Onlinepayment);

//       let payment_total = total ? parseFloat(total)?.toFixed(3) : 0;
//       let grand_total = totals?.total ? parseFloat(totals?.total)?.toFixed(3) : 0;

//       if (parseFloat(payment_total) <= parseFloat(grand_total)) {
//         totals.payments[name] = { ...totals.payments[name], amount: value };
//         setTotals({ ...totals });
//       } else {
//         let previous_total =
//           parseFloat(data_Cash) +
//           parseFloat(data_Cheque) +
//           parseFloat(data_Debitcard) +
//           parseFloat(data_Creditcard) +
//           parseFloat(data_Banktransfer) +
//           parseFloat(data_Onlinepayment);

//         toast?.error(`Total only ${grand_total}`);
//       }
//     }
//   };

//   const handleSubmit = (e) => {
//     e?.preventDefault();
//     const data = { status: true };
//     formdata(data);
//   };

//   const fetchData = () => {
//     handleSearch("");
//   };

//   const barcodeInputRefProduct = useRef("");
//   const handleKeyDownProduct = (event) => {
//     const ignoredKeys = [
//       "Shift",
//       "Control",
//       "Alt",
//       "Meta",
//       "ArrowUp",
//       "ArrowDown",
//       "ArrowLeft",
//       "ArrowRight",
//       "CapsLock",
//     ];
//     const validKey = /^[a-zA-Z0-9]$/;

//     if (event.key === "Enter") {
//       const barcode = barcodeInputRefProduct.current.trim();
//       if (barcode) {
//         handleDescriptionProductBarcode(barcode);
//       }
//       barcodeInputRefProduct.current = "";
//     } else if (!ignoredKeys.includes(event.key) && validKey.test(event.key)) {
//       barcodeInputRefProduct.current += event.key;
//     }
//   };

//   const barcodeInputRefInventory = useRef("");
//   const handleKeyDownInventory = (event) => {
//     const ignoredKeys = [
//       "Shift",
//       "Control",
//       "Alt",
//       "Meta",
//       "ArrowUp",
//       "ArrowDown",
//       "ArrowLeft",
//       "ArrowRight",
//       "CapsLock",
//     ];
//     const validKey = /^[a-zA-Z0-9]$/;

//     if (event.key === "Enter") {
//       const barcode = barcodeInputRefInventory.current.trim();
//       if (barcode) {
//         handleDescriptionInventoryBarcode(barcode);
//       }
//       barcodeInputRefInventory.current = "";
//     } else if (!ignoredKeys.includes(event.key) && validKey.test(event.key)) {
//       barcodeInputRefInventory.current += event.key;
//     }
//   };

//   const debouncedSearch = useCallback(
//     debounce((query) => handleSearch(query, { currentPage: 1 }), 500),
//     []
//   );

//   const handleInputChange = (e) => {
//     debouncedSearch(e.target.value);
//   };

//   const handleOnKeyDown = (event) => {
//     if (event.key === "Enter") {
//       event.preventDefault();
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const formRef = useRef(null);

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "F4") {
//         e.preventDefault();
//         submitType.current = "print";
//         if (formRef.current) {
//           formRef.current.requestSubmit();
//         }
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, []);

//   return (
//     <div>
//       <Modalcomponent
//         open={open}
//         setOpen={setOpen}
//         modalData={modalData}
//         setModalData={setModalData}
//         selectedModalData={selectedModalData}
//         setSelectedModalData={setSelectedModalData}
//         handleModal={handleModal}
//       />
//       <form ref={formRef} onSubmit={handleSubmit}>
//         <div className="p-4">
//           <div className="flex justify-between">
//             <div className="w-[49%] rounded-md">
//               <div className="p-4 flex justify-between bg-white rounded-tl-md rounded-tr-md">
//                 <div className="w-2/3 pr-8">
//                   <div className="flex">
//                     <div className="pr-3">
//                       <BarcodeButton
//                         name="product"
//                         tabIndex={0}
//                         onKeyDown={handleKeyDownProduct}
//                         isFocusedProduct={isFocusedProduct}
//                         setIsFocusedProduct={setIsFocusedProduct}
//                       />
//                     </div>
//                     <div className="w-full">
//                       <Select
//                         className="w-full text-regular"
//                         name="description"
//                         placeholder="Search Products"
//                         allowClear
//                         showSearch
//                         filterOption={false}
//                         options={inventoryOptions}
//                         onSearch={handleSelectSearch}
//                         onFocus={() => handleSelectSearch("")}
//                         onChange={(value) => {
//                           const selected = options.find((item) => item._id === value);
//                           if (selected) handleDescription(selected, details.length);
//                         }}
//                         autoComplete="off"
//                         loading={posloader}
//                         disabled={posloader}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div>
//                   <BarcodeButton
//                     name="inventory"
//                     onKeyDown={handleKeyDownInventory}
//                     isFocusedInventory={isFocusedInventory}
//                     setIsFocusedInventory={setIsFocusedInventory}
//                   />
//                 </div>
//               </div>
//               <div className="bg-white h-[60vh]" style={{ overflowX: "auto" }}>
//                 <Loadercomponent loader={posloader}>
//                   <div className="mx-2">
//                     <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 grid-cols-5 gap-3">
//                       {options?.map((value, index) => (
//                         <button
//                           type="button"
//                           key={index}
//                           className="border cursor-pointer p-3 hover:bg-gray-100 rounded-lg flex flex-col min-h-[8vw]"
//                           onClick={() => handleDescription(value)}
//                         >
//                           <div className="text-center pt-2 flex-grow">
//                             <div className="text-[0.70rem] text-medium break-words leading-tight">
//                               {value?.product?.name}
//                             </div>
//                             <div className="text-[0.50rem] text-gray-500">
//                               #BATCH-{value?.number}
//                               <div className="text-xs text-green-500 font-medium">
//                                 Stock&nbsp;(
//                                 {value?.stock
//                                   ? Number.isInteger(value?.stock)
//                                     ? parseFloat(value?.stock || 0)
//                                     : parseFloat(value?.stock || 0)?.toFixed(3)
//                                   : "0"}
//                                 )
//                               </div>
//                             </div>
//                             <div className="text-[0.50rem] text-gray-500">
//                               EXP :&nbsp;
//                               {value?.expiry_date
//                                 ? moment(value?.expiry_date).format("DD-MM-YYYY")
//                                 : "N/A"}
//                             </div>
//                           </div>
//                           <div className="text-center text-[0.50rem] text-gray-500">
//                             <div>{value?.tax ? `VAT ${value?.tax}%` : ""}</div>
//                           </div>
//                           <div className="border text-medium text-xs rounded-md text-center text-green-500 font-medium mt-auto">
//                             OMR {parseFloat(value?.sale_price)?.toFixed(3)}
//                           </div>
//                         </button>
//                       ))}
//                     </div>
//                   </div>
//                 </Loadercomponent>
//               </div>
//               <div className="p-4 flex justify-between text-gray-600 text-sm text-medium">
//                 <div>
//                   <span className="pr-3">TOTAL</span>
//                   <span className="pl-5">
//                     {pagination?.currentPage > 1
//                       ? parseInt(pagination?.currentPage || 0) - 1
//                       : 1}
//                     {pagination?.currentPage > 1 ? 1 : ""} -{" "}
//                     {pagination?.currentPage}0 OF {pagination?.totalCount}
//                   </span>
//                 </div>
//                 <div className="flex">
//                   <div
//                     type="button"
//                     className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553]"
//                     onClick={handlePrevious}
//                   >
//                     <div className="text-center text-xs text-gray-900">
//                       <LeftOutlined />
//                     </div>
//                   </div>
//                   <span className="px-3 pt-1">
//                     {pagination?.currentPage} OUT OF {pagination?.totalPages}
//                   </span>
//                   <div
//                     type="button"
//                     className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553]"
//                     onClick={handleNext}
//                   >
//                     <div className="text-center text-xs text-gray-600">
//                       <RightOutlined />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="p-10 flex justify-between bg-white rounded-bl-md rounded-br-md" />
//             </div>
//             <div className="bg-white w-[49%] rounded-md">
//               <div className="p-4 flex justify-center">
//                 <div className="p-1 text-semi-bold">CHECKOUT</div>
//               </div>
//               <div className="h-[35vh]" style={{ overflowY: "auto" }}>
//                 <table className="w-full">
//                   <thead className="bg-gray-100 text-gray-500 text-xs text-medium">
//                     <tr>
//                       <td className="p-1 border-r">SNO</td>
//                       <td className="p-1 border-r">NAME</td>
//                       <td className="p-1 border-r">UNIT</td>
//                       <td className="p-1 border-r">QUANTITY</td>
//                       <td className="p-1 border-r">PRICE</td>
//                       <td className="p-1 border-r">TAX</td>
//                       <td className="p-1 border-r">TOTAL</td>
//                       <td className="p-1 text-center">DELETE</td>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details?.map((value, index) => (
//                       <tr className="border-b text-xs" key={index}>
//                         <td className="p-1 border-r">{index + 1}</td>
//                         <td className="p-1 border-r">
//                           <div className="text-[0.70rem] text-medium">
//                             {value?.name}
//                           </div>
//                           <div className="text-[0.50rem] text-gray-500">
//                             <div>{`#BATCH-${value?.batch}`}</div>
//                             <div className="text-[0.50rem]">
//                               {value?.expiry_date
//                                 ? `EXPIRY : ${moment(value?.expiry_date).format(
//                                     "DD-MM-YYYY"
//                                   )}`
//                                 : ""}
//                             </div>
//                           </div>
//                         </td>
//                         <td className="p-1 border-r text-[0.65rem] text-medium">
//                           {value?.unit_name}
//                         </td>
//                         <td className="p-1 border-r">
//                           <div className="text-green-500 text-[0.60rem] text-medium">
//                             Stock&nbsp;(
//                             {value?.stock
//                               ? Number.isInteger(value?.stock)
//                                 ? parseFloat(value?.stock || 0)
//                                 : parseFloat(value?.stock || 0)?.toFixed(3)
//                               : "0"}
//                             )
//                           </div>
//                           <Input
//                             type="number"
//                             className="text-xs"
//                             name="quantity"
//                             placeholder="Quantity"
//                             value={value?.quantity}
//                             onChange={(e) => handleTotal(e, index)}
//                             onKeyDown={handleOnKeyDown}
//                             autoComplete="off"
//                             required
//                           />
//                         </td>
//                         <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                           {value?.sale_price
//                             ? value?.sale_price?.toFixed?.(3)
//                             : "0.000"}
//                         </td>
//                         <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                           <div>{value?.tax}%</div>
//                           <div>
//                             {value?.tax_amount
//                               ? value?.tax_amount?.toFixed?.(3)
//                               : ""}
//                           </div>
//                         </td>
//                         <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                           {value?.total ? value?.total?.toFixed?.(3) : "0.000"}
//                         </td>
//                         <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                           <button
//                             type="button"
//                             className="cursor-pointer text-xl text-red-500 hover:text-red-900"
//                             onClick={() => handleRemove(index)}
//                           >
//                             <DeleteOutlined />
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//               <div className="bg-gray-100 text-medium text-gray-500">
//                 <div className="px-4 py-1 flex justify-between text-xs">
//                   <div>Subtotal</div>
//                   <div>
//                     {totals?.subtotal > 0
//                       ? totals?.subtotal?.toFixed(3)
//                       : "0.000"}
//                   </div>
//                 </div>
//                 <div className="px-4 py-1 flex justify-between text-xs">
//                   <div>Tax amount</div>
//                   <div>
//                     {totals?.taxamount > 0
//                       ? totals?.taxamount?.toFixed(3)
//                       : "0.000"}
//                   </div>
//                 </div>
//                 <div className="px-4 pb-2 flex justify-between text-xs">
//                   <div className="my-auto">Discount</div>
//                   <div>
//                     <Input
//                       size="small"
//                       type="number"
//                       className="w-full text-regular"
//                       placeholder="Discount amount"
//                       name="discount"
//                       value={totals?.discount}
//                       autoComplete="off"
//                       onChange={handleDiscount}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="bg-white text-semi-bold">
//                 <div className="px-4 py-1 flex justify-between text-xs">
//                   <div>Total</div>
//                   <div>
//                     {totals?.total > 0 ? totals?.total?.toFixed(3) : "0.000"}
//                   </div>
//                 </div>
//               </div>
//               <div className="p-4 bg-gray-200">
//                 <div>
//                   <Select
//                     size="small"
//                     className="w-full text-regular"
//                     name="customer"
//                     showSearch
//                     allowClear
//                     placeholder="Select customer"
//                     filterOption={false}
//                     onSearch={handleCustomerSearch}
//                     onClick={() => handleCustomerSearch("")}
//                     onFocus={() => handleCustomerSearch("")}
//                     onChange={(e) => setCustomer(e)}
//                     value={customer}
//                     options={customerOptions}
//                   />
//                 </div>
//                 <div className="flex w-full pt-2">
//                   <div className="w-full">
//                     <Input
//                       size="small"
//                       className="w-full text-regular"
//                       name="name"
//                       value={customerName}
//                       placeholder="New customer name"
//                       onChange={handleCustomer}
//                       autoComplete="off"
//                     />
//                   </div>
//                   <div className="w-full pl-2">
//                     <Input
//                       size="small"
//                       className="w-full text-regular"
//                       name="phone"
//                       value={customerPhone}
//                       placeholder="New customer phone"
//                       onChange={handleCustomer}
//                       autoComplete="off"
//                     />
//                   </div>
//                   <div>
//                     <Button
//                       size="small"
//                       type="button"
//                       className="w-full text-medium text-white bg-[#07b553] hover:bg-[#14532d] mx-1"
//                       onClick={addCustomer}
//                     >
//                       ADD
//                     </Button>
//                   </div>
//                 </div>
//                 <div className="pt-2">
//                   {totals?.payment_status == 1 || totals?.payment_status == 2 ? (
//                     <div>
//                       <Select
//                         mode="multiple"
//                         className="w-full"
//                         name="payment_types"
//                         placeholder="Payment mode"
//                         value={totals?.payment_types}
//                         options={[
//                           { value: "Cash", label: "Cash" },
//                           { value: "Debit card", label: "Debit card" },
//                           { value: "Bank transfer", label: "Bank transfer" },
//                           { value: "Online payment", label: "Online payment" },
//                           { value: "Credit card", label: "Credit card" },
//                           { value: "Cheque", label: "Cheque" },
//                         ]}
//                         onChange={handlePaymentTypes}
//                       />
//                     </div>
//                   ) : (
//                     ""
//                   )}
//                   {totals?.payment_types?.map((value, index) => (
//                     <div className="pt-4" key={index}>
//                       <Input
//                         type="number"
//                         className="w-full"
//                         placeholder={value}
//                         name={value}
//                         value={totals?.payments?.[value]?.amount}
//                         onChange={handlePayments}
//                         autoComplete="off"
//                         required
//                       />
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div className="p-4 flex">
//                 <div className="pl-2 w-full">
//                   <Button
//                     htmlType="submit"
//                     type="primary"
//                     size="large"
//                     className="w-full text-medium bg-[#07b553] hover:bg-[#14532d]"
//                     disabled={buttonLoader}
//                   >
//                     {buttonLoader ? (
//                       <Spin
//                         indicator={<LoadingOutlined spin />}
//                         size="small"
//                         className="w-full text-medium bg-[#07b553]"
//                       />
//                     ) : (
//                       <>
//                         Save {" (OMR "}
//                         {totals?.total > 0
//                           ? totals?.total?.toFixed(3)
//                           : "0.000"}
//                         {") "}
//                       </>
//                     )}
//                   </Button>
//                 </div>
//               </div>
//               <div className="pt-4 mt-2 border-t-2 border-gray border-dashed">
//                 <div className="flex w-full bg-gray-200 p-4">
//                   <div className="w-full">
//                     <Input
//                       size=""
//                       className="w-full text-regular"
//                       name="customer_pay"
//                       value={customerPay}
//                       placeholder="Customer cash pay"
//                       onChange={handleCustomerPay}
//                       autoComplete="off"
//                     />
//                   </div>
//                 </div>
//                 <div className="flex justify-between w-full p-4">
//                   <div className="text-medium text-gray-500">
//                     RETURN BALANCE&nbsp;&nbsp;
//                   </div>
//                   <div className="text-medium text-gray-500">
//                     OMR&nbsp;
//                     {(parseFloat(customerPay || 0) - parseFloat(totals?.total || 0))?.toFixed(3)}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// });

// export default BillingPos;



/**
 * New pos test 2
 */


//src/App/Data/Forms/Billings/Billings/Pos.js

// import {
//   DeleteOutlined,
//   LeftOutlined,
//   LoadingOutlined,
//   RightOutlined,
//   SearchOutlined,
// } from "@ant-design/icons";
// import { Button, DatePicker, Input, Select, Spin } from "antd";
// import React, { useEffect, useRef, useState, useCallback } from "react";
// import { debounce } from "lodash";
// import Fuse from "fuse.js";
// import { useNavigate } from "react-router-dom";
// import BarcodeButton from "../../../../Componets/Buttons/barcode";
// import { select_search } from "../../../../Controllers/Global";
// import moment from "moment";
// import URL from "../../../../Main/url";
// import {
//   get_all_inventories,
//   get_inventory_barcode,
// } from "../../../../Controllers/Inventory/Batch";
// import toast from "react-hot-toast";
// import dayjs from "dayjs";
// import Modalcomponent from "../../../../Componets/Modal";
// import { create_customer } from "../../../../Controllers/Customers";
// import Loadercomponent from "../../../../Componets/Loader";

// const BillingPos = React.forwardRef((props, submitType) => {
//   const {
//     loader,
//     setLoader,
//     customer,
//     setCustomer,
//     details,
//     setDetails,
//     totals,
//     setTotals,
//     formdata,
//     buttonLoader,
//   } = props;

//   const [isFocusedProduct, setIsFocusedProduct] = useState(false);
//   const [isFocusedInventory, setIsFocusedInventory] = useState(false);
//   const [posloader, setPosLoader] = useState(false);
//   const [search, setSearch] = useState("");
//   const [options, setOptions] = useState([]);
//   const [inventoryOptions, setInventoryOptions] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [modalData, setModalData] = useState();
//   const [selectedModalData, setSelectedModalData] = useState();
//   const [customerName, setCustomerName] = useState();
//   const [customerPhone, setCustomerPhone] = useState();
//   const [customerOptions, setCustomerOptions] = useState([]);
//   const [customerPay, setCustomerPay] = useState();
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalCount: 0,
//     totalPages: 0,
//   });

//   const latestQueryRef = useRef("");

//   const normalizeQuery = (query) => {
//     return query ? query.toLowerCase().trim() : "";
//   };

//   const handleCustomerPay = (e) => {
//     setCustomerPay(e?.target?.value);
//   };

//   const handleCustomerSearch = async (e) => {
//     const select = {
//       api: "get-all-customers",
//       search: normalizeQuery(e),
//       status: 1,
//     };

//     try {
//       const search = await select_search(select);
//       console.log("handleCustomerSearch - API response:", search);
//       if (search?.status) {
//         const options = search?.data?.data?.map((value) => ({
//           value: value?._id,
//           label: (
//             <div>
//               {value?.name}
//               &nbsp;{value?.phone ? `(${value?.phone})` : ""}
//             </div>
//           ),
//         }));
//         setCustomerOptions(options);
//       } else {
//         toast?.error(search?.message || "No customers found");
//       }
//     } catch (error) {
//       console.error("handleCustomerSearch - Error:", error);
//       toast?.error("Failed to fetch customers");
//     }
//   };

//   const handleCustomer = (e) => {
//     if (e?.target?.name === "name") {
//       setCustomerName(e?.target?.value);
//     } else if (e?.target?.name === "phone") {
//       setCustomerPhone(e?.target?.value);
//     }
//   };

//   const addCustomer = async () => {
//     if (!customerPhone) {
//       toast?.error("Phone Required");
//       return;
//     }

//     let params = {
//       name: customerName,
//       phone: customerPhone,
//       status: 1,
//     };

//     try {
//       const addcustomer = await create_customer(params);
//       console.log("addCustomer - Response:", addcustomer);
//       if (addcustomer?.status) {
//         toast?.success(addcustomer?.message);
//         const newCustomer = addcustomer?.data;
//         setCustomerOptions((prevOptions) => [
//           ...prevOptions,
//           {
//             value: newCustomer._id,
//             label: `${newCustomer.name} (${newCustomer.phone || ""})`,
//           },
//         ]);
//         setCustomer(newCustomer._id);
//         setCustomerName("");
//         setCustomerPhone("");
//       } else {
//         toast?.error(addcustomer?.message || "Failed to add customer");
//       }
//     } catch (error) {
//       console.error("addCustomer - Error:", error);
//       toast?.error("Failed to add customer");
//     }
//   };

//   const handleSearch = async (query, page) => {
//     latestQueryRef.current = query;
//     setPosLoader(true);
//     setSearch(query);
//     const normalizedQuery = normalizeQuery(query);
//     const select = {
//       api: "get-all-inventories",
//       search: normalizedQuery,
//       status: 1,
//       sort: 6,
//       page: page?.currentPage || 1,
//     };

//     try {
//       const search = await select_search(select);
//       console.log("handleSearch - API response:", search);
//       if (latestQueryRef.current !== query) {
//         console.log("handleSearch - Stale query, ignoring");
//         return;
//       }

//       if (search?.status && Array.isArray(search?.data?.data)) {
//         let fetchedOptions = search.data.data;
//         console.log("handleSearch - Fetched options:", fetchedOptions);
//         if (query && fetchedOptions.length > 0) {
//           const fuse = new Fuse(fetchedOptions, {
//             keys: ["product.searchKey", "product.name"],
//             threshold: 0.8,
//             includeScore: true,
//             minMatchCharLength: 1,
//           });
//           fetchedOptions = fuse.search(normalizedQuery).map((result) => result.item);
//           console.log("handleSearch - Filtered options:", fetchedOptions);
//         }
//         setPagination({
//           currentPage: search?.data?.currentPage || 1,
//           totalCount: search?.data?.totalCount || 0,
//           totalPages: search?.data?.totalPages || 0,
//         });
//         setOptions(fetchedOptions);
//         setInventoryOptions(
//           fetchedOptions.map((item) => ({
//             value: item._id,
//             label: item.product?.name || "Unnamed Product",
//           }))
//         );
//         console.log(
//           "handleSearch - InventoryOptions:",
//           fetchedOptions.map((item) => ({
//             value: item._id,
//             label: item.product?.name || "Unnamed Product",
//           }))
//         );
//         setPosLoader(false);
//       } else {
//         console.log("handleSearch - Error:", search?.message || "No data");
//         setPosLoader(false);
//         setOptions([]);
//         setInventoryOptions([]);
//         toast?.error(search?.message || "Product not found");
//       }
//     } catch (error) {
//       console.error("handleSearch - Error:", error);
//       setPosLoader(false);
//       setOptions([]);
//       setInventoryOptions([]);
//       toast?.error("Failed to fetch products");
//     }
//   };

//   //commenting these for api driven search by faiyaz
//   // const handleSelectSearch = useCallback(
//   //   debounce((query) => {
//   //     console.log("handleSelectSearch - Query:", query);
//   //     console.log("handleSelectSearch - Current options:", options);
//   //     if (!query) {
//   //       if (Array.isArray(options)) {
//   //         const newOptions = options.map((item) => ({
//   //           value: item._id,
//   //           label: item.product?.name || "Unnamed Product",
//   //         }));
//   //         setInventoryOptions(newOptions);
//   //         console.log("handleSelectSearch - InventoryOptions (empty query):", newOptions);
//   //       } else {
//   //         setInventoryOptions([]);
//   //         console.log("handleSelectSearch - No options for empty query");
//   //       }
//   //       return;
//   //     }
//   //     const normalizedQuery = normalizeQuery(query);
//   //     if (Array.isArray(options) && options.length > 0) {
//   //       const fuse = new Fuse(options, {
//   //         keys: ["product.searchKey", "product.name"],
//   //         threshold: 0.6,
//   //         includeScore: true,
//   //         minMatchCharLength: 1,
//   //       });
//   //       const results = fuse.search(normalizedQuery).map((result) => ({
//   //         value: result.item._id,
//   //         label: result.item.product?.name || "Unnamed Product",
//   //       }));
//   //       console.log("handleSelectSearch - Fuse.js results:", results);
//   //       setInventoryOptions(results);
//   //     } else {
//   //       setInventoryOptions([]);
//   //       console.log("handleSelectSearch - No options to filter");
//   //     }
//   //   }, 300),
//   //   [options]
//   // );

//   // ✅ API-driven search instead of Fuse.js
//   const handleSelectSearch = useCallback(
//     debounce((query) => {
//       console.log("handleSelectSearch - Query:", query);
//       handleSearch(query || "");   // always call API search
//     }, 300),
//     [handleSearch]   // make sure handleSearch is in the deps
//   );

// //original code for barcode search by faiyaz
//   const handleDescriptionProductBarcode = async (e, page) => {
//     if (isFocusedProduct && e) {
//       const normalizedQuery = normalizeQuery(e);
//       setPosLoader(true);
//       setSearch(normalizedQuery);
//       const select = {
//         api: "get-all-inventories",
//         search: normalizedQuery,
//         status: 1,
//         sort: 6,
//         page: page?.currentPage || 1,
//       };
//       try {
//         const search = await select_search(select);
//         console.log("handleDescriptionProductBarcode - API response:", search);
//         if (search?.status && Array.isArray(search?.data?.data)) {
//           let fetchedOptions = search.data.data;
//           if (fetchedOptions.length > 0) {
//             handleDescription(fetchedOptions[0], details.length);
//           }
//           setPagination({
//             currentPage: search?.data?.currentPage || 1,
//             totalCount: search?.data?.totalCount || 0,
//             totalPages: search?.data?.totalPages || 0,
//           });
//           setOptions(fetchedOptions);
//           setInventoryOptions(
//             fetchedOptions.map((item) => ({
//               value: item._id,
//               label: item.product?.name || "Unnamed Product",
//             }))
//           );
//           setPosLoader(false);
//         } else {
//           setPosLoader(false);
//           toast?.error(search?.message || "Product not found");
//         }
//       } catch (error) {
//         console.error("handleDescriptionProductBarcode - Error:", error);
//         setPosLoader(false);
//         toast?.error("Failed to fetch product by barcode");
//       }
//     }
//   };



//   const handleDescriptionInventoryBarcode = async (e) => {
//     if (isFocusedInventory && e) {
//       const normalizedQuery = normalizeQuery(e);
//       let params = { barcode: normalizedQuery };
//       try {
//         const inventory = await get_inventory_barcode(params);
//         console.log("handleDescriptionInventoryBarcode - Response:", inventory);
//         if (inventory?.status) {
//           if (
//             inventory?.data?.expiry_date &&
//             new Date(new Date(inventory?.data?.expiry_date).getTime()) < new Date()
//           ) {
//             toast?.error(
//               `Inventory expired on ${moment?.(inventory?.data?.expiry_date)?.format(
//                 "DD-MM-YYYY"
//               )}`
//             );
//           } else {
//             if (inventory?.data?.inventories_units_details?.length > 0) {
//               setOpen(true);
//               let modaldata = [
//                 { ...inventory?.data, name: inventory?.data?.product?.unit?.name },
//               ];
//               inventory?.data?.inventories_units_details?.map((v) =>
//                 modaldata?.push(v)
//               );
//               setModalData(modaldata);
//               setSelectedModalData({ ...inventory.data, index: details?.length });
//             } else {
//               handleDescription(inventory.data, details?.length);
//             }
//           }
//         } else {
//           toast?.error("Inventory not found");
//         }
//       } catch (error) {
//         console.error("handleDescriptionInventoryBarcode - Error:", error);
//         toast?.error("Failed to fetch inventory by barcode");
//       }
//     }
//   };

//   const handleNext = () => {
//     let currentPage = parseInt(pagination?.currentPage) + 1;
//     if (currentPage <= parseInt(pagination?.totalPages)) {
//       let data = { ...pagination, currentPage: currentPage };
//       handleSearch(search, data);
//     }
//   };

//   const handlePrevious = () => {
//     let currentPage = parseInt(pagination?.currentPage) - 1;
//     if (currentPage > 0) {
//       let data = { ...pagination, currentPage: currentPage };
//       handleSearch(search, data);
//     }
//   };

//   const handleModal = (modaldata) => {
//     let data = [...details];
//     let inventory = selectedModalData;
//     let index = selectedModalData?.index;

//     let inventory_description = null;
//     let inventory_name = "";
//     let inventory_batch = "";
//     let inventory_expiry_date = "";
//     let inventory_price_per_unit = "";
//     let inventory_unit = "";
//     let inventory_unit_name = "";
//     let inventory_sale_price = 0;
//     let inventory_stock = 0;
//     let inventory_tax = 0;
//     let inventory_conversion = 0;
//     let inventories_units_details = [];

//     let description_ids = data?.map((v) => v?.unit);

//     if (!description_ids?.includes(modaldata)) {
//       if (inventory?._id === modaldata) {
//         inventory_description = inventory?._id;
//         inventory_name = inventory?.product?.name;
//         inventory_batch = inventory?.number;
//         inventory_expiry_date = inventory?.expiry_date;
//         inventory_price_per_unit = inventory?.price_per_unit;
//         inventory_unit = modaldata;
//         inventory_unit_name = inventory?.product?.unit?.name;
//         inventory_sale_price = inventory?.sale_price;
//         inventory_stock = inventory?.stock;
//         inventory_tax = inventory?.tax;
//         if (inventory?.inventories_units_details?.length > 0) {
//           inventory?.inventories_units_details?.map((value) => {
//             inventories_units_details?.push({
//               ...value,
//               name: value?.name,
//               purchase_price: value?.purchase_price,
//               price_per_unit: value?.price_per_unit,
//               sale_price: value?.sale_price,
//               stock: value?.stock,
//               unit_quantity: 0,
//               unit_delivered: 0,
//             });
//           });
//         }
//       } else {
//         let selected_unit = "";
//         let unit_ids = inventory?.inventories_units_details?.map((v) => v?._id);

//         if (unit_ids?.includes(modaldata)) {
//           selected_unit =
//             inventory?.inventories_units_details?.[unit_ids?.indexOf(modaldata)];
//         }

//         inventory_description = inventory?._id;
//         inventory_name = inventory?.product?.name;
//         inventory_batch = inventory?.number;
//         inventory_expiry_date = inventory?.expiry_date;
//         inventory_unit = modaldata;
//         inventory_unit_name = selected_unit?.name;
//         inventory_sale_price = selected_unit?.sale_price;
//         inventory_stock = selected_unit?.stock;
//         inventory_tax = inventory?.tax;
//         inventory_conversion = selected_unit?.conversion;
//       }

//       if (inventory_stock >= 1) {
//         let price_sale = parseFloat(inventory_sale_price || 0);
//         let price_tax =
//           parseFloat(price_sale || 0) * (parseFloat(inventory_tax || 0) / 100);
//         let price_total =
//           parseFloat(price_sale || 0) + parseFloat(price_tax || 0);

//         data?.push({
//           description: inventory_description,
//           name: inventory_name,
//           batch: inventory_batch,
//           expiry_date: inventory_expiry_date,
//           unit: inventory_unit,
//           unit_name: inventory_unit_name,
//           sale_price: price_sale,
//           stock: inventory_stock,
//           tax: inventory_tax,
//           conversion: inventory_conversion,
//           quantity: 1,
//           delivered: 1,
//           tax_amount: price_tax,
//           total: price_total,
//           unit_details_options: inventories_units_details,
//         });

//         let subtotal =
//           data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.total),
//             0
//           ) -
//           data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//             0
//           );
//         let taxamount = data?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//           0
//         );
//         let grandtotal = data?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.total),
//           0
//         );

//         totals.subtotal = subtotal;
//         totals.taxamount = taxamount;
//         totals.delivery_status = 2;
//         totals.delivery_date = new Date();
//         totals.payment_status = 2;
//         totals.payment_types = ["Cash"];
//         totals.payments = {
//           Cash: "",
//           Cheque: "",
//           "Debit card": "",
//           "Credit card": "",
//           "Bank transfer": "",
//           "Online payment": "",
//         };
//         totals.total = grandtotal;

//         setDetails(data);
//         setTotals({ ...totals });
//         setModalData(null);
//         setSelectedModalData(null);
//       } else {
//         toast?.error(`Stock only ${inventory_stock}`);
//         setModalData(null);
//         setSelectedModalData(null);
//       }
//     } else {
//       let selected_index = description_ids?.indexOf(modaldata);

//       if (
//         parseFloat(data[selected_index].quantity || 0) <
//         parseFloat(Math.floor(data[selected_index].stock) || 0)
//       ) {
//         if (
//           data?.[selected_index]?.conversion > 0 &&
//           data?.[selected_index]?.quantity + parseFloat(1) >=
//           data?.[selected_index]?.conversion
//         ) {
//           toast?.error(
//             `Quantity exceeding ${data?.[selected_index]?.conversion}`
//           );
//         } else {
//           let quantity = data[selected_index].quantity
//             ? data[selected_index].quantity
//             : 0;
//           let delivered = data[selected_index].delivered
//             ? data[selected_index].delivered
//             : 0;

//           let total_quantity = parseFloat(quantity) + parseFloat(1);

//           data[selected_index].quantity = total_quantity;
//           data[selected_index].delivered = total_quantity;

//           data[selected_index].tax_amount = data[selected_index].tax
//             ? parseFloat(data[selected_index].sale_price || 0) *
//             parseFloat(total_quantity || 0) *
//             (parseFloat(data[selected_index].tax || 0) / 100)
//             : 0;
//           data[selected_index].total =
//             parseFloat(data[selected_index].sale_price || 0) *
//             parseFloat(total_quantity) +
//             (data[selected_index].tax
//               ? parseFloat(data[selected_index].sale_price || 0) *
//               parseFloat(total_quantity || 0) *
//               (parseFloat(data[selected_index].tax || 0) / 100)
//               : 0);

//           let subtotal =
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.total),
//               0
//             ) -
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//               0
//             );
//           let taxamount = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//             0
//           );
//           let grandtotal = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.total),
//             0
//           );

//           totals.subtotal = subtotal;
//           totals.taxamount = taxamount;
//           totals.delivery_status = 2;
//           totals.delivery_date = new Date();
//           totals.payment_status = 2;
//           totals.payment_types = ["Cash"];
//           totals.payments = {
//             Cash: "",
//             Cheque: "",
//             "Debit card": "",
//             "Credit card": "",
//             "Bank transfer": "",
//             "Online payment": "",
//           };
//           totals.total = grandtotal;

//           setDetails(data);
//           setTotals({ ...totals });
//         }
//       } else {
//         toast?.error(`Stock only ${data[selected_index].stock}`);
//       }
//     }
//   };

//   const handleDescription = async (e, index) => {
//     let data = [...details];

//     if (e?._id) {
//       if (
//         e?.expiry_date &&
//         new Date(new Date(e?.expiry_date).getTime()) < new Date()
//       ) {
//         toast?.error(
//           `Inventory expired on ${moment?.(e?.expiry_date)?.format(
//             "DD-MM-YYYY"
//           )}`
//         );
//       } else {
//         if (e?.inventories_units_details?.length > 0) {
//           setOpen(true);
//           let modaldata = [
//             { ...e, name: e?.product?.unit?.name },
//           ];
//           e?.inventories_units_details?.map((v) => modaldata?.push(v));
//           setModalData(modaldata);
//           setSelectedModalData({ ...e, index: index });
//         } else {
//           if (e?.stock >= 1) {
//             let description_ids = data?.map((v) => v?.description);

//             if (!description_ids?.includes(e?._id)) {
//               let inventory_description = e?._id;
//               let inventory_name = e?.product?.name;
//               let inventory_batch = e?.number;
//               let inventory_expiry_date = e?.expiry_date;
//               let inventory_unit = e?._id;
//               let inventory_unit_name = e?.product?.unit?.name;
//               let inventory_sale_price = e?.sale_price;
//               let inventory_stock = e?.stock;
//               let inventory_tax = e?.tax;
//               let inventories_units_details = [];

//               if (e?.inventories_units_details?.length > 0) {
//                 e?.inventories_units_details?.map((value) => {
//                   inventories_units_details?.push({
//                     ...value,
//                     name: value?.name?.name,
//                     price_per_unit: 0,
//                     sale_price: "",
//                     unit_quantity: 0,
//                     unit_delivered: 0,
//                   });
//                 });
//               }

//               let price_sale = parseFloat(inventory_sale_price || 0);
//               let price_tax =
//                 parseFloat(price_sale || 0) *
//                 (parseFloat(inventory_tax || 0) / 100);
//               let price_total =
//                 parseFloat(price_sale || 0) + parseFloat(price_tax || 0);

//               data?.push({
//                 description: inventory_description,
//                 name: inventory_name,
//                 batch: inventory_batch,
//                 expiry_date: inventory_expiry_date,
//                 unit: inventory_unit,
//                 unit_name: inventory_unit_name,
//                 sale_price: price_sale,
//                 stock: inventory_stock,
//                 tax: inventory_tax,
//                 quantity: 1,
//                 delivered: 1,
//                 tax_amount: price_tax,
//                 total: price_total,
//                 unit_details_options: inventories_units_details,
//               });

//               let subtotal =
//                 data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.total),
//                   0
//                 ) -
//                 data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                   0
//                 );
//               let taxamount = data?.reduce(
//                 (acc, currentValue) =>
//                   parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                 0
//               );
//               let grandtotal = data?.reduce(
//                 (acc, currentValue) =>
//                   parseFloat(acc) + parseFloat(currentValue?.total),
//                 0
//               );

//               totals.subtotal = subtotal;
//               totals.taxamount = taxamount;
//               totals.delivery_status = 2;
//               totals.delivery_date = new Date();
//               totals.payment_status = 2;
//               totals.payment_types = ["Cash"];
//               totals.payments = {
//                 Cash: "",
//                 Cheque: "",
//                 "Debit card": "",
//                 "Credit card": "",
//                 "Bank transfer": "",
//                 "Online payment": "",
//               };
//               totals.total = grandtotal;

//               setDetails(data);
//               setTotals({ ...totals });
//             } else {
//               let selected_index = description_ids?.indexOf(e?._id);

//               if (
//                 parseFloat(data[selected_index].quantity || 0) <
//                 parseFloat(data[selected_index].stock || 0)
//               ) {
//                 let quantity = data[selected_index].quantity
//                   ? data[selected_index].quantity
//                   : 0;
//                 let delivered = data[selected_index].delivered
//                   ? data[selected_index].delivered
//                   : 0;
//                 let total_quantity = parseFloat(quantity) + parseFloat(1);

//                 data[selected_index].quantity = total_quantity;
//                 data[selected_index].delivered = total_quantity;
//                 data[selected_index].tax_amount = data[selected_index].tax
//                   ? parseFloat(data[selected_index].sale_price || 0) *
//                   parseFloat(total_quantity || 0) *
//                   (parseFloat(data[selected_index].tax || 0) / 100)
//                   : 0;
//                 data[selected_index].total =
//                   parseFloat(data[selected_index].sale_price || 0) *
//                   parseFloat(total_quantity) +
//                   (data[selected_index].tax
//                     ? parseFloat(data[selected_index].sale_price || 0) *
//                     parseFloat(total_quantity || 0) *
//                     (parseFloat(data[selected_index].tax || 0) / 100)
//                     : 0);

//                 let subtotal =
//                   data?.reduce(
//                     (acc, currentValue) =>
//                       parseFloat(acc) + parseFloat(currentValue?.total),
//                     0
//                   ) -
//                   data?.reduce(
//                     (acc, currentValue) =>
//                       parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                     0
//                   );
//                 let taxamount = data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//                   0
//                 );
//                 let grandtotal = data?.reduce(
//                   (acc, currentValue) =>
//                     parseFloat(acc) + parseFloat(currentValue?.total),
//                   0
//                 );

//                 totals.subtotal = subtotal;
//                 totals.taxamount = taxamount;
//                 totals.delivery_status = 2;
//                 totals.delivery_date = new Date();
//                 totals.payment_status = 2;
//                 totals.payment_types = ["Cash"];
//                 totals.payments = {
//                   Cash: "",
//                   Cheque: "",
//                   "Debit card": "",
//                   "Credit card": "",
//                   "Bank transfer": "",
//                   "Online payment": "",
//                 };
//                 totals.total = grandtotal;

//                 setDetails(data);
//                 setTotals({ ...totals });
//               } else {
//                 toast?.error(`Stock only ${data[selected_index].stock}`);
//               }
//             }
//           } else {
//             toast?.error(`Stock only ${e?.stock}`);
//           }
//         }
//       }
//     } else {
//       data[index].id = "";
//       data[index].description = null;
//       data[index].name = "";
//       data[index].batch = "";
//       data[index].expiry_date = "";
//       data[index].unit = "";
//       data[index].unit_name = "";
//       data[index].unit_details_options = null;
//       data[index].quantity = "";
//       data[index].conversion = 0;
//       data[index].purchase = "";
//       data[index].sale_price = "";
//       data[index].purchase_options = null;
//       data[index].delivered = "";
//       data[index].tax = 0;
//       data[index].free = "";
//       data[index].barcode = "";
//       data[index].price_per_unit = "";
//       data[index].sale_price = "";
//       data[index].expiry_date = "";
//       data[index].tax_amount = "0.000";
//       data[index].total = 0;
//       setDetails(data);
//     }
//   };

//   const handlePurchase = (e, index, key) => {
//     if (e) {
//       let event = {
//         target: {
//           name: "sale_price",
//           value: JSON?.parse(e)?.sale_price,
//         },
//       };
//       handleTotal(event, index, "sale_price");
//       handleTotal(JSON?.parse(e)?.tax, index, "tax");
//     }
//   };

//   const handleDelivered = (e, index) => {
//     if (e?.target?.value >= 0) {
//       let data = [...details];
//       let data_quantity = data[index]?.quantity
//         ? parseFloat(data[index]?.quantity)
//         : 0;
//       let data_delivered = e?.target?.value ? parseFloat(e?.target?.value) : 0;

//       if (data_delivered <= data_quantity) {
//         data[index][e?.target?.name] = e?.target?.value;
//         setDetails(data);
//       } else {
//         toast?.error(`Quantity only ${data_quantity}`);
//       }
//     }
//   };

//   const handleTotal = (e, index, key) => {
//     let name = key ? key : e?.target?.name;
//     let value = key && e ? e : e?.target?.value ? e?.target?.value : "";

//     if (value >= 0) {
//       let data = [...details];

//       if (value <= data[index]?.stock) {
//         let data_sale_price = data[index]?.sale_price
//           ? data[index]?.sale_price
//           : 0;
//         let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
//         let data_delivered = data[index]?.delivered ? data[index]?.delivered : 0;
//         let data_free = data[index]?.free ? data[index]?.free : 0;
//         let data_tax = data[index]?.tax ? data[index]?.tax : 0;
//         let data_conversion = data[index].conversion
//           ? data[index].conversion
//           : 0;

//         let sale_price = name === "sale_price" ? value : data_sale_price;
//         let quantity = name === "quantity" ? value : data_quantity;
//         let delivered = name === "quantity" ? value : data_delivered;
//         let free = name === "free" ? value : data_free;
//         let tax = name === "tax" ? value : data_tax;

//         let tax_amount = tax
//           ? parseFloat(sale_price) *
//           parseFloat(quantity ? quantity : 0) *
//           (parseFloat(tax) / 100)
//           : 0;

//         let total =
//           parseFloat(sale_price) * parseFloat(quantity ? quantity : 0) +
//           parseFloat(tax_amount);

//         let price_per_unit =
//           parseFloat(total ? total : 0) /
//           (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

//         let unit_details_options = [];
//         if (data?.[index]?.unit_details_options?.length > 0) {
//           data?.[index]?.unit_details_options?.map((v) => {
//             let total_quantity =
//               parseFloat(quantity || 0) + parseFloat(free || 0);

//             unit_details_options?.push({
//               ...v,
//               price_per_unit: price_per_unit
//                 ? parseFloat(price_per_unit || 0) / parseFloat(v?.conversion || 0)
//                 : 0,
//               unit_quantity: quantity
//                 ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
//                 : 0,
//               unit_delivered: delivered
//                 ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
//                 : 0,
//             });
//           });
//         }

//         if (
//           data_conversion > 0 &&
//           parseFloat(quantity) + parseFloat(free) >= data_conversion
//         ) {
//           toast?.error(`Quantity exceeding ${data[index].conversion}`);
//         } else {
//           data[index][name] = value;
//           data[index].unit_details_options = unit_details_options;
//           data[index].delivered = delivered ? delivered : "";
//           data[index].tax = tax ? tax : 0;
//           data[index].total = total ? total : 0;
//           data[index].tax_amount = tax_amount ? tax_amount : "0.000";
//           data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

//           let subtotal =
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.total),
//               0
//             ) -
//             data?.reduce(
//               (acc, currentValue) =>
//                 parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//               0
//             );

//           let taxamount = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//             0
//           );

//           let grandtotal = data?.reduce(
//             (acc, currentValue) =>
//               parseFloat(acc) + parseFloat(currentValue?.total),
//             0
//           );

//           totals.discount = "";
//           totals.delivery = "";
//           totals.subtotal = subtotal;
//           totals.taxamount = taxamount;
//           totals.delivery_status = 2;
//           totals.delivery_date = new Date();
//           totals.payment_status = 2;
//           totals.payment_types = ["Cash"];
//           totals.payments = {
//             Cash: "",
//             Cheque: "",
//             "Debit card": "",
//             "Credit card": "",
//             "Bank transfer": "",
//             "Online payment": "",
//           };
//           totals.total = grandtotal;

//           setDetails(data);
//           setTotals({ ...totals });
//         }
//       } else {
//         toast?.error(`Stock only ${data[index]?.stock}`);
//       }
//     }
//   };

//   const handleRemove = (index) => {
//     let data = [...details];
//     data?.splice(index, 1);

//     let subtotal =
//       data?.reduce(
//         (acc, currentValue) =>
//           parseFloat(acc) + parseFloat(currentValue?.total),
//         0
//       ) -
//       data?.reduce(
//         (acc, currentValue) =>
//           parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//         0
//       );

//     let taxamount = data?.reduce(
//       (acc, currentValue) =>
//         parseFloat(acc) + parseFloat(currentValue?.tax_amount),
//       0
//     );

//     let grandtotal = data?.reduce(
//       (acc, currentValue) =>
//         parseFloat(acc) + parseFloat(currentValue?.total),
//       0
//     );

//     totals.discount = "";
//     totals.delivery = "";
//     totals.subtotal = subtotal;
//     totals.taxamount = taxamount;
//     totals.delivery_status = 2;
//     totals.delivery_date = new Date();
//     totals.payment_status = 2;
//     totals.payment_types = ["Cash"];
//     totals.payments = {
//       Cash: "",
//       Cheque: "",
//       "Debit card": "",
//       "Credit card": "",
//       "Bank transfer": "",
//       "Online payment": "",
//     };
//     totals.total = grandtotal;

//     setDetails(data);
//     setTotals({ ...totals });
//   };

//   const handleAdd = (e) => {
//     if (e) {
//       setDetails((prevDetails) => [
//         ...prevDetails,
//         {
//           id: "",
//           description: null,
//           unit: "",
//           sale_price: "",
//           quantity: "",
//           delivered: "",
//           free: "",
//           tax: 0,
//           total: 0,
//         },
//       ]);
//       handleDescription(e, details?.length + 1);
//     }
//   };

//   const handleDelivery = (e) => {
//     if (e?.target?.value >= 0) {
//       let total_amount = parseFloat(
//         details?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.total),
//           0
//         )
//       );

//       let total =
//         parseFloat(total_amount ? total_amount : 0) +
//         parseFloat(e?.target?.value ? e?.target?.value : 0) -
//         parseFloat(totals?.discount ? totals?.discount : 0);

//       totals.delivery = e?.target?.value;
//       totals.total = total;

//       setTotals({ ...totals });
//     }
//   };

//   const handleDiscount = (e) => {
//     if (e?.target?.value >= 0) {
//       let total_amount = parseFloat(
//         details?.reduce(
//           (acc, currentValue) =>
//             parseFloat(acc) + parseFloat(currentValue?.total),
//           0
//         )
//       );

//       let total =
//         parseFloat(total_amount ? total_amount : 0) +
//         parseFloat(totals?.delivery ? totals?.delivery : 0) -
//         parseFloat(e?.target?.value ? e?.target?.value : 0);

//       if (e?.target?.value <= total_amount) {
//         totals.discount = e?.target?.value;
//         totals.total = total;
//       } else {
//         toast?.error(`Discount exceeding`);
//       }

//       setTotals({ ...totals });
//     }
//   };

//   const handleDeliveryStatus = (e) => {
//     totals.delivery_status = e;
//     if (!e || e === 1) {
//       totals.delivery_date = "";
//     }
//     setTotals({ ...totals });
//   };

//   const handleDeliveryDate = (e) => {
//     totals.delivery_date = e?.$d;
//     setTotals({ ...totals });
//   };

//   const handlePaymentStatus = (e) => {
//     totals.payment_status = e;
//     if (!e) {
//       totals.payment_types = null;
//     }
//     setTotals({ ...totals });
//   };

//   const handlePaymentTypes = (e) => {
//     totals?.payment_types?.map((v) => {
//       if (!e?.includes(v)) {
//         totals.payments[v] = "";
//       }
//     });
//     totals.payment_types = e;
//     setTotals({ ...totals });
//   };

//   const handlePayments = (e) => {
//     let name = e?.target?.name;
//     let value = e?.target?.value ? e?.target?.value : "";

//     if (e?.target?.value >= 0) {
//       let data_Cash = totals?.payments?.Cash?.amount || 0;
//       let data_Cheque = totals?.payments?.Cheque?.amount || 0;
//       let data_Debitcard = totals?.payments?.["Debit card"]?.amount || 0;
//       let data_Creditcard = totals?.payments?.["Credit card"]?.amount || 0;
//       let data_Banktransfer = totals?.payments?.["Bank transfer"]?.amount || 0;
//       let data_Onlinepayment = totals?.payments?.["Online payment"]?.amount || 0;

//       let Cash = name === "Cash" ? value : data_Cash;
//       let Cheque = name === "Cheque" ? value : data_Cheque;
//       let Debitcard = name === "Debit card" ? value : data_Debitcard;
//       let Creditcard = name === "Credit card" ? value : data_Creditcard;
//       let Banktransfer = name === "Bank transfer" ? value : data_Banktransfer;
//       let Onlinepayment = name === "Online payment" ? value : data_Onlinepayment;

//       let total =
//         parseFloat(Cash) +
//         parseFloat(Cheque) +
//         parseFloat(Debitcard) +
//         parseFloat(Creditcard) +
//         parseFloat(Banktransfer) +
//         parseFloat(Onlinepayment);

//       let payment_total = total ? parseFloat(total)?.toFixed(3) : 0;
//       let grand_total = totals?.total ? parseFloat(totals?.total)?.toFixed(3) : 0;

//       if (parseFloat(payment_total) <= parseFloat(grand_total)) {
//         totals.payments[name] = { ...totals.payments[name], amount: value };
//         setTotals({ ...totals });
//       } else {
//         toast?.error(`Total only ${grand_total}`);
//       }
//     }
//   };

//   const handleSubmit = (e) => {
//     e?.preventDefault();
//     const data = { status: true };
//     formdata(data);
//   };

//   const fetchData = () => {
//     handleSearch("");
//   };

//   const barcodeInputRefProduct = useRef("");
//   const handleKeyDownProduct = (event) => {
//     const ignoredKeys = [
//       "Shift",
//       "Control",
//       "Alt",
//       "Meta",
//       "ArrowUp",
//       "ArrowDown",
//       "ArrowLeft",
//       "ArrowRight",
//       "CapsLock",
//     ];
//     const validKey = /^[a-zA-Z0-9]$/;

//     if (event.key === "Enter") {
//       const barcode = barcodeInputRefProduct.current.trim();
//       if (barcode) {
//         handleDescriptionProductBarcode(barcode);
//       }
//       barcodeInputRefProduct.current = "";
//     } else if (!ignoredKeys.includes(event.key) && validKey.test(event.key)) {
//       barcodeInputRefProduct.current += event.key;
//     }
//   };

//   const barcodeInputRefInventory = useRef("");
//   const handleKeyDownInventory = (event) => {
//     const ignoredKeys = [
//       "Shift",
//       "Control",
//       "Alt",
//       "Meta",
//       "ArrowUp",
//       "ArrowDown",
//       "ArrowLeft",
//       "ArrowRight",
//       "CapsLock",
//     ];
//     const validKey = /^[a-zA-Z0-9]$/;

//     if (event.key === "Enter") {
//       const barcode = barcodeInputRefInventory.current.trim();
//       if (barcode) {
//         handleDescriptionInventoryBarcode(barcode);
//       }
//       barcodeInputRefInventory.current = "";
//     } else if (!ignoredKeys.includes(event.key) && validKey.test(event.key)) {
//       barcodeInputRefInventory.current += event.key;
//     }
//   };

//   const debouncedSearch = useCallback(
//     debounce((query) => handleSearch(query, { currentPage: 1 }), 500),
//     []
//   );

//   const handleInputChange = (e) => {
//     debouncedSearch(e.target.value);
//   };

//   const handleOnKeyDown = (event) => {
//     if (event.key === "Enter") {
//       event.preventDefault();
//     }
//   };

//   useEffect(() => {
//     console.log("Initial fetch triggered");
//     fetchData();
//   }, []);

//   useEffect(() => {
//     console.log("posloader state:", posloader);
//     console.log("Options state:", options);
//     console.log("InventoryOptions state:", inventoryOptions);
//   }, [posloader, options, inventoryOptions]);

//   const formRef = useRef(null);

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "F4") {
//         e.preventDefault();
//         submitType.current = "print";
//         if (formRef.current) {
//           formRef.current.requestSubmit();
//         }
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, []);

//   return (
//     <div>
//       <Modalcomponent
//         open={open}
//         setOpen={setOpen}
//         modalData={modalData}
//         setModalData={setModalData}
//         selectedModalData={selectedModalData}
//         setSelectedModalData={setSelectedModalData}
//         handleModal={handleModal}
//       />
//       <form ref={formRef} onSubmit={handleSubmit}>
//         <div className="p-4">
//           <div className="flex justify-between">
//             <div className="w-[49%] rounded-md">
//               <div className="p-4 flex justify-between bg-white rounded-tl-md rounded-tr-md">
//                 <div className="w-2/3 pr-8">
//                   <div className="flex">
//                     <div className="pr-3">
//                       <BarcodeButton
//                         name="product"
//                         tabIndex={0}
//                         onKeyDown={handleKeyDownProduct}
//                         isFocusedProduct={isFocusedProduct}
//                         setIsFocusedProduct={setIsFocusedProduct}
//                       />
//                     </div>
//                     <div className="w-full">
//                       {/* <Select
//                         className="w-full text-regular"
//                         name="description"
//                         placeholder="Search Products"
//                         allowClear
//                         showSearch
//                         options={inventoryOptions}
//                         // onSearch={handleSelectSearch}
//                         onSearch={(value) => handleSearch(value)}
//                         onFocus={() => handleSearch("")} 
//                         onChange={(value) => {
//                           const selected = options.find((item) => item._id === value);
//                           if (selected) handleDescription(selected, details.length);
//                         }}
//                         autoComplete="off"
//                         loading={posloader}
//                         disabled={posloader}
//                       /> */}

//                       <Select
//                         className="w-full text-regular"
//                         name="description"
//                         placeholder="Search Products"
//                         allowClear
//                         showSearch
//                         filterOption={false}   // ✅ must be false to use remote search
//                         options={inventoryOptions}
//                         onSearch={handleSelectSearch}   // ✅ debounce + API
//                         onFocus={() => handleSearch("")} // ✅ load default list when focused
//                         onChange={(value) => {
//                           const selected = options.find((item) => item._id === value);
//                           if (selected) handleDescription(selected, details.length);
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div>
//                   <BarcodeButton
//                     name="inventory"
//                     onKeyDown={handleKeyDownInventory}
//                     isFocusedInventory={isFocusedInventory}
//                     setIsFocusedInventory={setIsFocusedInventory}
//                   />
//                 </div>
//               </div>
//               <div className="bg-white h-[60vh]" style={{ overflowX: "auto" }}>
//                 <Loadercomponent loader={posloader}>
//                   <div className="mx-2">
//                     <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 grid-cols-5 gap-3">
//                       {options?.map((value, index) => (
//                         <button
//                           type="button"
//                           key={index}
//                           className="border cursor-pointer p-3 hover:bg-gray-100 rounded-lg flex flex-col min-h-[8vw]"
//                           onClick={() => handleDescription(value)}
//                         >
//                           <div className="text-center pt-2 flex-grow">
//                             <div className="text-[0.70rem] text-medium break-words leading-tight">
//                               {value?.product?.name}
//                             </div>
//                             <div className="text-[0.50rem] text-gray-500">
//                               #BATCH-{value?.number}
//                               <div className="text-xs text-green-500 font-medium">
//                                 Stock&nbsp;(
//                                 {value?.stock
//                                   ? Number.isInteger(value?.stock)
//                                     ? parseFloat(value?.stock || 0)
//                                     : parseFloat(value?.stock || 0)?.toFixed(3)
//                                   : "0"}
//                                 )
//                               </div>
//                             </div>
//                             <div className="text-[0.50rem] text-gray-500">
//                               EXP :&nbsp;
//                               {value?.expiry_date
//                                 ? moment(value?.expiry_date).format("DD-MM-YYYY")
//                                 : "N/A"}
//                             </div>
//                           </div>
//                           <div className="text-center text-[0.50rem] text-gray-500">
//                             <div>{value?.tax ? `VAT ${value?.tax}%` : ""}</div>
//                           </div>
//                           <div className="border text-medium text-xs rounded-md text-center text-green-500 font-medium mt-auto">
//                             OMR {parseFloat(value?.sale_price)?.toFixed(3)}
//                           </div>
//                         </button>
//                       ))}
//                     </div>
//                   </div>
//                 </Loadercomponent>
//               </div>
//               <div className="p-4 flex justify-between text-gray-600 text-sm text-medium">
//                 <div>
//                   <span className="pr-3">TOTAL</span>
//                   <span className="pl-5">
//                     {pagination?.currentPage > 1
//                       ? parseInt(pagination?.currentPage || 0) - 1
//                       : 1}
//                     {pagination?.currentPage > 1 ? 1 : ""} -{" "}
//                     {pagination?.currentPage}0 OF {pagination?.totalCount}
//                   </span>
//                 </div>
//                 <div className="flex">
//                   <div
//                     type="button"
//                     className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553]"
//                     onClick={handlePrevious}
//                   >
//                     <div className="text-center text-xs text-gray-900">
//                       <LeftOutlined />
//                     </div>
//                   </div>
//                   <span className="px-3 pt-1">
//                     {pagination?.currentPage} OUT OF {pagination?.totalPages}
//                   </span>
//                   <div
//                     type="button"
//                     className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553]"
//                     onClick={handleNext}
//                   >
//                     <div className="text-center text-xs text-gray-600">
//                       <RightOutlined />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="p-10 flex justify-between bg-white rounded-bl-md rounded-br-md" />
//             </div>
//             <div className="bg-white w-[49%] rounded-md">
//               <div className="p-4 flex justify-center">
//                 <div className="p-1 text-semi-bold">CHECKOUT</div>
//               </div>
//               <div className="h-[35vh]" style={{ overflowY: "auto" }}>
//                 <table className="w-full">
//                   <thead className="bg-gray-100 text-gray-500 text-xs text-medium">
//                     <tr>
//                       <td className="p-1 border-r">SNO</td>
//                       <td className="p-1 border-r">NAME</td>
//                       <td className="p-1 border-r">UNIT</td>
//                       <td className="p-1 border-r">QUANTITY</td>
//                       <td className="p-1 border-r">PRICE</td>
//                       <td className="p-1 border-r">TAX</td>
//                       <td className="p-1 border-r">TOTAL</td>
//                       <td className="p-1 text-center">DELETE</td>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details?.map((value, index) => (
//                       <tr className="border-b text-xs" key={index}>
//                         <td className="p-1 border-r">{index + 1}</td>
//                         <td className="p-1 border-r">
//                           <div className="text-[0.70rem] text-medium">
//                             {value?.name}
//                           </div>
//                           <div className="text-[0.50rem] text-gray-500">
//                             <div>{`#BATCH-${value?.batch}`}</div>
//                             <div className="text-[0.50rem]">
//                               {value?.expiry_date
//                                 ? `EXPIRY : ${moment(value?.expiry_date).format(
//                                   "DD-MM-YYYY"
//                                 )}`
//                                 : ""}
//                             </div>
//                           </div>
//                         </td>
//                         <td className="p-1 border-r text-[0.65rem] text-medium">
//                           {value?.unit_name}
//                         </td>
//                         <td className="p-1 border-r">
//                           <div className="text-green-500 text-[0.60rem] text-medium">
//                             Stock&nbsp;(
//                             {value?.stock
//                               ? Number.isInteger(value?.stock)
//                                 ? parseFloat(value?.stock || 0)
//                                 : parseFloat(value?.stock || 0)?.toFixed(3)
//                               : "0"}
//                             )
//                           </div>
//                           <Input
//                             type="number"
//                             className="text-xs"
//                             name="quantity"
//                             placeholder="Quantity"
//                             value={value?.quantity}
//                             onChange={(e) => handleTotal(e, index)}
//                             onKeyDown={handleOnKeyDown}
//                             autoComplete="off"
//                             required
//                           />
//                         </td>
//                         <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                           {value?.sale_price
//                             ? value?.sale_price?.toFixed?.(3)
//                             : "0.000"}
//                         </td>
//                         <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                           <div>{value?.tax}%</div>
//                           <div>
//                             {value?.tax_amount
//                               ? value?.tax_amount?.toFixed?.(3)
//                               : ""}
//                           </div>
//                         </td>
//                         <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                           {value?.total ? value?.total?.toFixed?.(3) : "0.000"}
//                         </td>
//                         <td className="p-1 text-center text-[0.60rem] text-medium border-r">
//                           <button
//                             type="button"
//                             className="cursor-pointer text-xl text-red-500 hover:text-red-900"
//                             onClick={() => handleRemove(index)}
//                           >
//                             <DeleteOutlined />
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//               <div className="bg-gray-100 text-medium text-gray-500">
//                 <div className="px-4 py-1 flex justify-between text-xs">
//                   <div>Subtotal</div>
//                   <div>
//                     {totals?.subtotal > 0
//                       ? totals?.subtotal?.toFixed(3)
//                       : "0.000"}
//                   </div>
//                 </div>
//                 <div className="px-4 py-1 flex justify-between text-xs">
//                   <div>Tax amount</div>
//                   <div>
//                     {totals?.taxamount > 0
//                       ? totals?.taxamount?.toFixed(3)
//                       : "0.000"}
//                   </div>
//                 </div>
//                 <div className="px-4 pb-2 flex justify-between text-xs">
//                   <div className="my-auto">Discount</div>
//                   <div>
//                     <Input
//                       size="small"
//                       type="number"
//                       className="w-full text-regular"
//                       placeholder="Discount amount"
//                       name="discount"
//                       value={totals?.discount}
//                       autoComplete="off"
//                       onChange={handleDiscount}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="bg-white text-semi-bold">
//                 <div className="px-4 py-1 flex justify-between text-xs">
//                   <div>Total</div>
//                   <div>
//                     {totals?.total > 0 ? totals?.total?.toFixed(3) : "0.000"}
//                   </div>
//                 </div>
//               </div>
//               <div className="p-4 bg-gray-200">
//                 <div>
//                   <Select
//                     size="small"
//                     className="w-full text-regular"
//                     name="customer"
//                     showSearch
//                     allowClear
//                     placeholder="Select customer"
//                     filterOption={false}
//                     onSearch={handleCustomerSearch}
//                     onClick={() => handleCustomerSearch("")}
//                     onFocus={() => handleCustomerSearch("")}
//                     onChange={(e) => setCustomer(e)}
//                     value={customer}
//                     options={customerOptions}
//                   />
//                 </div>
//                 <div className="flex w-full pt-2">
//                   <div className="w-full">
//                     <Input
//                       size="small"
//                       className="w-full text-regular"
//                       name="name"
//                       value={customerName}
//                       placeholder="New customer name"
//                       onChange={handleCustomer}
//                       autoComplete="off"
//                     />
//                   </div>
//                   <div className="w-full pl-2">
//                     <Input
//                       size="small"
//                       className="w-full text-regular"
//                       name="phone"
//                       value={customerPhone}
//                       placeholder="New customer phone"
//                       onChange={handleCustomer}
//                       autoComplete="off"
//                     />
//                   </div>
//                   <div>
//                     <Button
//                       size="small"
//                       type="button"
//                       className="w-full text-medium text-white bg-[#07b553] hover:bg-[#14532d] mx-1"
//                       onClick={addCustomer}
//                     >
//                       ADD
//                     </Button>
//                   </div>
//                 </div>
//                 <div className="pt-2">
//                   {totals?.payment_status == 1 || totals?.payment_status == 2 ? (
//                     <div>
//                       <Select
//                         mode="multiple"
//                         className="w-full"
//                         name="payment_types"
//                         placeholder="Payment mode"
//                         value={totals?.payment_types}
//                         options={[
//                           { value: "Cash", label: "Cash" },
//                           { value: "Debit card", label: "Debit card" },
//                           { value: "Bank transfer", label: "Bank transfer" },
//                           { value: "Online payment", label: "Online payment" },
//                           { value: "Credit card", label: "Credit card" },
//                           { value: "Cheque", label: "Cheque" },
//                         ]}
//                         onChange={handlePaymentTypes}
//                       />
//                     </div>
//                   ) : (
//                     ""
//                   )}
//                   {totals?.payment_types?.map((value, index) => (
//                     <div className="pt-4" key={index}>
//                       <Input
//                         type="number"
//                         className="w-full"
//                         placeholder={value}
//                         name={value}
//                         value={totals?.payments?.[value]?.amount}
//                         onChange={handlePayments}
//                         autoComplete="off"
//                         // required
//                       />
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div className="p-4 flex">
//                 <div className="pl-2 w-full">
//                   <Button
//                     htmlType="submit"
//                     type="primary"
//                     size="large"
//                     className="w-full text-medium bg-[#07b553] hover:bg-[#14532d]"
//                     disabled={buttonLoader}
//                   >
//                     {buttonLoader ? (
//                       <Spin
//                         indicator={<LoadingOutlined spin />}
//                         size="small"
//                         className="w-full text-medium bg-[#07b553]"
//                       />
//                     ) : (
//                       <>
//                         Save {" (OMR "}
//                         {totals?.total > 0
//                           ? totals?.total?.toFixed(3)
//                           : "0.000"}
//                         {") "}
//                       </>
//                     )}
//                   </Button>
//                 </div>
//               </div>
//               <div className="pt-4 mt-2 border-t-2 border-gray border-dashed">
//                 <div className="flex w-full bg-gray-200 p-4">
//                   <div className="w-full">
//                     <Input
//                       size=""
//                       className="w-full text-regular"
//                       name="customer_pay"
//                       value={customerPay}
//                       placeholder="Customer cash pay"
//                       onChange={handleCustomerPay}
//                       autoComplete="off"
//                     />
//                   </div>
//                 </div>
//                 <div className="flex justify-between w-full p-4">
//                   <div className="text-medium text-gray-500">
//                     RETURN BALANCE&nbsp;&nbsp;
//                   </div>
//                   <div className="text-medium text-gray-500">
//                     OMR&nbsp;
//                     {(parseFloat(customerPay || 0) - parseFloat(totals?.total || 0))?.toFixed(3)}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// });

// export default BillingPos;


/**
 * New Version of POS V4
 */

import {
  DeleteOutlined,
  LeftOutlined,
  LoadingOutlined,
  RightOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Button, DatePicker, Input, Select, Spin } from "antd";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { debounce } from "lodash";
import Fuse from "fuse.js";
import { useNavigate } from "react-router-dom";
import BarcodeButton from "../../../../Componets/Buttons/barcode";
import { select_search } from "../../../../Controllers/Global";
import moment from "moment";
import URL from "../../../../Main/url";
import {
  get_all_inventories,
  get_inventory_barcode,
} from "../../../../Controllers/Inventory/Batch";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import Modalcomponent from "../../../../Componets/Modal";
import { create_customer } from "../../../../Controllers/Customers";
import Loadercomponent from "../../../../Componets/Loader";
import formatDateDDMMYYYY from "../../../../Main/formatDate";

const BillingPos = React.forwardRef((props, submitType) => {
  const {
    loader,
    setLoader,
    customer,
    setCustomer,
    details,
    setDetails,
    totals,
    setTotals,
    formdata,
    buttonLoader,
  } = props;

  const [isFocusedProduct, setIsFocusedProduct] = useState(false);
  const [isFocusedInventory, setIsFocusedInventory] = useState(false);
  const [posloader, setPosLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [options, setOptions] = useState([]);
  const [inventoryOptions, setInventoryOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [selectedModalData, setSelectedModalData] = useState();
  const [customerName, setCustomerName] = useState();
  const [customerPhone, setCustomerPhone] = useState();
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerPay, setCustomerPay] = useState();
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const latestQueryRef = useRef("");
  const barcodeInputRefProduct = useRef("");
  const barcodeInputRefInventory = useRef("");
  const navigate = useNavigate();

  const normalizeQuery = (query) => {
    return query ? query.toLowerCase().trim() : "";
  };

  const handleKeyDownSearch = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const barcode = search.trim();
      if (barcode) {
        console.log("handleKeyDownSearch - Barcode scanned:", barcode);
        handleDescriptionProductBarcode(barcode);
      }
    }
  };

  const handleInputChange = (e) => {
    const query = e.target.value;
    setSearch(query);
    debouncedSearch(query);
  };

  const handleKeyDownProduct = (event) => {
    const ignoredKeys = [
      "Shift",
      "Control",
      "Alt",
      "Meta",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "CapsLock",
    ];
    const validKey = /^[a-zA-Z0-9]$/;
    if (event.key === "Enter") {
      const barcode = barcodeInputRefProduct.current.trim();
      if (barcode) {
        handleDescriptionProductBarcode(barcode);
      }
      barcodeInputRefProduct.current = "";
    } else if (!ignoredKeys.includes(event.key) && validKey.test(event.key)) {
      barcodeInputRefProduct.current += event.key;
    }
  };

  const handleKeyDownInventory = (event) => {
    const ignoredKeys = [
      "Shift",
      "Control",
      "Alt",
      "Meta",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "CapsLock",
    ];
    const validKey = /^[a-zA-Z0-9]$/;
    if (event.key === "Enter") {
      const barcode = barcodeInputRefInventory.current.trim();
      if (barcode) {
        handleDescriptionInventoryBarcode(barcode);
      }
      barcodeInputRefInventory.current = "";
    } else if (!ignoredKeys.includes(event.key) && validKey.test(event.key)) {
      barcodeInputRefInventory.current += event.key;
    }
  };

  const debouncedSearch = useCallback(
    debounce((query) => handleSearch(query, { currentPage: 1 }), 500),
    []
  );

  const handleCustomerPay = (e) => {
    const value = e?.target?.value ? parseFloat(e?.target?.value) : 0;
    if (!isNaN(value) && value >= 0) {
      setCustomerPay(value);
    } else {
      setCustomerPay(0);
      toast?.error("Invalid customer cash payment amount");
    }
  };

  const handleCustomerSearch = async (e) => {
    const select = {
      api: "get-all-customers",
      search: normalizeQuery(e),
      status: 1,
    };
    try {
      const search = await select_search(select);
      console.log("handleCustomerSearch - API response:", search);
      if (search?.status) {
        const options = search?.data?.data?.map((value) => ({
          value: value?._id,
          label: (
            <div>
              {value?.name}
              &nbsp;{value?.phone ? `(${value?.phone})` : ""}
            </div>
          ),
        }));
        setCustomerOptions(options);
      } else {
        toast?.error(search?.message || "No customers found");
      }
    } catch (error) {
      console.error("handleCustomerSearch - Error:", error);
      toast?.error("Failed to fetch customers");
    }
  };

  const handleCustomer = (e) => {
    if (e?.target?.name === "name") {
      setCustomerName(e?.target?.value);
    } else if (e?.target?.name === "phone") {
      setCustomerPhone(e?.target?.value);
    }
  };

  const addCustomer = async () => {
    if (!customerPhone) {
      toast?.error("Phone Required");
      return;
    }
    let params = {
      name: customerName,
      phone: customerPhone,
      status: 1,
    };
    try {
      const addcustomer = await create_customer(params);
      console.log("addCustomer - Response:", addcustomer);
      if (addcustomer?.status) {
        toast?.success(addcustomer?.message);
        const newCustomer = addcustomer?.data;
        setCustomerOptions((prevOptions) => [
          ...prevOptions,
          {
            value: newCustomer._id,
            label: `${newCustomer.name} (${newCustomer.phone || ""})`,
          },
        ]);
        setCustomer(newCustomer._id);
        setCustomerName("");
        setCustomerPhone("");
      } else {
        toast?.error(addcustomer?.message || "Failed to add customer");
      }
    } catch (error) {
      console.error("addCustomer - Error:", error);
      toast?.error("Failed to add customer");
    }
  };

  const handleSearch = async (query, page) => {
    latestQueryRef.current = query;
    setPosLoader(true);
    setSearch(query);
    const normalizedQuery = normalizeQuery(query);
    const select = {
      api: "get-all-inventories",
      search: normalizedQuery,
      status: 1,
      sort: 7,
      page: page?.currentPage || 1,
    };
    try {
      const search = await select_search(select);
      console.log("handleSearch - API response:", search);
      if (latestQueryRef.current !== query) {
        console.log("handleSearch - Stale query, ignoring");
        return;
      }
      if (search?.status && Array.isArray(search?.data?.data)) {
        let fetchedOptions = search.data.data;
        if (query && fetchedOptions.length > 0) {
          const fuse = new Fuse(fetchedOptions, {
            keys: ["product.searchKey", "product.name"],
            threshold: 0.8,
            includeScore: true,
            minMatchCharLength: 1,
          });
          fetchedOptions = fuse.search(normalizedQuery).map((result) => result.item);
          console.log("handleSearch - Filtered options:", fetchedOptions);
        }
        setPagination({
          currentPage: search?.data?.currentPage || 1,
          totalCount: search?.data?.totalCount || 0,
          totalPages: search?.data?.totalPages || 0,
        });
        setOptions(fetchedOptions);
        setInventoryOptions(
          fetchedOptions.map((item) => ({
            value: item._id,
            label: item.product?.name || "Unnamed Product",
          }))
        );
        setPosLoader(false);
      } else {
        console.log("handleSearch - Error:", search?.message || "No data");
        setPosLoader(false);
        setOptions([]);
        setInventoryOptions([]);
        toast?.error(search?.message || "Product not found");
      }
    } catch (error) {
      console.error("handleSearch - Error:", error);
      setPosLoader(false);
      setOptions([]);
      setInventoryOptions([]);
      toast?.error("Failed to fetch products");
    }
  };


  const handleSelectSearch = useCallback(
    debounce((query) => {
      console.log("handleSelectSearch - Query:", query);
      handleSearch(query || "");
    }, 300),
    [handleSearch]
  );

  const handleDescriptionProductBarcode = async (e, page) => {
    if (e) {
      const normalizedQuery = normalizeQuery(e);
      setPosLoader(true);
      setSearch(normalizedQuery);
      const select = {
        api: "get-all-inventories",
        search: normalizedQuery,
        status: 1,
        sort: 6,
        page: page?.currentPage || 1,
      };
      try {
        const search = await select_search(select);
        console.log("handleDescriptionProductBarcode - API response:", search);
        if (search?.status && Array.isArray(search?.data?.data)) {
          let fetchedOptions = search.data.data;
          if (fetchedOptions.length > 0) {
            await handleDescription(fetchedOptions[0], details.length);
            setSearch("");
            handleSearch("");
          }
          setPagination({
            currentPage: search?.data?.currentPage || 1,
            totalCount: search?.data?.totalCount || 0,
            totalPages: search?.data?.totalPages || 0,
          });
          setOptions(fetchedOptions);
          setInventoryOptions(
            fetchedOptions.map((item) => ({
              value: item._id,
              label: item.product?.name || "Unnamed Product",
            }))
          );
          setPosLoader(false);
        } else {
          setPosLoader(false);
          toast?.error(search?.message || "Product not found for barcode: " + normalizedQuery);
        }
      } catch (error) {
        console.error("handleDescriptionProductBarcode - Error:", error);
        setPosLoader(false);
        toast?.error("Failed to fetch product by barcode");
      }
    }
  };

  const handleDescriptionInventoryBarcode = async (e) => {
    if (e) {
      const normalizedQuery = normalizeQuery(e);
      let params = { barcode: normalizedQuery };
      try {
        const inventory = await get_inventory_barcode(params);
        console.log("handleDescriptionInventoryBarcode - Response:", inventory);
        if (inventory?.status) {
          if (
            inventory?.data?.expiry_date &&
            new Date(new Date(inventory?.data?.expiry_date).getTime()) < new Date()
          ) {
            toast?.error(
              `Inventory expired on ${formatDateDDMMYYYY(inventory?.data?.expiry_date)}`
            );
          } else {
            if (inventory?.data?.inventories_units_details?.length > 0) {
              setOpen(true);
              let modaldata = [
                { ...inventory?.data, name: inventory?.data?.product?.unit?.name },
              ];
              inventory?.data?.inventories_units_details?.map((v) =>
                modaldata?.push(v)
              );
              setModalData(modaldata);
              setSelectedModalData({ ...inventory.data, index: details?.length });
              setSearch("");
              handleSearch("");
            } else {
              await handleDescription(inventory.data, details?.length);
              setSearch("");
              handleSearch("");
            }
          }
        } else {
          toast?.error("Inventory not found");
        }
      } catch (error) {
        console.error("handleDescriptionInventoryBarcode - Error:", error);
        toast?.error("Failed to fetch inventory by barcode");
      }
    }
  };

  const handleNext = () => {
    let currentPage = parseInt(pagination?.currentPage) + 1;
    if (currentPage <= parseInt(pagination?.totalPages)) {
      let data = { ...pagination, currentPage: currentPage };
      handleSearch(search, data);
    }
  };

  const handlePrevious = () => {
    let currentPage = parseInt(pagination?.currentPage) - 1;
    if (currentPage > 0) {
      let data = { ...pagination, currentPage: currentPage };
      handleSearch(search, data);
    }
  };

  const handleModal = (modaldata) => {
    let data = [...details];
    let inventory = selectedModalData;
    let index = selectedModalData?.index;

    let inventory_description = null;
    let inventory_name = "";
    let inventory_batch = "";
    let inventory_expiry_date = "";
    let inventory_price_per_unit = "";
    let inventory_unit = "";
    let inventory_unit_name = "";
    let inventory_sale_price = 0;
    let inventory_stock = 0;
    let inventory_tax = 0;
    let inventory_conversion = 0;
    let inventories_units_details = [];

    let description_ids = data?.map((v) => v?.unit);

    if (!description_ids?.includes(modaldata)) {
      if (inventory?._id === modaldata) {
        inventory_description = inventory?._id;
        inventory_name = inventory?.product?.name;
        inventory_batch = inventory?.number;
        inventory_expiry_date = inventory?.expiry_date;
        inventory_price_per_unit = inventory?.price_per_unit;
        inventory_unit = modaldata;
        inventory_unit_name = inventory?.product?.unit?.name;
        inventory_sale_price = inventory?.sale_price;
        inventory_stock = inventory?.stock;
        inventory_tax = inventory?.tax;
        if (inventory?.inventories_units_details?.length > 0) {
          inventory?.inventories_units_details?.map((value) =>
            inventories_units_details?.push({
              ...value,
              name: value?.name,
              purchase_price: value?.purchase_price,
              price_per_unit: value?.price_per_unit,
              sale_price: value?.sale_price,
              stock: value?.stock,
              unit_quantity: 0,
              unit_delivered: 0,
            })
          );
        }
      } else {
        let selected_unit = "";
        let unit_ids = inventory?.inventories_units_details?.map((v) => v?._id);
        if (unit_ids?.includes(modaldata)) {
          selected_unit =
            inventory?.inventories_units_details?.[unit_ids?.indexOf(modaldata)];
        }
        inventory_description = inventory?._id;
        inventory_name = inventory?.product?.name;
        inventory_batch = inventory?.number;
        inventory_expiry_date = inventory?.expiry_date;
        inventory_unit = modaldata;
        inventory_unit_name = selected_unit?.name;
        inventory_sale_price = selected_unit?.sale_price;
        inventory_stock = selected_unit?.stock;
        inventory_tax = inventory?.tax;
        inventory_conversion = selected_unit?.conversion;
      }

      if (inventory_stock >= 1) {
        let price_sale = parseFloat(inventory_sale_price || 0);
        let price_tax =
          parseFloat(price_sale || 0) * (parseFloat(inventory_tax || 0) / 100);
        let price_total =
          parseFloat(price_sale || 0) + parseFloat(price_tax || 0);

        data?.push({
          description: inventory_description,
          name: inventory_name,
          batch: inventory_batch,
          expiry_date: inventory_expiry_date,
          unit: inventory_unit,
          unit_name: inventory_unit_name,
          sale_price: price_sale,
          stock: inventory_stock,
          tax: inventory_tax,
          conversion: inventory_conversion,
          quantity: 1,
          delivered: 1,
          tax_amount: price_tax,
          total: price_total,
          unit_details_options: inventories_units_details,
        });

        let subtotal =
          data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.total),
            0
          ) -
          data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.tax_amount),
            0
          );
        let taxamount = data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.tax_amount),
          0
        );
        let grandtotal = data?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0
        );

        totals.subtotal = subtotal;
        totals.taxamount = taxamount;
        totals.delivery_status = 2;
        totals.delivery_date = new Date();
        totals.payment_status = 2;
        totals.payment_types = ["Cash"];
        totals.payments = {
          Cash: { amount: parseFloat(totals.payments?.Cash?.amount || 0) },
          Cheque: { amount: parseFloat(totals.payments?.Cheque?.amount || 0) },
          "Debit card": { amount: parseFloat(totals.payments?.["Debit card"]?.amount || 0) },
          "Credit card": { amount: parseFloat(totals.payments?.["Credit card"]?.amount || 0) },
          "Bank transfer": { amount: parseFloat(totals.payments?.["Bank transfer"]?.amount || 0) },
          "Online payment": { amount: parseFloat(totals.payments?.["Online payment"]?.amount || 0) },
        };
        totals.total = grandtotal;

        setDetails(data);
        setTotals({ ...totals });
        setModalData(null);
        setSelectedModalData(null);
      } else {
        toast?.error(`Stock only ${inventory_stock}`);
        setModalData(null);
        setSelectedModalData(null);
      }
    } else {
      let selected_index = description_ids?.indexOf(modaldata);

      if (
        parseFloat(data[selected_index].quantity || 0) <
        parseFloat(Math.floor(data[selected_index].stock) || 0)
      ) {
        if (
          data?.[selected_index]?.conversion > 0 &&
          data?.[selected_index]?.quantity >=
          (data?.[selected_index]?.conversion * data[selected_index]?.stock)
        ) {
          toast?.error(
            `Quantity exceeding ${data?.[selected_index]?.conversion}`
          );
        } else {
          let quantity = data[selected_index].quantity
            ? data[selected_index].quantity
            : 0;
          let delivered = data[selected_index].delivered
            ? data[selected_index].delivered
            : 0;

          let total_quantity = parseFloat(quantity) + parseFloat(1);

          data[selected_index].quantity = total_quantity;
          data[selected_index].delivered = total_quantity;

          data[selected_index].tax_amount = data[selected_index].tax
            ? parseFloat(data[selected_index].sale_price || 0) *
            parseFloat(total_quantity || 0) *
            (parseFloat(data[selected_index].tax || 0) / 100)
            : 0;
          data[selected_index].total =
            parseFloat(data[selected_index].sale_price || 0) *
            parseFloat(total_quantity) +
            (data[selected_index].tax
              ? parseFloat(data[selected_index].sale_price || 0) *
              parseFloat(total_quantity || 0) *
              (parseFloat(data[selected_index].tax || 0) / 100)
              : 0);

          let subtotal =
            data?.reduce(
              (acc, currentValue) =>
                parseFloat(acc) + parseFloat(currentValue?.total),
              0
            ) -
            data?.reduce(
              (acc, currentValue) =>
                parseFloat(acc) + parseFloat(currentValue?.tax_amount),
              0
            );
          let taxamount = data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.tax_amount),
            0
          );
          let grandtotal = data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.total),
            0
          );

          totals.subtotal = subtotal;
          totals.taxamount = taxamount;
          totals.total = grandtotal;

          setDetails(data);
          setTotals({ ...totals });
        }
      } else {
        toast?.error(`Stock only ${data[selected_index].stock}`);
      }
    }
  };

  const handleDescription = async (e, index) => {
    let data = [...details];
    if (e?._id) {
      if (
        e?.expiry_date &&
        new Date(new Date(e?.expiry_date).getTime()) < new Date()
      ) {
        toast?.error(
          `Inventory expired on ${formatDateDDMMYYYY(e?.expiry_date)}`
        );
        return;
      }

      if (!e?.sale_price || parseFloat(e?.sale_price) <= 0) {
        toast?.error("Product has invalid sale price");
        return;
      }

      else {
        if (e?.inventories_units_details?.length > 0) {
          setOpen(true);
          let modaldata = [
            { ...e, name: e?.product?.unit?.name },
          ];
          e?.inventories_units_details?.map((v) => modaldata?.push(v));
          setModalData(modaldata);
          setSelectedModalData({ ...e, index: index });
          setSearch("");
          handleSearch("");
        } else {
          if (e?.stock >= 1) {
            let description_ids = data?.map((v) => v?.description);
            if (!description_ids?.includes(e?._id)) {
              let inventory_description = e?._id;
              let inventory_name = e?.product?.name;
              let inventory_batch = e?.number;
              let inventory_expiry_date = e?.expiry_date;
              let inventory_unit = e?._id;
              let inventory_unit_name = e?.product?.unit?.name;
              let inventory_sale_price = e?.sale_price;
              let inventory_stock = e?.stock;
              let inventory_tax = e?.tax;
              let inventories_units_details = [];

              if (e?.inventories_units_details?.length > 0) {
                e?.inventories_units_details?.map((value) =>
                  inventories_units_details?.push({
                    ...value,
                    name: value?.name,
                    price_per_unit: 0,
                    sale_price: "",
                    unit_quantity: 0,
                    unit_delivered: 0,
                  })
                );
              }

              let price_sale = parseFloat(inventory_sale_price || 0);
              let price_tax =
                parseFloat(price_sale || 0) *
                (parseFloat(inventory_tax || 0) / 100);
              let price_total =
                parseFloat(price_sale || 0) + parseFloat(price_tax || 0);

              data?.push({
                description: inventory_description,
                name: inventory_name,
                batch: inventory_batch,
                expiry_date: inventory_expiry_date,
                unit: inventory_unit,
                unit_name: inventory_unit_name,
                sale_price: price_sale,
                stock: inventory_stock,
                tax: inventory_tax,
                quantity: 1,
                delivered: 1,
                tax_amount: price_tax,
                total: price_total,
                unit_details_options: inventories_units_details,
              });

              let subtotal =
                data?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.total),
                  0
                ) -
                data?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.tax_amount),
                  0
                );
              let taxamount = data?.reduce(
                (acc, currentValue) =>
                  parseFloat(acc) + parseFloat(currentValue?.tax_amount),
                0
              );
              let grandtotal = data?.reduce(
                (acc, currentValue) =>
                  parseFloat(acc) + parseFloat(currentValue?.total),
                0
              );

              totals.subtotal = subtotal;
              totals.taxamount = taxamount;
              totals.total = grandtotal;

              setDetails(data);
              setTotals({ ...totals });
              setSearch("");
              handleSearch("");

            } else {
              let selected_index = description_ids?.indexOf(e?._id);
              if (
                parseFloat(data[selected_index].quantity || 0) <
                parseFloat(data[selected_index].stock || 0)
              ) {
                let quantity = data[selected_index].quantity
                  ? data[selected_index].quantity
                  : 0;
                let delivered = data[selected_index].delivered
                  ? data[selected_index].delivered
                  : 0;
                let total_quantity = parseFloat(quantity) + parseFloat(1);

                data[selected_index].quantity = total_quantity;
                data[selected_index].delivered = total_quantity;
                data[selected_index].tax_amount = data[selected_index].tax
                  ? parseFloat(data[selected_index].sale_price || 0) *
                  parseFloat(total_quantity || 0) *
                  (parseFloat(data[selected_index].tax || 0) / 100)
                  : 0;
                data[selected_index].total =
                  parseFloat(data[selected_index].sale_price || 0) *
                  parseFloat(total_quantity) +
                  (data[selected_index].tax
                    ? parseFloat(data[selected_index].sale_price || 0) *
                    parseFloat(total_quantity || 0) *
                    (parseFloat(data[selected_index].tax || 0) / 100)
                    : 0);

                let subtotal =
                  data?.reduce(
                    (acc, currentValue) =>
                      parseFloat(acc) + parseFloat(currentValue?.total),
                    0
                  ) -
                  data?.reduce(
                    (acc, currentValue) =>
                      parseFloat(acc) + parseFloat(currentValue?.tax_amount),
                    0
                  );
                let taxamount = data?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.tax_amount),
                  0
                );
                let grandtotal = data?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.total),
                  0
                );

                totals.subtotal = subtotal;
                totals.taxamount = taxamount;
                totals.total = grandtotal;

                setDetails(data);
                setTotals({ ...totals });
                setSearch("");
                handleSearch("");
              } else {
                toast?.error(`Stock only ${data[selected_index].stock}`);
              }
            }
          } else {
            toast?.error(`Stock only ${e?.stock}`);
          }
        }
      }
    } else {
      data[index].id = "";
      data[index].description = null;
      data[index].name = "";
      data[index].batch = "";
      data[index].expiry_date = "";
      data[index].unit = "";
      data[index].unit_name = "";
      data[index].unit_details_options = null;
      data[index].quantity = "";
      data[index].conversion = 0;
      data[index].purchase = "";
      data[index].sale_price = "";
      data[index].purchase_options = null;
      data[index].delivered = "";
      data[index].tax = 0;
      data[index].free = "";
      data[index].barcode = "";
      data[index].price_per_unit = "";
      data[index].sale_price = "";
      data[index].expiry_date = "";
      data[index].tax_amount = "0.000";
      data[index].total = 0;
      setDetails(data);
    }
  };

  const handlePurchase = (e, index, key) => {
    if (e) {
      let event = {
        target: {
          name: "sale_price",
          value: JSON?.parse(e)?.sale_price,
        },
      };
      handleTotal(event, index, "sale_price");
      handleTotal(JSON?.parse(e)?.tax, index, "tax");
    }
  };

  const handleDelivered = (e, index) => {
    if (e?.target?.value >= 0) {
      let data = [...details];
      let data_quantity = data[index]?.quantity
        ? parseFloat(data[index]?.quantity)
        : 0;
      let data_delivered = e?.target?.value ? parseFloat(e?.target?.value) : 0;

      if (data_delivered <= data_quantity) {
        data[index][e?.target?.name] = e?.target?.value;
        setDetails(data);
      } else {
        toast?.error(`Quantity only ${data_quantity}`);
      }
    }
  };

  const handleTotal = (e, index, key) => {
    let name = key ? key : e?.target?.name;
    let value = key && e ? e : e?.target?.value ? e?.target?.value : "";

    if (value >= 0) {
      let data = [...details];

      if (value <= data[index]?.stock) {
        let data_sale_price = data[index]?.sale_price
          ? data[index]?.sale_price
          : 0;
        let data_quantity = data[index]?.quantity ? data[index]?.quantity : 0;
        let data_delivered = data[index]?.delivered ? data[index]?.delivered : 0;
        let data_free = data[index]?.free ? data[index]?.free : 0;
        let data_tax = data[index]?.tax ? data[index]?.tax : 0;
        let data_conversion = data[index].conversion
          ? data[index].conversion
          : 0;

        let sale_price = name === "sale_price" ? value : data_sale_price;
        let quantity = name === "quantity" ? value : data_quantity;
        let delivered = name === "quantity" ? value : data_delivered;
        let free = name === "free" ? value : data_free;
        let tax = name === "tax" ? value : data_tax;

        let tax_amount = tax
          ? parseFloat(sale_price) *
          parseFloat(quantity ? quantity : 0) *
          (parseFloat(tax) / 100)
          : 0;

        let total =
          parseFloat(sale_price) * parseFloat(quantity ? quantity : 0) +
          parseFloat(tax_amount);

        let price_per_unit =
          parseFloat(total ? total : 0) /
          (parseFloat(quantity ? quantity : 0) + parseFloat(free ? free : 0));

        let unit_details_options = [];
        if (data?.[index]?.unit_details_options?.length > 0) {
          data?.[index]?.unit_details_options?.map((v) => {
            let total_quantity =
              parseFloat(quantity || 0) + parseFloat(free || 0);

            unit_details_options?.push({
              ...v,
              price_per_unit: price_per_unit
                ? parseFloat(price_per_unit || 0) / parseFloat(v?.conversion || 0)
                : 0,
              unit_quantity: quantity
                ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
                : 0,
              unit_delivered: delivered
                ? parseFloat(v?.conversion || 0) * parseFloat(total_quantity || 0)
                : 0,
            });
          });
        }

        if (
          data_conversion > 0 &&
          parseFloat(quantity) + parseFloat(free) >= ((data_conversion) * data[index]?.stock)
        ) {
          toast?.error(`Quantity exceeding ${data[index].conversion}`);
        } else {
          data[index][name] = value;
          data[index].unit_details_options = unit_details_options;
          data[index].delivered = delivered ? delivered : "";
          data[index].tax = tax ? tax : 0;
          data[index].total = total ? total : 0;
          data[index].tax_amount = tax_amount ? tax_amount : "0.000";
          data[index].price_per_unit = price_per_unit ? price_per_unit : 0;

          let subtotal =
            data?.reduce(
              (acc, currentValue) =>
                parseFloat(acc) + parseFloat(currentValue?.total),
              0
            ) -
            data?.reduce(
              (acc, currentValue) =>
                parseFloat(acc) + parseFloat(currentValue?.tax_amount),
              0
            );

          let taxamount = data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.tax_amount),
            0
          );

          let grandtotal = data?.reduce(
            (acc, currentValue) =>
              parseFloat(acc) + parseFloat(currentValue?.total),
            0
          );

          totals.subtotal = subtotal;
          totals.taxamount = taxamount;
          totals.total = grandtotal;

          setDetails(data);
          setTotals({ ...totals });
        }
      } else {
        toast?.error(`Stock only ${data[index]?.stock}`);
      }
    }
  };

  const handleRemove = (index) => {
    let data = [...details];
    data?.splice(index, 1);

    let subtotal =
      data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.total),
        0
      ) -
      data?.reduce(
        (acc, currentValue) =>
          parseFloat(acc) + parseFloat(currentValue?.tax_amount),
        0
      );

    let taxamount = data?.reduce(
      (acc, currentValue) =>
        parseFloat(acc) + parseFloat(currentValue?.tax_amount),
      0
    );

    let grandtotal = data?.reduce(
      (acc, currentValue) =>
        parseFloat(acc) + parseFloat(currentValue?.total),
      0
    );

    totals.subtotal = subtotal;
    totals.taxamount = taxamount;
    totals.total = grandtotal;

    setDetails(data);
    setTotals({ ...totals });
  };

  const handleAdd = (e) => {
    if (e) {
      setDetails((prevDetails) => [
        ...prevDetails,
        {
          id: "",
          description: null,
          unit: "",
          sale_price: "",
          quantity: "",
          delivered: "",
          free: "",
          tax: 0,
          total: 0,
        },
      ]);
      handleDescription(e, details?.length + 1);
    }
  };

  const handleDelivery = (e) => {
    if (e?.target?.value >= 0) {
      let total_amount = parseFloat(
        details?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0
        )
      );

      let total =
        parseFloat(total_amount ? total_amount : 0) +
        parseFloat(e?.target?.value ? e?.target?.value : 0) -
        parseFloat(totals?.discount ? totals?.discount : 0);

      totals.delivery = e?.target?.value;
      totals.total = total;

      setTotals({ ...totals });
    }
  };

  const handleDiscount = (e) => {
    if (e?.target?.value >= 0) {
      let total_amount = parseFloat(
        details?.reduce(
          (acc, currentValue) =>
            parseFloat(acc) + parseFloat(currentValue?.total),
          0
        )
      );

      let total =
        parseFloat(total_amount ? total_amount : 0) +
        parseFloat(totals?.delivery ? totals?.delivery : 0) -
        parseFloat(e?.target?.value ? e?.target?.value : 0);

      if (e?.target?.value <= total_amount) {
        totals.discount = e?.target?.value;
        totals.total = total;
      } else {
        toast?.error(`Discount exceeding`);
      }

      setTotals({ ...totals });
    }
  };

  const handleDeliveryStatus = (e) => {
    totals.delivery_status = e;
    if (!e || e === 1) {
      totals.delivery_date = "";
    }
    setTotals({ ...totals });
  };

  const handleDeliveryDate = (e) => {
    totals.delivery_date = e?.$d;
    setTotals({ ...totals });
  };

  const handlePaymentStatus = (e) => {
    totals.payment_status = e;
    if (!e) {
      totals.payment_types = null;
    }
    setTotals({ ...totals });
  };


  const handlePaymentTypes = (e) => {
    const updatedPayments = { ...totals.payments };

    totals?.payment_types?.map((v) => {
      if (!e?.includes(v)) {
        updatedPayments[v] = { amount: 0 };
      }
    });

    e?.map((v) => {
      if (!updatedPayments[v]) {
        updatedPayments[v] = { amount: 0 };
      }
    });

    totals.payment_types = e;
    totals.payments = updatedPayments;

    setTotals({ ...totals });
  };


  const handlePayments = (e) => {
    let name = e?.target?.name;
    let value = e?.target?.value ? parseFloat(e?.target?.value) : 0;

    if (value >= 0) {
      const updatedPayments = { ...totals.payments };

      updatedPayments[name] = { amount: value };

      const paymentTypes = totals?.payment_types || [];
      const totalPayments = paymentTypes.reduce((sum, type) => {
        return sum + parseFloat(updatedPayments[type]?.amount || 0);
      }, 0);

      let grand_total = totals?.total ? parseFloat(totals?.total) : 0;

      if (totalPayments <= grand_total) {
        setTotals({
          ...totals,
          payments: updatedPayments
        });
      } else {
        toast?.error(`Total payments cannot exceed ${grand_total.toFixed(3)}`);
      }
    } else {
      toast?.error("Payment amount cannot be negative");
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!details || details.length === 0) {
      toast?.error("No items added to the invoice");
      return;
    }
    if (!totals?.total || totals.total <= 0) {
      toast?.error("Invalid total amount");
      return;
    }
    const data = {
      status: true,
      details: details,
      totals: {
        ...totals,
        payments: {
          ...totals.payments,
          Cash: { amount: parseFloat(totals.payments.Cash?.amount || 0) },
          Cheque: { amount: parseFloat(totals.payments.Cheque?.amount || 0) },
          "Debit card": { amount: parseFloat(totals.payments["Debit card"]?.amount || 0) },
          "Credit card": { amount: parseFloat(totals.payments["Credit card"]?.amount || 0) },
          "Bank transfer": { amount: parseFloat(totals.payments["Bank transfer"]?.amount || 0) },
          "Online payment": { amount: parseFloat(totals.payments["Online payment"]?.amount || 0) },
        },
      },
      customer: customer || null,
    };
    setSearch("");
    formdata(data);
  };

  const fetchData = () => {
    handleSearch("");
  };

  const handleOnKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  useEffect(() => {
    console.log("Initial fetch triggered");
    fetchData();
  }, []);

  useEffect(() => {
    console.log("posloader state:", posloader);
    console.log("Options state:", options);
    console.log("InventoryOptions state:", inventoryOptions);
  }, [posloader, options, inventoryOptions]);

  const formRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "F4") {
        e.preventDefault();
        submitType.current = "print";
        if (formRef.current) {
          formRef.current.requestSubmit();
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className="flex-1 min-h-0" >
      <div className="w-full rounded-md overflow-hidden flex flex-col mt-4 h-full">
        <div className="flex-1 overflow-auto hide-scrollbar pb-10 mb-20">
          <Modalcomponent
            open={open}
            setOpen={setOpen}
            modalData={modalData}
            setModalData={setModalData}
            selectedModalData={selectedModalData}
            setSelectedModalData={setSelectedModalData}
            handleModal={handleModal}
          />
          <form ref={formRef} onSubmit={handleSubmit}>
            <div className="p-4">
              <div className="flex justify-between">
                <div className="w-[49%] rounded-md">
                  <div className="p-4 flex justify-between bg-white rounded-tl-md rounded-tr-md">
                    <div className="w-2/3 pr-8">
                      <div className="flex">
                        <div className="pr-3">
                          <BarcodeButton
                            name="product"
                            tabIndex={0}
                            onKeyDown={handleKeyDownProduct}
                            isFocusedProduct={isFocusedProduct}
                            setIsFocusedProduct={setIsFocusedProduct}
                          />
                        </div>
                        <div className="w-full">
                          <Input
                            className="w-full text-regular"
                            name="search"
                            placeholder="Search Products or Scan Barcode"
                            value={search}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDownSearch}
                            autoComplete="off"
                            prefix={posloader ? <LoadingOutlined /> : <SearchOutlined />}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <BarcodeButton
                        name="inventory"
                        onKeyDown={handleKeyDownInventory}
                        isFocusedInventory={isFocusedInventory}
                        setIsFocusedInventory={setIsFocusedInventory}
                      />
                    </div>
                  </div>
                  <div className="bg-white h-[60vh]" style={{ overflowX: "auto" }}>
                    <Loadercomponent loader={posloader}>
                      <div className="mx-2">
                        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 grid-cols-5 gap-3">
                          {options?.map((value, index) => (
                            <button
                              type="button"
                              key={index}
                              className="border cursor-pointer p-3 hover:bg-gray-100 rounded-lg flex flex-col min-h-[8vw]"
                              onClick={() => handleDescription(value)}
                            >
                              <div className="text-center pt-2 flex-grow">
                                <div className="text-[0.70rem] text-medium break-words leading-tight">
                                  {value?.product?.name}
                                </div>
                                <div className="text-[0.50rem] text-gray-500">
                                  #BATCH-{value?.number}
                                  <div className="text-xs text-green-500 font-medium">
                                    Stock&nbsp;(
                                    {value?.stock
                                      ? Number.isInteger(value?.stock)
                                        ? parseFloat(value?.stock || 0)
                                        : parseFloat(value?.stock || 0)?.toFixed(3)
                                      : "0"}
                                    )
                                  </div>
                                </div>
                                <div className="text-[0.50rem] text-gray-500">
                                  EXP :&nbsp;
                                  {value?.expiry_date
                                    ? formatDateDDMMYYYY(value?.expiry_date)
                                    : "N/A"}
                                </div>
                              </div>
                              <div className="text-center text-[0.50rem] text-gray-500">
                                <div>{value?.tax ? `VAT ${value?.tax}%` : ""}</div>
                              </div>
                              <div className="border text-medium text-xs rounded-md text-center text-green-500 font-medium mt-auto">
                                OMR {parseFloat(value?.sale_price)?.toFixed(3)}
                              </div>
                            </button>
                          ))}
                        </div>
                      </div>
                    </Loadercomponent>
                  </div>
                  <div className="p-4 flex justify-between text-gray-600 text-sm text-medium">
                    <div>
                      <span className="pr-3">TOTAL</span>
                      <span className="pl-5">
                        {(() => {
                          const itemsPerPage = 10;
                          const startItem = ((pagination?.currentPage || 1) - 1) * itemsPerPage + 1;
                          const endItem = Math.min(
                            (pagination?.currentPage || 1) * itemsPerPage,
                            pagination?.totalCount || 0
                          );

                          return `${startItem} - ${endItem} OF ${pagination?.totalCount || 0}`;
                        })()}
                      </span>
                    </div>
                    <div className="flex">
                      <span>
                        <div
                          type="button"
                          className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#6254be]"
                          onClick={handlePrevious}
                        >
                          <div className="text-center text-xs text-gray-900">
                            <LeftOutlined />
                          </div>
                        </div>
                      </span>
                      <span className="px-3 pt-1">
                        {pagination?.currentPage || 1} OF {pagination?.totalPages || 1}
                      </span>
                      <span>
                        <div
                          type="button"
                          className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#6254be]"
                          onClick={handleNext}
                        >
                          <div className="text-center text-xs text-gray-600">
                            <RightOutlined />
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div className="p-10 flex justify-between bg-white rounded-bl-md rounded-br-md" />
                </div>
                <div className="bg-white w-[49%] rounded-md">
                  <div className="p-4 flex justify-center">
                    <div className="p-1 text-semi-bold">CHECKOUT</div>
                  </div>
                  <div className="h-[35vh]" style={{ overflowY: "auto" }}>
                    <table className="w-full">
                      <thead className="bg-gray-100 text-gray-500 text-xs text-medium">
                        <tr>
                          <td className="p-1 border-r">SNO</td>
                          <td className="p-1 border-r">NAME</td>
                          <td className="p-1 border-r">UNIT</td>
                          <td className="p-1 border-r">QUANTITY</td>
                          <td className="p-1 border-r">PRICE</td>
                          <td className="p-1 border-r">TAX</td>
                          <td className="p-1 border-r">TOTAL</td>
                          <td className="p-1 text-center">DELETE</td>
                        </tr>
                      </thead>
                      <tbody>
                        {details?.map((value, index) => (
                          <tr className="border-b text-xs" key={index}>
                            <td className="p-1 border-r">{index + 1}</td>
                            <td className="p-1 border-r">
                              <div className="text-[0.70rem] text-medium">
                                {value?.name}
                              </div>
                              <div className="text-[0.50rem] text-gray-500">
                                <div>{`#BATCH-${value?.batch}`}</div>
                                <div className="text-[0.50rem]">
                                  {value?.expiry_date
                                    ? `EXPIRY : ${formatDateDDMMYYYY(value?.expiry_date)}`
                                    : ""}
                                </div>
                              </div>
                            </td>
                            <td className="p-1 border-r text-[0.65rem] text-medium">
                              {value?.unit_name}
                            </td>
                            <td className="p-1 border-r">
                              <div className="text-green-500 text-[0.60rem] text-medium">
                                Stock&nbsp;(
                                {value?.stock
                                  ? Number.isInteger(value?.stock)
                                    ? parseFloat(value?.stock || 0)
                                    : parseFloat(value?.stock || 0)?.toFixed(3)
                                  : "0"}
                                )
                              </div>
                              <Input
                                type="number"
                                className="text-xs"
                                name="quantity"
                                placeholder="Quantity"
                                value={value?.quantity}
                                onChange={(e) => handleTotal(e, index)}
                                autoComplete="off"
                                required
                                onKeyDown={(e) => {
                                  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                    e.preventDefault();
                                  }

                                  handleOnKeyDown(e);
                                }}

                                onWheel={(e) => {
                                  e.target.blur();
                                }}
                              />
                            </td>
                            <td className="p-1 text-center text-[0.60rem] text-medium border-r">
                              {value?.sale_price
                                ? value?.sale_price?.toFixed?.(3)
                                : "0.000"}
                            </td>
                            <td className="p-1 text-center text-[0.60rem] text-medium border-r">
                              <div>{value?.tax}%</div>
                              <div>
                                {value?.tax_amount
                                  ? value?.tax_amount?.toFixed?.(3)
                                  : ""}
                              </div>
                            </td>
                            <td className="p-1 text-center text-[0.60rem] text-medium border-r">
                              {value?.total ? value?.total?.toFixed?.(3) : "0.000"}
                            </td>
                            <td className="p-1 text-center text-[0.60rem] text-medium border-r">
                              <button
                                type="button"
                                className="cursor-pointer text-xl text-red-500 hover:text-red-900"
                                onClick={() => handleRemove(index)}
                              >
                                <DeleteOutlined />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="bg-gray-100 text-medium text-gray-500">
                    <div className="px-4 py-1 flex justify-between text-xs">
                      <div>Subtotal</div>
                      <div>
                        {totals?.subtotal > 0
                          ? totals?.subtotal?.toFixed(3)
                          : "0.000"}
                      </div>
                    </div>
                    <div className="px-4 py-1 flex justify-between text-xs">
                      <div>Tax amount</div>
                      <div>
                        {totals?.taxamount > 0
                          ? totals?.taxamount?.toFixed(3)
                          : "0.000"}
                      </div>
                    </div>
                    <div className="px-4 py-1 flex justify-between text-xs">
                      <div>Discount</div>
                      <div>
                        <Input
                          size="small"
                          type="number"
                          className="w-full text-regular"
                          placeholder="Discount amount"
                          name="discount"
                          value={totals?.discount}
                          autoComplete="off"
                          onChange={handleDiscount}
                          onKeyDown={(e) => {
                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                              e.preventDefault();
                            }
                          }}
                          onWheel={(e) => {
                            e.target.blur();
                          }}
                        />
                      </div>
                    </div>
                    {/* <div className="px-4 py-1 flex justify-between text-xs">
                  <div>Delivery Amount</div>
                  <div>
                    <Input
                      size="small"
                      type="number"
                      className="w-full text-regular"
                      placeholder="Delivery amount"
                      name="delivery"
                      value={totals?.delivery}
                      autoComplete="off"
                      onChange={handleDelivery}
                    />
                  </div>
                </div>
                <div className="px-4 py-1 flex justify-between text-xs">
                  <div>Delivery Date</div>
                  <div>
                    <DatePicker
                      size="small"
                      className="w-full"
                      value={totals?.delivery_date ? dayjs(totals?.delivery_date) : null}
                      onChange={handleDeliveryDate}
                    />
                  </div>
                </div> */}
                  </div>
                  <div className="bg-white text-semi-bold">
                    <div className="px-4 py-1 flex justify-between text-xs">
                      <div>Total</div>
                      <div>
                        {totals?.total > 0 ? totals?.total?.toFixed(3) : "0.000"}
                      </div>
                    </div>
                  </div>
                  <div className="p-4 bg-gray-200">
                    <div>
                      <Select
                        size="small"
                        className="w-full text-regular"
                        name="customer"
                        showSearch
                        allowClear
                        placeholder="Select customer"
                        filterOption={false}
                        onSearch={handleCustomerSearch}
                        onClick={() => handleCustomerSearch("")}
                        onFocus={() => handleCustomerSearch("")}
                        onChange={(e) => setCustomer(e)}
                        value={customer}
                        options={customerOptions}
                      />
                    </div>
                    <div className="flex w-full pt-2">
                      <div className="w-full">
                        <Input
                          size="small"
                          className="w-full text-regular"
                          name="name"
                          value={customerName}
                          placeholder="New customer name"
                          onChange={handleCustomer}
                          autoComplete="off"
                        />
                      </div>
                      <div className="w-full pl-2">
                        <Input
                          size="small"
                          className="w-full text-regular"
                          name="phone"
                          value={customerPhone}
                          placeholder="New customer phone"
                          onChange={handleCustomer}
                          autoComplete="off"
                        />
                      </div>
                      <div>
                        <Button
                          size="small"
                          type="button"
                          className="w-full text-medium text-white bg-[#07b553] hover:bg-[#14532d] mx-1"
                          onClick={addCustomer}
                        >
                          ADD
                        </Button>
                      </div>
                    </div>
                    <div className="pt-2">
                      {totals?.payment_status == 1 || totals?.payment_status == 2 ? (
                        <div>
                          <Select
                            mode="multiple"
                            className="w-full"
                            name="payment_types"
                            placeholder="Payment mode"
                            value={totals?.payment_types}
                            options={[
                              { value: "Cash", label: "Cash" },
                              { value: "Debit card", label: "Debit card" },
                              { value: "Bank transfer", label: "Bank transfer" },
                              { value: "Online payment", label: "Online payment" },
                              { value: "Credit card", label: "Credit card" },
                              { value: "Cheque", label: "Cheque" },
                            ]}
                            onChange={handlePaymentTypes}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {totals?.payment_types?.map((value, index) => (
                        <div className="pt-4" key={index}>
                          <Input
                            type="number"
                            className="w-full"
                            placeholder={value}
                            name={value}
                            value={totals?.payments?.[value]?.amount}
                            onChange={handlePayments}
                            autoComplete="off"
                            onKeyDown={(e) => {
                              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                e.preventDefault();
                              }
                            }}
                            onWheel={(e) => {
                              e.target.blur();
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="p-4 flex">
                    <div className="pl-2 w-full">
                      <Button
                        htmlType="submit"
                        type="primary"
                        size="large"
                        className="w-full text-medium bg-[#07b553] hover:bg-[#14532d]"
                        disabled={buttonLoader}
                      >
                        {buttonLoader ? (
                          <Spin
                            indicator={<LoadingOutlined spin />}
                            size="small"
                            className="w-full text-medium bg-[#07b553]"
                          />
                        ) : (
                          <>
                            Save {" (OMR "}
                            {totals?.total > 0
                              ? totals?.total?.toFixed(3)
                              : "0.000"}
                            {") "}
                          </>
                        )}
                      </Button>
                    </div>
                  </div>
                  <div className="pt-4 mt-2 border-t-2 border-gray border-dashed">
                    <div className="flex w-full bg-gray-200 p-4">
                      <div className="w-full">
                        <Input
                          size=""
                          className="w-full text-regular"
                          name="customer_pay"
                          value={customerPay}
                          placeholder="Customer cash pay"
                          onChange={handleCustomerPay}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="flex justify-between w-full p-4">
                      <div className="text-medium text-gray-500">
                        RETURN BALANCE (CASH)&nbsp;&nbsp;
                      </div>
                      <div className="text-medium text-gray-500">
                        OMR&nbsp;
                        {(parseFloat(customerPay || 0) - parseFloat(totals?.total || 0))?.toFixed(3)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
});

export default BillingPos;